webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(444);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__common__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__common__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__common__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__common__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__common__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__common__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__common__["g"]; });




/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(720)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(831),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js__ = __webpack_require__(11);


var pre = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__js__["d" /* isDev */])() ? '/test' : '';
/* harmony default export */ __webpack_exports__["a"] = (pre + '/candidate/ats');

/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(741)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(849),
  /* scopeId */
  "data-v-645350ea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(730)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(840),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(738)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(846),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(757)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(863),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(710)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(822),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(724)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(835),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo3.6485adf.png";

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/user_img.f3429a8.jpg";

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(723)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(834),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(711)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(824),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(753)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(859),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(756)
__webpack_require__(755)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(862),
  /* scopeId */
  "data-v-7db27245",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__basePath__ = __webpack_require__(71);








__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_3_axios___default.a);

__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.request.use(function (config) {
	if (config.url.indexOf(__WEBPACK_IMPORTED_MODULE_6__basePath__["a" /* default */]) < 0) {
		config.url = '' + __WEBPACK_IMPORTED_MODULE_6__basePath__["a" /* default */] + config.url;
	}

	if (config.method === 'post' && config.data && config.data.constructor !== URLSearchParams) {
		config.data = __WEBPACK_IMPORTED_MODULE_5_qs___default.a.stringify(config.data);
	}
	return config;
}, function (error) {
	return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.http.interceptors.push(function (request, next) {
	if (request.url.indexOf(__WEBPACK_IMPORTED_MODULE_6__basePath__["a" /* default */]) < 0) {
		request.url = '' + __WEBPACK_IMPORTED_MODULE_6__basePath__["a" /* default */] + request.url;
	}

	next();
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_StepStatus_vue__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_StepStatus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_StepStatus_vue__);


var components = [__WEBPACK_IMPORTED_MODULE_0__components_StepStatus_vue___default.a];

var install = function install(Vue) {
  components.map(function (component) {
    return Vue.component(component.name, component);
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  install: install
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main_fillform_fillform__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main_fillform_fillform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__main_fillform_fillform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main_interview_book__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main_interview_book___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__main_interview_book__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main_interview_interview__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main_interview_interview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__main_interview_interview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main_interview_result__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main_interview_result___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__main_interview_result__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__main_interview_pass__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__main_interview_pass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__main_interview_pass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__main_pso_pso__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__main_pso_pso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__main_pso_pso__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__main_tpg_book__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__main_tpg_book___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__main_tpg_book__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__main_tpg_tpg__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__main_tpg_tpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__main_tpg_tpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__main_tpg_result__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__main_tpg_result___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__main_tpg_result__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__main_demo_book__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__main_demo_book___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__main_demo_book__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__main_demo_demo__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__main_demo_demo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__main_demo_demo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__main_demo_result__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__main_demo_result___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__main_demo_result__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__main_onboarding_personal_profile__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__main_onboarding_personal_profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__main_onboarding_personal_profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__main_onboarding_personal_in__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__main_onboarding_personal_in___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__main_onboarding_personal_in__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__main_onboarding_personal_qa__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__main_onboarding_personal_qa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__main_onboarding_personal_qa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__main_onboarding_payment__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__main_onboarding_payment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__main_onboarding_payment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__main_onboarding_on_board__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__main_onboarding_on_board___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__main_onboarding_on_board__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__main_onboarding_sign_sa__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__main_onboarding_sign_sa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__main_onboarding_sign_sa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__main_onboarding_info_pre__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__main_onboarding_info_pre___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__main_onboarding_info_pre__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__main_forgot_password_forgot_password_step1__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__main_forgot_password_forgot_password_step1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__main_forgot_password_forgot_password_step1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__main_forgot_password_forgot_password_step2__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__main_forgot_password_forgot_password_step2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__main_forgot_password_forgot_password_step2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__main_forgot_password_forgot_password_step3__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__main_forgot_password_forgot_password_step3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__main_forgot_password_forgot_password_step3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__main_forgot_password_forgot_password_step4__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__main_forgot_password_forgot_password_step4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__main_forgot_password_forgot_password_step4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__main_other_pending__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__main_other_pending___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__main_other_pending__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__main_other_login_status__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__main_other_login_status___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__main_other_login_status__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__main_other_loading__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__main_other_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__main_other_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__main_other_online_pending__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__main_other_online_pending___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__main_other_online_pending__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__main_other_online_failed__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__main_other_online_failed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__main_other_online_failed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__main_other_congratulations__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__main_other_congratulations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__main_other_congratulations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__main_other_resetcode__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__main_other_resetcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__main_other_resetcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__main_other_login__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__main_other_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__main_other_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__main_other_FAQ__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__main_other_FAQ___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__main_other_FAQ__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__main_other_get_started__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__main_other_get_started___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__main_other_get_started__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__main_other_privacy_policy__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__main_other_privacy_policy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__main_other_privacy_policy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__main_other_upload__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__main_other_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__main_other_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__common_upload_img__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__common_upload_img___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__common_upload_img__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__common_zoom__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__common_zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__common_zoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__common_ac__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__common_ac___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__common_ac__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__common_mypage__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__common_mypage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__common_mypage__);























































__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

var steps = [['fillform'], ['book_interview', 'interview', 'interview_result', 'interview_pass'], ['pso'], ['book_tpg', 'tpg', 'tpg_result', 'book_demo', 'demo', 'demo_result'], ['personal_profile', 'personal_in', 'personal_qa', 'payment', 'on_board', 'sign_sa', 'info_pre', 'online_pending', 'online_failed', 'get_started']];

var routes = [{
  path: '/fillform',
  name: 'fillform',
  component: __WEBPACK_IMPORTED_MODULE_4__main_fillform_fillform___default.a,
  meta: { gtm: 'MyCustomValue' }
}, {
  path: '/book_interview',
  name: 'book_interview',
  component: __WEBPACK_IMPORTED_MODULE_5__main_interview_book___default.a
}, {
  path: '/interview',
  name: 'interview',
  component: __WEBPACK_IMPORTED_MODULE_6__main_interview_interview___default.a,
  meta: { gtm: 'MyCustomValue' }
}, {
  path: '/interview_result',
  name: 'interview_result',
  component: __WEBPACK_IMPORTED_MODULE_7__main_interview_result___default.a
}, {
  path: '/interview_pass',
  name: 'interview_pass',
  component: __WEBPACK_IMPORTED_MODULE_8__main_interview_pass___default.a
}, {
  path: '/pso',
  name: 'pso',
  component: __WEBPACK_IMPORTED_MODULE_9__main_pso_pso___default.a
}, {
  path: '/book_tpg',
  name: 'book_tpg',
  component: __WEBPACK_IMPORTED_MODULE_10__main_tpg_book___default.a
}, {
  path: '/tpg',
  name: 'tpg',
  component: __WEBPACK_IMPORTED_MODULE_11__main_tpg_tpg___default.a
}, {
  path: '/tpg_result',
  name: 'tpg_result',
  component: __WEBPACK_IMPORTED_MODULE_12__main_tpg_result___default.a
}, {
  path: '/book_demo',
  name: 'book_demo',
  component: __WEBPACK_IMPORTED_MODULE_13__main_demo_book___default.a
}, {
  path: '/demo',
  name: 'demo',
  component: __WEBPACK_IMPORTED_MODULE_14__main_demo_demo___default.a
}, {
  path: '/demo_result',
  name: 'demo_result',
  component: __WEBPACK_IMPORTED_MODULE_15__main_demo_result___default.a
}, {
  path: '/personal_profile',
  name: 'personal_profile',
  component: __WEBPACK_IMPORTED_MODULE_16__main_onboarding_personal_profile___default.a,
  children: [{
    path: '/personal_profile/personal_in',
    name: 'personal_in',
    component: __WEBPACK_IMPORTED_MODULE_17__main_onboarding_personal_in___default.a
  }, {
    path: '/personal_profile/personal_qa',
    name: 'personal_qa',
    component: __WEBPACK_IMPORTED_MODULE_18__main_onboarding_personal_qa___default.a
  }, {
    path: '/personal_profile/payment',
    name: 'payment',
    component: __WEBPACK_IMPORTED_MODULE_19__main_onboarding_payment___default.a
  }, {
    path: '/personal_profile/on_board',
    name: 'on_board',
    component: __WEBPACK_IMPORTED_MODULE_20__main_onboarding_on_board___default.a
  }, {
    path: '/personal_profile/sign_sa',
    name: 'sign_sa',
    component: __WEBPACK_IMPORTED_MODULE_21__main_onboarding_sign_sa___default.a
  }, {
    path: '/personal_profile/info_pre',
    name: 'info_pre',
    component: __WEBPACK_IMPORTED_MODULE_22__main_onboarding_info_pre___default.a
  }]
}, {
  path: '/online_pending',
  name: 'online_pending',
  component: __WEBPACK_IMPORTED_MODULE_30__main_other_online_pending___default.a
}, {
  path: '/online_failed',
  name: 'online_failed',
  component: __WEBPACK_IMPORTED_MODULE_31__main_other_online_failed___default.a
}, {
  path: '/forgot_password_step1',
  name: 'forgot_password_step1',
  component: __WEBPACK_IMPORTED_MODULE_23__main_forgot_password_forgot_password_step1___default.a
}, {
  path: '/forgot_password_step2',
  name: 'forgot_password_step2',
  component: __WEBPACK_IMPORTED_MODULE_24__main_forgot_password_forgot_password_step2___default.a
}, {
  path: '/forgot_password_step3',
  name: 'forgot_password_step3',
  component: __WEBPACK_IMPORTED_MODULE_25__main_forgot_password_forgot_password_step3___default.a
}, {
  path: '/forgot_password_step4',
  name: 'forgot_password_step4',
  component: __WEBPACK_IMPORTED_MODULE_26__main_forgot_password_forgot_password_step4___default.a
}, {
  path: '/',
  name: 'rigister_init',
  component: __WEBPACK_IMPORTED_MODULE_29__main_other_loading___default.a
}, {
  path: '/rigister',
  name: 'rigister',
  component: __WEBPACK_IMPORTED_MODULE_29__main_other_loading___default.a
}, {
  path: '/pending',
  name: 'pending',
  component: __WEBPACK_IMPORTED_MODULE_27__main_other_pending___default.a
}, {
  path: '/congratulations',
  name: 'congratulations',
  component: __WEBPACK_IMPORTED_MODULE_32__main_other_congratulations___default.a
}, {
  path: '/login_status',
  name: 'login_status',
  component: __WEBPACK_IMPORTED_MODULE_28__main_other_login_status___default.a
}, {
  path: '/personal_profile_information',
  name: 'personal_profile_information',
  component: __WEBPACK_IMPORTED_MODULE_17__main_onboarding_personal_in___default.a
}, {
  path: '/resetcode',
  name: 'resetcode',
  component: __WEBPACK_IMPORTED_MODULE_33__main_other_resetcode___default.a
}, {
  path: '/login',
  name: 'login',
  component: __WEBPACK_IMPORTED_MODULE_34__main_other_login___default.a
}, {
  path: '/POLICY',
  name: 'POLICY',
  component: __WEBPACK_IMPORTED_MODULE_35__main_other_FAQ___default.a
}, {
  path: '/FAQ',
  name: 'FAQ',
  component: __WEBPACK_IMPORTED_MODULE_35__main_other_FAQ___default.a
}, {
  path: '/payment',
  name: 'payment',
  component: __WEBPACK_IMPORTED_MODULE_19__main_onboarding_payment___default.a
}, {
  path: '/get_started',
  name: 'get_started',
  component: __WEBPACK_IMPORTED_MODULE_36__main_other_get_started___default.a
}, {
  path: '/privacy_policy',
  name: 'privacy_policy',
  component: __WEBPACK_IMPORTED_MODULE_37__main_other_privacy_policy___default.a
}, {
  path: '/upload_img',
  name: 'upload_img',
  component: __WEBPACK_IMPORTED_MODULE_39__common_upload_img___default.a
}, {
  path: '/zoom',
  name: 'zoom',
  component: __WEBPACK_IMPORTED_MODULE_40__common_zoom___default.a
}, {
  path: '/ac',
  name: 'ac',
  component: __WEBPACK_IMPORTED_MODULE_41__common_ac___default.a
}, {
  path: '/mypage',
  name: 'mypage',
  component: __WEBPACK_IMPORTED_MODULE_42__common_mypage___default.a
}, {
  path: '/upload',
  name: 'upload',
  component: __WEBPACK_IMPORTED_MODULE_38__main_other_upload___default.a
}];

var setSteps = function setSteps(routes) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    var _loop = function _loop() {
      var route = _step.value;

      steps.map(function (item, index) {
        if (item.includes(route.name)) {
          route.meta = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, route.meta, { step: index + 1 });
        }
      });

      if (route.children) {
        setSteps(route.children);
      }
    };

    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(routes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      _loop();
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

setSteps(routes);

console.log(routes);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  routes: routes
}));

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__js__ = __webpack_require__(11);






__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* default */].Store({
	state: {
		loginStatus: {},
		init_state: 0,
		acDownloadUrl: null,
		per_opt: [{
			names: "Basic Information",
			addClass: "step1",
			to: '/personal_profile/personal_in',
			step: 'info'
		}, {
			names: "Qualifications",
			addClass: "step2",
			to: '/personal_profile/personal_qa',
			step: 'qualific'
		}, {
			names: 'Payment Method',
			addClass: "step3",
			to: '/personal_profile/payment',
			step: 'paymode'
		}, {
			names: 'Introductory audio',
			addClass: "step4",
			to: '/personal_profile/on_board',
			step: 'video'
		}, {
			names: 'Sign SA',
			addClass: "step5",
			to: '/personal_profile/sign_sa',
			step: 'sa'
		}],
		pop_up: false,
		switch_time: '',
		ntt_self_complete: false,
		is_logined: null,
		pass_date: "",
		full_name: ''
	},
	getters: {
		_acDownloadUrl: function _acDownloadUrl(_ref) {
			var acDownloadUrl = _ref.acDownloadUrl;

			if (acDownloadUrl === null) return {};

			try {
				return {
					mac: acDownloadUrl.macdata.url,
					pc: acDownloadUrl.pcdata.url
				};
			} catch (e) {
				return {
					mac: __WEBPACK_IMPORTED_MODULE_4__js__["a" /* urls */].acMacDownloadLink,
					pc: __WEBPACK_IMPORTED_MODULE_4__js__["a" /* urls */].acPcDownloadLink
				};
			}
		},
		_boardingStep: function _boardingStep(_ref2) {
			var loginStatus = _ref2.loginStatus,
			    per_opt = _ref2.per_opt;

			var _boardingStep = {
				doneStep: [],
				reachStep: []
			};

			var is_login = loginStatus.is_login,
			    status = loginStatus.status,
			    exact_status = loginStatus.exact_status;

			if (!is_login || status != 'onboarding' || !exact_status) return _boardingStep;
			var steps = per_opt.map(function (item) {
				return item.step;
			});
			var index = steps.indexOf(exact_status);
			if (index < 0) return _boardingStep;

			return {
				doneStep: steps.slice(0, index),
				reachStep: steps.slice(0, index + 1)
			};
		}
	},
	mutations: {
		update_login_status: function update_login_status(state, loginStatus) {
			state.loginStatus = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.loginStatus, loginStatus);
		},
		update_ntt_self_comlete: function update_ntt_self_comlete(state, r_status) {
			state.ntt_self_complete = r_status;
		},
		first_enter_times: function first_enter_times(state) {
			state.first_enter++;
		},
		reschedule_pop_show: function reschedule_pop_show(state) {
			state.pop_up = !state.pop_up;
		},
		update_login_state: function update_login_state(state, login) {
			state.is_logined = login;
		},
		setCookie: function setCookie(state, cookies) {
			var ctuskytime = new Date();
			ctuskytime.setYear(ctuskytime.getFullYear() + 1);
			console.log(ctuskytime);
			document.cookie = cookies.key + '=' + encodeURI(cookies.value) + ';expires=' + ctuskytime.toUTCString() + "; path=/; domain=.51talk.com";
		},
		delCookie: function delCookie(state, cookies) {
			var pasttime = new Date(new Date().getTime() - 100000);
			document.cookie = cookies.key + '= ;expires=' + pasttime.toUTCString();
		},
		getCookie: function getCookie(state, cookies) {
			var cookie_ary = document.cookie.split('; ');
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(cookie_ary), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var one = _step.value;

					var find = one.split('=');
					if (find[0] == cookies.name) {
						state.pass_date = find[1];
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		},
		update_full_name: function update_full_name(state, full_name) {
			state.full_name = full_name;
		},
		updateAcDownloadUrl: function updateAcDownloadUrl(state, _ref3) {
			var acDownloadUrl = _ref3.acDownloadUrl;

			state.acDownloadUrl = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.acDownloadUrl, acDownloadUrl);
		}
	},
	actions: {
		update_switch_time: function update_switch_time(_ref4, time) {
			var commit = _ref4.commit,
			    state = _ref4.state;

			state.switch_time = time;
			console.log(time);
		},
		update_ac_download_url: function update_ac_download_url(_ref5) {
			var commit = _ref5.commit,
			    state = _ref5.state;

			if (state.acDownloadUrl != null) return;
			__WEBPACK_IMPORTED_MODULE_2_vue___default.a.axios.get('/common/getAcDownloadUrl').then(function (_ref6) {
				var data = _ref6.data;
				var code = data.code,
				    res = data.res;

				if (data.code == 75000) {
					var macdata = res.macdata,
					    pcdata = res.pcdata;

					commit('updateAcDownloadUrl', {
						acDownloadUrl: { macdata: macdata, pcdata: pcdata }
					});
				} else {
					commit('updateAcDownloadUrl', {
						acDownloadUrl: {}
					});
				}
			}).catch(function (err) {
				commit('updateAcDownloadUrl', {
					acDownloadUrl: {}
				});
			});
		}
	}
}));

/***/ }),
/* 346 */,
/* 347 */,
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(707)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(818),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);








var mimes = {
    'jpg': 'image/jpeg',
    'png': 'image/png',
    'gif': 'image/gif',
    'svg': 'image/svg+xml',
    'psd': 'image/photoshop'
},
    effectRipple = function effectRipple(e, arg_opts) {
    var opts = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({
        ele: e.target,
        type: 'hit',
        bgc: 'rgba(0, 0, 0, 0.15)' }, arg_opts),
        target = opts.ele;
    if (target) {
        var rect = target.getBoundingClientRect(),
            ripple = target.querySelector('.e-ripple');
        if (!ripple) {
            ripple = document.createElement('span');
            ripple.className = 'e-ripple';
            ripple.style.height = ripple.style.width = Math.max(rect.width, rect.height) + 'px';
            target.appendChild(ripple);
        } else {
            ripple.className = 'e-ripple';
        }
        switch (opts.type) {
            case 'center':
                ripple.style.top = rect.height / 2 - ripple.offsetHeight / 2 + 'px';
                ripple.style.left = rect.width / 2 - ripple.offsetWidth / 2 + 'px';
                break;
            default:
                ripple.style.top = e.pageY - rect.top - ripple.offsetHeight / 2 - document.body.scrollTop + 'px';
                ripple.style.left = e.pageX - rect.left - ripple.offsetWidth / 2 - document.body.scrollLeft + 'px';
        }
        ripple.style.backgroundColor = opts.bgc;
        ripple.className = 'e-ripple z-active';
        return false;
    }
},
    data2blob = function data2blob(data, mime) {
    data = data.split(',')[1];
    data = window.atob(data);
    var ia = new Uint8Array(data.length);
    for (var i = 0; i < data.length; i++) {
        ia[i] = data.charCodeAt(i);
    };

    return new Blob([ia], {
        type: mime
    });
};

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        field: {
            type: String,
            'default': 'avatar'
        },

        ki: {
            'default': 0
        },

        value: {
            'default': true
        },

        url: {
            type: String,
            'default': ''
        },

        params: {
            type: Object,
            'default': null
        },

        headers: {
            type: Object,
            'default': null
        },

        width: {
            type: Number,
            default: 200
        },

        height: {
            type: Number,
            default: 200
        },

        noCircle: {
            type: Boolean,
            default: false
        },

        maxSize: {
            type: Number,
            'default': 10240
        },

        langType: {
            type: String,
            'default': 'zh'
        },

        langExt: {
            type: Object,
            'default': null
        },

        imgFormat: {
            type: String,
            'default': 'png'
        }
    },
    data: function data() {
        var that = this,
            imgFormat = that.imgFormat,
            langType = that.langType,
            langExt = that.langExt,
            width = that.width,
            height = that.height,
            isSupported = true,
            allowImgFormat = ['jpg', 'png'],
            langBag = {
            zh: {
                hint: '点击，或拖动图片至此处',
                loading: '正在上传……',
                noSupported: '浏览器不支持该功能，请使用IE10以上或其他现在浏览器！',
                success: '上传成功',
                fail: '图片上传失败',
                preview: '头像预览',
                btn: {
                    off: '取消',
                    close: '关闭',
                    back: '上一步',
                    save: '保存'
                },
                error: {
                    onlyImg: '仅限图片格式',
                    outOfSize: '单文件大小不能超过 ',
                    lowestPx: '图片最低像素为（宽*高）：'
                }
            },
            en: {
                hint: 'Click, or drag the file here',
                loading: 'Uploading……',
                noSupported: 'Browser does not support, please use IE10+ or other browsers',
                success: 'Upload success',
                fail: 'Upload failed',
                preview: 'Preview',
                btn: {
                    off: 'Cancel',
                    close: 'Close',
                    back: 'Back',
                    save: 'Save'
                },
                error: {
                    onlyImg: 'Image only',
                    outOfSize: 'Image exceeds size limit: ',
                    lowestPx: 'The lowest pixel in the image: '
                }
            },
            ru: {
                hint: 'Нажмите, или перетащите файл в это окно',
                loading: 'Загружаю……',
                noSupported: 'Ваш браузер не поддерживается, пожалуйста, используйте IE10 + или другие браузеры',
                success: 'Загрузка выполнена успешно',
                fail: 'Ошибка загрузки',
                preview: 'Предпросмотр',
                btn: {
                    off: 'Отменить',
                    close: 'Закрыть',
                    back: 'Назад',
                    save: 'Сохранить'
                },
                error: {
                    onlyImg: 'Только изображения',
                    outOfSize: 'Изображение превышает предельный размер: ',
                    lowestPx: 'Минимальный размер изображения: '
                }
            }
        },
            tempImgFormat = allowImgFormat.indexOf(imgFormat) === -1 ? 'jpg' : imgFormat,
            lang = langBag[langType] ? langBag[langType] : lang['zh'],
            mime = mimes[tempImgFormat];

        that.imgFormat = tempImgFormat;

        if (langExt) {
            __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(lang, langExt);
        }
        if (typeof FormData != 'function') {
            isSupported = false;
        }
        return {
            mime: mime,

            lang: lang,

            isSupported: isSupported,

            isSupportTouch: document.hasOwnProperty("ontouchstart"),

            step: 1,
            loading: 0,
            progress: 0,

            hasError: false,
            errorMsg: '',

            ratio: width / height,

            sourceImg: null,
            sourceImgUrl: '',
            createImgUrl: '',

            sourceImgMouseDown: {
                on: false,
                mX: 0,
                mY: 0,
                x: 0,
                y: 0
            },

            previewContainer: {
                width: 100,
                height: 100
            },

            sourceImgContainer: {
                width: 240,
                height: 180
            },

            scale: {
                zoomAddOn: false,
                zoomSubOn: false,
                range: 1,
                x: 0,
                y: 0,
                width: 0,
                height: 0,
                maxWidth: 0,
                maxHeight: 0,
                minWidth: 0,
                minHeight: 0,
                naturalWidth: 0,
                naturalHeight: 0
            }
        };
    },

    computed: {
        progressStyle: function progressStyle() {
            var progress = this.progress;

            return {
                width: progress + '%'
            };
        },
        sourceImgStyle: function sourceImgStyle() {
            var scale = this.scale,
                sourceImgMasking = this.sourceImgMasking,
                top = scale.y + sourceImgMasking.y + 'px',
                left = scale.x + sourceImgMasking.x + 'px';

            return {
                top: top,
                left: left,
                width: scale.width + 'px',
                height: scale.height + 'px'
            };
        },
        sourceImgMasking: function sourceImgMasking() {
            var width = this.width,
                height = this.height,
                ratio = this.ratio,
                sourceImgContainer = this.sourceImgContainer,
                sic = sourceImgContainer,
                sicRatio = sic.width / sic.height,
                x = 0,
                y = 0,
                w = sic.width,
                h = sic.height,
                scale = 1;

            if (ratio < sicRatio) {
                scale = sic.height / height;
                w = sic.height * ratio;
                x = (sic.width - w) / 2;
            }
            if (ratio > sicRatio) {
                scale = sic.width / width;
                h = sic.width / ratio;
                y = (sic.height - h) / 2;
            }
            return {
                scale: scale,
                x: x,
                y: y,
                width: w,
                height: h
            };
        },
        sourceImgShadeStyle: function sourceImgShadeStyle() {
            var sourceImgMasking = this.sourceImgMasking,
                sourceImgContainer = this.sourceImgContainer,
                sic = sourceImgContainer,
                sim = sourceImgMasking,
                w = sim.width == sic.width ? sim.width : (sic.width - sim.width) / 2,
                h = sim.height == sic.height ? sim.height : (sic.height - sim.height) / 2;

            return {
                width: w + 'px',
                height: h + 'px'
            };
        },
        previewStyle: function previewStyle() {
            var width = this.width,
                height = this.height,
                ratio = this.ratio,
                previewContainer = this.previewContainer,
                pc = previewContainer,
                w = pc.width,
                h = pc.height,
                pcRatio = w / h;

            if (ratio < pcRatio) {
                w = pc.height * ratio;
            }
            if (ratio > pcRatio) {
                h = pc.width / ratio;
            }
            return {
                width: w + 'px',
                height: h + 'px'
            };
        }
    },
    watch: {
        value: function value(newValue) {
            if (newValue && this.loading != 1) {
                this.reset();
            }
        }
    },
    methods: {
        ripple: function ripple(e) {
            effectRipple(e);
        },
        off: function off() {
            var that = this;
            setTimeout(function () {
                that.$emit('input', false);
                if (that.step == 3 && that.loading == 2) {
                    that.setStep(1);
                }
            }, 200);
        },
        setStep: function setStep(no) {
            var that = this;
            setTimeout(function () {
                that.step = no;
            }, 200);
        },
        preventDefault: function preventDefault(e) {
            e.preventDefault();
            return false;
        },
        handleClick: function handleClick(e) {
            if (this.loading !== 1) {
                if (e.target !== this.$refs.fileinput) {
                    e.preventDefault();
                    if (document.activeElement !== this.$refs) {
                        this.$refs.fileinput.click();
                    }
                }
            }
        },
        handleChange: function handleChange(e) {
            e.preventDefault();
            if (this.loading !== 1) {
                var files = e.target.files || e.dataTransfer.files;
                this.reset();
                if (this.checkFile(files[0])) {
                    this.setSourceImg(files[0]);
                }
            }
        },
        checkFile: function checkFile(file) {
            var that = this,
                lang = that.lang,
                maxSize = that.maxSize;

            if (file.type.indexOf('image') === -1) {
                that.hasError = true;
                that.errorMsg = lang.error.onlyImg;
                return false;
            }

            if (file.size / 1024 > maxSize) {
                that.hasError = true;
                that.errorMsg = lang.error.outOfSize + maxSize + 'kb';
                return false;
            }
            return true;
        },
        reset: function reset() {
            var that = this;
            that.loading = 0;
            that.hasError = false;
            that.errorMsg = '';
            that.progress = 0;
        },
        setSourceImg: function setSourceImg(file) {
            var that = this,
                fr = new FileReader();
            fr.onload = function (e) {
                that.sourceImgUrl = fr.result;
                that.startCrop();
            };
            fr.readAsDataURL(file);
        },
        startCrop: function startCrop() {
            var that = this,
                width = that.width,
                height = that.height,
                ratio = that.ratio,
                scale = that.scale,
                sourceImgUrl = that.sourceImgUrl,
                sourceImgMasking = that.sourceImgMasking,
                lang = that.lang,
                sim = sourceImgMasking,
                img = new Image();

            img.src = sourceImgUrl;
            img.onload = function () {
                var nWidth = img.naturalWidth,
                    nHeight = img.naturalHeight,
                    nRatio = nWidth / nHeight,
                    w = sim.width,
                    h = sim.height,
                    x = 0,
                    y = 0;

                if (nWidth < width || nHeight < height) {
                    that.hasError = true;
                    that.errorMsg = lang.error.lowestPx + width + '*' + height;
                    return false;
                }
                if (ratio > nRatio) {
                    h = w / nRatio;
                    y = (sim.height - h) / 2;
                }
                if (ratio < nRatio) {
                    w = h * nRatio;
                    x = (sim.width - w) / 2;
                }
                scale.range = 0;
                scale.x = x;
                scale.y = y;
                scale.width = w;
                scale.height = h;
                scale.minWidth = w;
                scale.minHeight = h;
                scale.maxWidth = nWidth * sim.scale;
                scale.maxHeight = nHeight * sim.scale;
                scale.naturalWidth = nWidth;
                scale.naturalHeight = nHeight;
                that.sourceImg = img;
                that.createImg();
                that.setStep(2);
            };
        },
        imgStartMove: function imgStartMove(e) {
            e.preventDefault();

            if (this.isSupportTouch && !e.targetTouches) {
                return false;
            }
            var et = e.targetTouches ? e.targetTouches[0] : e,
                sourceImgMouseDown = this.sourceImgMouseDown,
                scale = this.scale,
                simd = sourceImgMouseDown;

            simd.mX = et.screenX;
            simd.mY = et.screenY;
            simd.x = scale.x;
            simd.y = scale.y;
            simd.on = true;
        },
        imgMove: function imgMove(e) {
            e.preventDefault();

            if (this.isSupportTouch && !e.targetTouches) {
                return false;
            }
            var et = e.targetTouches ? e.targetTouches[0] : e,
                _sourceImgMouseDown = this.sourceImgMouseDown,
                on = _sourceImgMouseDown.on,
                mX = _sourceImgMouseDown.mX,
                mY = _sourceImgMouseDown.mY,
                x = _sourceImgMouseDown.x,
                y = _sourceImgMouseDown.y,
                scale = this.scale,
                sourceImgMasking = this.sourceImgMasking,
                sim = sourceImgMasking,
                nX = et.screenX,
                nY = et.screenY,
                dX = nX - mX,
                dY = nY - mY,
                rX = x + dX,
                rY = y + dY;

            if (!on) return;
            if (rX > 0) {
                rX = 0;
            }
            if (rY > 0) {
                rY = 0;
            }
            if (rX < sim.width - scale.width) {
                rX = sim.width - scale.width;
            }
            if (rY < sim.height - scale.height) {
                rY = sim.height - scale.height;
            }
            scale.x = rX;
            scale.y = rY;
        },
        startZoomAdd: function startZoomAdd(e) {
            var that = this,
                scale = that.scale;

            scale.zoomAddOn = true;

            function zoom() {
                if (scale.zoomAddOn) {
                    var range = scale.range >= 100 ? 100 : ++scale.range;
                    that.zoomImg(range);
                    setTimeout(function () {
                        zoom();
                    }, 60);
                }
            }
            zoom();
        },
        endZoomAdd: function endZoomAdd(e) {
            this.scale.zoomAddOn = false;
        },
        startZoomSub: function startZoomSub(e) {
            var that = this,
                scale = that.scale;

            scale.zoomSubOn = true;

            function zoom() {
                if (scale.zoomSubOn) {
                    var range = scale.range <= 0 ? 0 : --scale.range;
                    that.zoomImg(range);
                    setTimeout(function () {
                        zoom();
                    }, 60);
                }
            }
            zoom();
        },
        endZoomSub: function endZoomSub(e) {
            var scale = this.scale;

            scale.zoomSubOn = false;
        },
        zoomChange: function zoomChange(e) {
            this.zoomImg(e.target.value);
        },
        zoomImg: function zoomImg(newRange) {
            var that = this,
                sourceImgMasking = this.sourceImgMasking,
                sourceImgMouseDown = this.sourceImgMouseDown,
                scale = this.scale,
                maxWidth = scale.maxWidth,
                maxHeight = scale.maxHeight,
                minWidth = scale.minWidth,
                minHeight = scale.minHeight,
                width = scale.width,
                height = scale.height,
                x = scale.x,
                y = scale.y,
                range = scale.range,
                sim = sourceImgMasking,
                sWidth = sim.width,
                sHeight = sim.height,
                nWidth = minWidth + (maxWidth - minWidth) * newRange / 100,
                nHeight = minHeight + (maxHeight - minHeight) * newRange / 100,
                nX = sWidth / 2 - nWidth / width * (sWidth / 2 - x),
                nY = sHeight / 2 - nHeight / height * (sHeight / 2 - y);

            if (nX > 0) {
                nX = 0;
            }
            if (nY > 0) {
                nY = 0;
            }
            if (nX < sWidth - nWidth) {
                nX = sWidth - nWidth;
            }
            if (nY < sHeight - nHeight) {
                nY = sHeight - nHeight;
            }

            scale.x = nX;
            scale.y = nY;
            scale.width = nWidth;
            scale.height = nHeight;
            scale.range = newRange;
            setTimeout(function () {
                if (scale.range == newRange) {
                    that.createImg();
                }
            }, 300);
        },
        createImg: function createImg(e) {
            var that = this,
                mime = that.mime,
                sourceImg = that.sourceImg,
                _that$scale = that.scale,
                x = _that$scale.x,
                y = _that$scale.y,
                width = _that$scale.width,
                height = _that$scale.height,
                scale = that.sourceImgMasking.scale,
                canvas = that.$refs.canvas,
                ctx = canvas.getContext('2d');

            if (e) {
                that.sourceImgMouseDown.on = false;
            }
            ctx.clearRect(0, 0, that.width, that.height);
            ctx.drawImage(sourceImg, x / scale, y / scale, width / scale, height / scale);
            that.createImgUrl = canvas.toDataURL(mime);
        },
        upload: function upload() {
            var that = this,
                lang = this.lang,
                imgFormat = this.imgFormat,
                mime = this.mime,
                url = this.url,
                params = this.params,
                headers = this.headers,
                field = this.field,
                ki = this.ki,
                createImgUrl = this.createImgUrl,
                fmData = new FormData();

            fmData.append(field, data2blob(createImgUrl, mime), field + '.' + imgFormat);

            if ((typeof params === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(params)) == 'object' && params) {
                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(params).forEach(function (k) {
                    fmData.append(k, params[k]);
                });
            }

            var uploadProgress = function uploadProgress(event) {
                if (event.lengthComputable) {
                    that.progress = 100 * Math.round(event.loaded) / event.total;
                }
            };

            that.reset();
            that.loading = 1;
            that.setStep(3);
            that.$emit('crop-success', createImgUrl, field, ki);
            new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var client = new XMLHttpRequest();
                client.open('POST', url, true);
                client.onreadystatechange = function () {
                    if (this.readyState !== 4) {
                        return;
                    }
                    if (this.status === 200 || this.status === 201) {
                        resolve(JSON.parse(this.responseText));
                    } else {
                        reject(this.status);
                    }
                };
                client.upload.addEventListener("progress", uploadProgress, false);
                if ((typeof headers === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(headers)) == 'object' && headers) {
                    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(headers).forEach(function (k) {
                        client.setRequestHeader(k, headers[k]);
                    });
                }
                client.send(fmData);
            }).then(function (resData) {
                if (that.value) {
                    that.loading = 2;
                    that.$emit('crop-upload-success', resData, field, ki);
                }
            }, function (sts) {
                if (that.value) {
                    that.loading = 3;
                    that.hasError = true;
                    that.errorMsg = lang.fail;
                    that.$emit('crop-upload-fail', sts, field, ki);
                }
            });
        }
    }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_public_header__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_public_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main_public_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main_public_footer__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main_public_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__main_public_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(61);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      i: 0,
      d: {
        data: ''
      },
      pathT: true
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['update_ac_download_url'])),
  computed: {
    logined: function logined() {
      return this.$store.state.pass_date;
    },
    showHeader: function showHeader() {
      var pathT = void 0;
      if (this.$route.path == '/FAQ' || this.$route.path == '/POLICY' || this.$route.path == '/login_status' || this.$route.name == 'rigister_init' || this.$route.name == 'rigister') {
        pathT = false;
      } else {
        pathT = true;
      }
      return pathT;
    },
    showFooter: function showFooter() {
      var pathT = void 0;
      if (this.$route.path == '/FAQ' || this.$route.path == '/POLICY' || this.$route.path == '/login_status' || this.$route.name == 'rigister_init' || this.$route.name == 'rigister') {
        pathT = false;
      } else {
        pathT = true;
      }
      return pathT;
    }
  },
  components: {
    appHeader: __WEBPACK_IMPORTED_MODULE_1__main_public_header___default.a,
    appFooter: __WEBPACK_IMPORTED_MODULE_2__main_public_footer___default.a
  },
  created: function created() {
    var _this = this;

    if (this.$route.path == '/FAQ' || this.$route.path == '/POLICY') return;
    if (this.$route.path == '/login_status') return;

    this.$http.get('/index/islogin').then(function (d) {
      _this.$store.commit('update_login_status', d.data.res);

      _this.update_ac_download_url();

      if (d.data && d.data.code == '75000' && d.data.res.is_login) {
        var state = d.data.res.status;

        var exact_state = d.data.res.exact_status;

        _this.$store.commit('update_login_state', d.data.res.is_login);

        __WEBPACK_IMPORTED_MODULE_3__js__["b" /* routerController */].call(_this, { state: state, exact_state: exact_state });
      } else {
        _this.$store.commit('update_login_state', false);
        if (_this.$route.path != '/rigister' && _this.$route.path != '/' && _this.$route.path != '/privacy_policy' && _this.$route.path != '/forgot_password_step1' && _this.$route.path != '/forgot_password_step2' && _this.$route.path != '/forgot_password_step3' && _this.$route.path != '/forgot_password_step4' && _this.$route.path != '/POLICY' && _this.$route.path != '/FAQ') {
          window.location.href = __WEBPACK_IMPORTED_MODULE_3__js__["a" /* urls */].ssoLogin;
        }
      }
    });
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        show: {
            type: Boolean,
            twoWay: true,
            default: true
        },

        autoclose: {
            type: Boolean,
            default: true
        },

        startview: {
            type: String,
            default: "month"
        },

        minview: {
            type: String,
            default: "month"
        },

        maxview: {
            type: String,
            default: "decade"
        },
        x: {
            type: Number,
            default: 0
        },
        y: {
            type: Number,
            default: 0
        },
        type: {
            type: String,
            default: "date"
        },
        begin: {
            type: String,
            twoWay: true,
            default: ""
        },
        end: {
            type: String,
            default: ""
        },

        value: {
            type: String,
            twoWay: true,
            default: ""
        },

        single: {
            type: Boolean,
            default: true
        },

        rangeValue: {
            type: String,
            default: ""
        },
        sep: {
            type: String,
            twoWay: true,
            default: "-"
        },
        weeksWording: {
            type: Array,
            default: function _default() {
                return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
            }
        },
        monthsWording: {
            type: Array,
            default: function _default() {
                return [{ text: 'Jan', value: 0 }, { text: 'Feb', value: 1 }, { text: 'Mar', value: 2 }, { text: 'Apr', value: 3 }, { text: 'May', value: 4 }, { text: 'Jun', value: 5 }, { text: 'Jul', value: 6 }, { text: 'Aug', value: 7 }, { text: 'Sep', value: 8 }, { text: 'Oct', value: 9 }, { text: 'Nov', value: 10 }, { text: 'Dec', value: 11 }];
            }
        }
    },
    data: function data() {
        return {
            list: {
                head: [],
                body: []
            },
            days: [],
            today: [],

            selects: [],

            currentViewDate: "",

            currentViewType: {
                text: "",
                value: 0
            },

            timeSwitch: "",
            selectValue: {
                start: "",
                end: ""
            }
        };
    },
    created: function created() {
        var _this = this;

        this.init();

        window.setTimeout(function () {
            document.addEventListener('click', function (e) {
                e.stopPropagation();
                _this.cancel();
            }, false);
        }, 500);
    },

    watch: {
        show: function show() {
            this.init();
        },
        value: function value() {
            this.init();
        }
    },
    computed: {},
    methods: {
        init: function init() {
            if (1) {
                if (!this.value) {
                    this.selectValue.start = new Date();
                }
                this.selectValue.start = this.value;
                this.selectValue.end = this.selectValue.start;
                if (this.rangeValue) {
                    this.selectValue.end = this.rangeValue;
                }

                this.currentViewDate = this.selectValue.end;
                this.currentViewType = {
                    text: this.startview,
                    value: viewTypeEnum[this.startview]
                };

                this.selects = [];
                this.selects.push(this.selectValue.start);
                if (!this.single) {
                    this.selects = this.getRangeDate(this.selectValue.start, this.selectValue.end, this.currentViewType.text);
                }

                this.render(this.currentViewType.text, this.currentViewDate);
            }
        },
        getRangeDate: function getRangeDate(start, end, currentViewTypeText) {
            var _self = this;
            var result = [];
            var type = '';

            switch (currentViewTypeText) {
                case "decade":
                    type = 'years';
                    break;
                case "year":
                    type = 'months';
                    break;

                case "month":
                    type = 'days';
                    break;
            }
            var startMM = __WEBPACK_IMPORTED_MODULE_1_moment___default()(start).endOf(type);
            var endMM = __WEBPACK_IMPORTED_MODULE_1_moment___default()(end).endOf(type);
            while (startMM <= endMM) {
                result.push(startMM.format('YYYY-MM-DD'));
                startMM.add(1, type);
            }
            result = unique(result);
            return result;
        },
        render: function render(currentViewTypeText, date) {
            var _self = this;
            var mm = __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(this.formatViewTypeDate(date, currentViewTypeText)));

            switch (currentViewTypeText) {
                case "decade":
                    _self.list.head = [];
                    var yearList = getYearDateBody(date);
                    var list = yearList.map(function (c) {
                        return {
                            text: c.text,
                            value: c.value
                        };
                    });
                    list = _self.setDisableCssClass(list);
                    _self.list.body = splitTwoDimension(list, 4, 'years');
                    if (list.length > 0) {
                        _self.timeSwitch = list[0].text + '-' + list[list.length - 1].text;
                    }
                    break;
                case "year":
                    _self.list.head = [];
                    var list = _self.monthsWording.map(function (c) {
                        return {
                            text: c.text,
                            value: mm.month(c.value).format('YYYY-MM-DD')
                        };
                    });
                    list = _self.setDisableCssClass(list);
                    _self.list.body = splitTwoDimension(list, 4, 'months');
                    _self.timeSwitch = this.getTimeSwitch(currentViewTypeText, date);
                    break;

                case "month":
                    _self.list.head = _self.weeksWording;
                    console.log(date);
                    var list = getMonthDateBody(date);
                    list = _self.setDisableCssClass(list);
                    _self.list.body = splitTwoDimension(list, 7, 'days');
                    _self.timeSwitch = this.getTimeSwitch(currentViewTypeText, date);
                    break;
            }
        },
        prev: function prev(e) {
            e.stopPropagation();
            switch (this.currentViewType.text) {
                case 'decade':
                    this.currentViewDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(this.currentViewDate)).add(-10, "years");
                    this.render("decade", this.currentViewDate);
                    break;
                case 'year':
                    this.currentViewDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(this.currentViewDate)).add(-1, "years");
                    this.render("year", this.currentViewDate);
                    break;
                case 'month':
                    this.currentViewDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(this.currentViewDate)).add(-1, "months");
                    this.render("month", this.currentViewDate);
                    break;
                case 'day':
                    break;
                case 'hour':
                    break;
            }
        },
        next: function next(e) {
            e.stopPropagation();
            switch (this.currentViewType.text) {
                case 'decade':
                    this.currentViewDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(this.currentViewDate)).add(10, "years");
                    this.render("decade", this.currentViewDate);
                    break;
                case 'year':
                    this.currentViewDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(this.currentViewDate)).add(1, "years");
                    this.render("year", this.currentViewDate);
                    break;
                case 'month':
                    this.currentViewDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(this.currentViewDate)).add(1, "months");
                    this.render("month", this.currentViewDate);
                    break;
                case 'day':
                    break;
                case 'hour':
                    break;
            }
        },
        select: function select(value) {
            if (this.currentViewType.text != this.minview) {
                if (this.currentViewType.value < viewTypeEnum[this.minview]) {
                    this.currentViewType.value = this.currentViewType.value + 1;

                    this.currentViewType.text = viewTypeEnum[this.currentViewType.value];

                    this.currentViewDate = value;
                    switch (this.currentViewType.text) {
                        case 'decade':
                            break;
                        case 'year':
                            this.render('year', value);
                            break;
                        case 'month':
                            this.render('month', value);
                            break;
                        case 'day':
                            break;
                        case 'hour':
                            break;
                    }
                }
                return false;
            }

            this.selects = [];
            if (!this.single) {
                if (this.selectValue.start && this.selectValue.end) {
                    this.selectValue.start = value;
                    this.selectValue.end = '';
                    this.selects.push(this.selectValue.start);
                } else if (this.selectValue.start) {
                    this.selectValue.end = value;

                    if (__WEBPACK_IMPORTED_MODULE_1_moment___default()(value) < __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.selectValue.start)) {
                        this.selectValue.end = this.selectValue.start;
                        this.selectValue.start = value;
                    }
                    this.selects = this.getRangeDate(this.selectValue.start, this.selectValue.end, this.currentViewType.text);
                }
            } else {
                if (this.selects.some(function (c) {
                    return c == value;
                })) {
                    var index = this.selects.indexOf(value);
                    this.selects.splice(index, 1);
                } else {
                    this.selects.push(value);
                }
            }

            if (this.autoclose && this.selectValue.start && this.selectValue.end) {
                this.ok();
            }
        },
        ok: function ok() {
            if (this.sep != '-') {
                var sep = this.sep;
                this.selects = this.selects.map(function (c) {
                    return c.replace(/-/g, sep);
                });
            }
            this.$emit('ok', { values: this.selects });
            this.cancel();
        },
        cancel: function cancel() {
            this.$emit('cancel', { show: false });
        },
        getCssClass: function getCssClass(value, cssClass) {
            var _self = this;
            var newcssClass = {};
            var selects = this.selects || [],
                type = "";
            switch (this.currentViewType.text) {
                case "decade":
                    type = 'years';
                    break;
                case "year":
                    type = 'months';
                    break;

                case "month":
                    type = 'days';
                    break;
            }
            value = this.formatViewTypeDate(value, type);
            if (!_self.single) {
                selects = this.removeRedundancy(this.selects, value, type);
            }
            selects = selects.map(function (c) {
                return _self.formatViewTypeDate(c, type);
            });
            selects = unique(selects);

            var index = selects.indexOf(value);
            if (index >= 0) {
                newcssClass.selected = true;
            }

            if (this.selects.length >= 2) {
                delete newcssClass.selected;
                var startSelect = _self.formatViewTypeDate(this.selects[0], type);
                var endSelect = _self.formatViewTypeDate(this.selects[this.selects.length - 1], type);
                if (value == startSelect) {
                    newcssClass['selected-start'] = true;
                } else if (value == endSelect) {
                    newcssClass['selected-end'] = true;
                } else {
                    if (index >= 0) {
                        newcssClass['selected-item'] = true;
                    }
                }
            }
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(newcssClass, cssClass);
        },
        getTimeSwitch: function getTimeSwitch(currentViewTypeText, date) {
            var timeSwitch = [];
            var mm = __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(date));

            if (currentViewTypeText == "year") {
                timeSwitch.push(mm.year());
            }

            if (currentViewTypeText == "month") {
                timeSwitch.push(mm.year());
                timeSwitch.push(mm.month() + 1);
            }
            if (currentViewTypeText == "day") {
                timeSwitch.push(mm.year());
                timeSwitch.push(mm.month() + 1);
                timeSwitch.push(Number(mm.format("DD")) + 1);
            }
            return timeSwitch.join('/');
        },
        removeRedundancy: function removeRedundancy(arr, date, type) {
            var dateSplit = date.split('-');
            var field = date;
            switch (type) {
                case 'months':
                    field = dateSplit[0];
                    break;
                case 'days':
                    field = dateSplit[0] + '-' + dateSplit[1];
                    break;
            }
            var list = arr.filter(function (c) {
                return c.indexOf(field) >= 0;
            });
            return list;
        },
        formatViewTypeDate: function formatViewTypeDate(date, type) {
            switch (type) {
                case "decade":
                    type = 'years';
                    break;
                case "year":
                    type = 'months';
                    break;

                case "month":
                    type = 'days';
                    break;
            }
            date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(date)).endOf(type).format('YYYY-MM-DD');
            return date;
        },
        setPrevTimeSwitch: function setPrevTimeSwitch() {
            if (this.currentViewType.value - 1 > 0) {
                this.currentViewType.value = this.currentViewType.value - 1;

                this.currentViewType.text = viewTypeEnum[this.currentViewType.value];
            }
            this.render(this.currentViewType.text, this.currentViewDate);
        },
        setDisableCssClass: function setDisableCssClass(arr) {
            var _self = this;
            var beginMM = null,
                endMM = null;
            if (this.begin) {
                beginMM = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.begin);
            }
            if (this.end) {
                endMM = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.end);
            }
            console.log(_self.currentViewType.text, arr);

            return arr.map(function (c) {
                var disabled = false;
                var mm = __WEBPACK_IMPORTED_MODULE_1_moment___default()(c.value);
                if (!c.cssClass) {
                    c.cssClass = {};
                }
                if (beginMM) {
                    switch (_self.currentViewType.text) {
                        case 'decade':
                            disabled = mm.year() < beginMM.year();
                            break;
                        case 'year':
                            disabled = mm.year() == beginMM.year() && mm.month() < beginMM.month();
                            break;
                        case 'month':
                            disabled = mm < beginMM;
                            break;
                    }
                }
                console.log(disabled);

                if (endMM && !disabled) {
                    switch (_self.currentViewType.text) {
                        case 'decade':
                            disabled = mm.year() > endMM.year();
                            break;
                        case 'year':
                            disabled = mm.year() == beginMM.year() && mm.month() > endMM.month();
                            break;
                        case 'month':
                            disabled = mm > endMM;
                            break;
                    }
                }

                return {
                    text: c.text,
                    value: c.value,
                    cssClass: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(c.cssClass, { disabled: disabled })
                };
            });
        }
    }
});

var viewTypeEnum = {
    decade: 1,
    year: 2,
    month: 3,
    day: 4,
    hour: 5,
    '1': 'decade',
    '2': 'year',
    '3': 'month',
    '4': 'day',
    '5': 'hour'
};

var getYearDateBody = function getYearDateBody(date) {
    var mm = __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(date));
    var year = mm.year();
    var result = [];
    var prevLength = year % 10;

    result.push({
        text: __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(date)).add(0 - (prevLength + 1), "years").year(),
        value: __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(date)).add(0 - (prevLength + 1), "years").format("YYYY-MM-DD")
    });

    for (var i = prevLength; i > 0; i--) {
        result.push({
            text: __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(date)).add(0 - i, "years").year(),
            value: __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(date)).add(0 - i, "years").format("YYYY-MM-DD")
        });
    }

    var nextLength = 10 - prevLength;
    for (var i = 0; i <= nextLength; i++) {
        result.push({
            text: __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(date)).add(i, "years").year(),
            value: __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(date)).add(i, "years").format("YYYY-MM-DD")
        });
    }
    return result;
};

var getMonthDateBody = function getMonthDateBody(date) {
    var mm = __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(date));
    var year = mm.year();

    var month = mm.month() + 1;
    var result = [];

    var monthStartDay = mm.startOf("month").days();
    var monthEndDay = mm.endOf("month").days();

    if (monthStartDay != 0) {
        var prevMM = __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(date)).add(-1, 'months');
        var prevPadding = prevMM.endOf("month").add(0 - monthStartDay, "days");
        for (var i = 0; i <= monthStartDay - 1; i++) {
            result.push({
                text: prevPadding.add(1, "days").format("DD"),
                value: prevPadding.add(0, "days").format("YYYY-MM-DD"),
                cssClass: {
                    "old": true
                }
            });
        }
    }

    var thisMonthLastNum = Number(__WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(date)).endOf("month").format("DD"));
    for (var i = 0; i <= thisMonthLastNum - 1; i++) {
        result.push({
            text: __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(date)).startOf("month").add(i, "days").format("DD"),
            value: __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(date)).startOf("month").add(i, "days").format("YYYY-MM-DD")
        });
    }

    if (monthEndDay != 6) {
        var nextMM = __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(date)).add(1, 'months');
        var length = 6 - nextMM.startOf("month").days();
        for (var i = 0; i <= length; i++) {
            result.push({
                text: __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(date)).startOf("month").add(1, 'months').add(i, "days").format("DD"),
                value: __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(date)).startOf("month").add(1, 'months').add(i, "days").format("YYYY-MM-DD"),
                cssClass: {
                    "old": true
                }
            });
        }
    }
    return result;
};

var unique = function unique(arr) {
    arr = arr || [];
    var hash = {},
        result = [],
        type = '',
        item;
    for (var i = 0; i < arr.length; i++) {
        item = arr[i];
        type = Object.prototype.toString.call(item);

        if (!hash[item + type]) {
            hash[item + type] = true;
            result.push(item);
        }
    }
    return result;
};

var a = __WEBPACK_IMPORTED_MODULE_1_moment___default()('2016-5-1');
var b = __WEBPACK_IMPORTED_MODULE_1_moment___default()('2016-05-2');

var splitTwoDimension = function splitTwoDimension(arr, length, formatType) {
    var result = [];

    var twoDimension = [];
    for (var i = 0; i < arr.length; i++) {
        if (i % length == 0 && i !== 0) {
            result.push(twoDimension);
            twoDimension = [];
        }
        if (formatType) {
            arr[i].value = __WEBPACK_IMPORTED_MODULE_1_moment___default()(arr[i].value).endOf(formatType).format('YYYY-MM-DD');
        }
        twoDimension.push(arr[i]);

        if (i + 1 == arr.length) {
            result.push(twoDimension);
        }
    }
    return result;
};

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(61);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    isCheck: {
      default: false,
      required: false,
      isMac: false,
      isWindows: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['_acDownloadUrl']), {
    mac_sys_url: function mac_sys_url() {
      if (this._acDownloadUrl.mac && this._acDownloadUrl.pc) {
        var _isMac = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__js__["c" /* isMac */])();
        return this._acDownloadUrl[_isMac ? 'mac' : 'pc'];
      }
    }
  })
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "MoUpload",
  props: {
    accepts: {
      type: String,
      default: "image/jpeg,image/jpg,image/png"
    },
    flag: [String, Number],
    maxSize: {
      type: Number,
      default: 0 },
    action: {
      type: String
    },
    beforeUpload: {
      type: Function
    },
    idx: {
      type: Number
    },
    id: {
      type: String
    },
    overtimeFn: {
      type: Function
    },
    uploadKey: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    upload: function upload(event) {
      var _this2 = this;

      var file = event.target.files[0];
      var _this = this;
      var flag = this.flag;
      if (file) {
        if (!_this.beforeUpload(file, event)) {
          return;
        }


        var formData = new FormData();

        formData.append("file", file);

        _this.$http.post(this.action, formData).then(function (response) {
          var result = response.body;

          _this.$emit("complete", result, file, _this.idx, _this.id, _this2.uploadKey);

          event.target.value = null;
        }).catch(function () {
          if (_this2.overtimeFn) _this2.overtimeFn();
        });
      }
    }
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    title: String,
    partOne: String,
    partTwo: String,
    partTh: String
  },
  data: function data() {
    return {
      onOff: false
    };
  },

  components: {},
  methods: {
    fold: function fold() {
      this.onOff = !this.onOff;
    }
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    isCheck: {
      default: false,
      required: false
    }
  },
  methods: {
    inputCheckFn: function inputCheckFn() {
      var isCheck = !this.isCheck;
      this.$emit('checkFn', isCheck);
    }
  }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			upload_remind_words: 'Resume ＊（.doc/.docx/.pdf format within 2MB）',
			BtnText: 'upload'
		};
	},

	props: {
		init_width: String,
		words: String
	},
	computed: {
		c_wid: function c_wid() {
			return this.init_width ? this.init_width : 475;
		}
	},
	methods: {
		upload: function upload(e) {
			var file = e.target.files[0];
			var formData = new FormData();
			formData.append('file', file);
			console.log(file, formData);
			if (file) {
				this.$http.post('/common/fillform/uploadResume', formData).then(function (d) {
					console.log('success:' + d);
				}, function (d) {
					console.log('error' + d);
				});
			}
		}
	},
	watch: {
		words: function words() {}
	}
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js__ = __webpack_require__(11);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    isCheck: {
      default: false,
      required: false
    }
  },

  data: function data() {
    return {
      myPageLogTea: __WEBPACK_IMPORTED_MODULE_0__js__["a" /* urls */].myPageLogTea
    };
  }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["message", "imageUrl"],
  data: function data() {
    return {};
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    isCheck: {
      default: false,
      required: false
    }
  }

});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_Calendar_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_Calendar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_Calendar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_ac_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_ac_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_ac_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rangeTime',
  components: {
    Calendar: __WEBPACK_IMPORTED_MODULE_0__common_Calendar_vue___default.a,
    ac: __WEBPACK_IMPORTED_MODULE_1__common_ac_vue___default.a,
    status: status
  },
  data: function data() {
    return {
      hasDate: false,
      username: '',
      words: {
        cancel: false,
        no_show: false
      },

      calendar: {
        show: true,
        x: 0,
        y: 0,
        items: {
          type: 'date',
          begin: '',
          end: '',
          value: '',
          text: '',
          sep: '-',
          rangeValue: '',
          single: true,
          autoclose: true,
          weeks: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        }
      },
      d_time_zone: '',
      time_zone: '',
      time_detail: '',
      switch_time: '',
      time_frame: [],
      right_date_update: '',
      work_start_time: ''
    };
  },

  methods: {
    frameFn: function frameFn(d, idx, work_start_time) {
      for (var i = 0; i < this.time_frame.length; i++) {
        this.time_frame[i].isActive = false;
      }
      this.time_detail = d;
      this.time_frame[idx].isActive = true;
      this.work_start_time = work_start_time;
    },
    open: function open(e, type) {
      this.calendar.show = true;
      this.calendar.x = e.target.offsetLeft;
      this.calendar.y = e.target.offsetTop + e.target.offsetHeight + 8;
    },
    dateCancel: function dateCancel(obj) {
      this.calendar.show = obj.show;
    },
    dateOk: function dateOk(obj) {
      this.calendar.items.text = obj.values[0];
      this.calendar.items.value = obj.values[0];
    },
    submit: function submit() {
      var _this2 = this;

      var params = new URLSearchParams();
      var _this = this;
      var date = this.calendar.items.text + ' ' + this.work_start_time;

      if (!this.time_zone || !date || !this.time_detail) {
        this.$message.error('Please choose a training session!');
        return;
      }
      params.append('timezone', _this.time_zone);
      params.append('working_date', date);
      params.append('working_time', _this.time_detail);
      params.append('action', 'schedule');

      this.axios.post('/demo/schedule', params).then(function (d) {
        if (d.data.code == '75000') {
          _this2.$message.success('Success!');
          _this2.$router.replace('/demo?status=assigned');
        } else {
          _this2.$message.error(d.data.message);
        }
      });
    },
    addZero: function addZero(n) {
      return n < 10 ? '0' + n : n;
    },
    update_right_time: function update_right_time() {
      this.time_detail = '';

      var date = this.calendar.items.text + ' ' + this.switch_time;
      this.$http.get('/demo/getDemoTime?timezone=' + this.time_zone + '&working_date=' + date).then(function (response) {
        if (response.data.code == '75000') {
          this.hasDate = true;
          this.time_frame = [];
          for (var i = 0; i < response.data.res.length; i++) {
            var arrTime = {};
            arrTime.service_id = response.data.res[i].service_id;
            arrTime.working_date = response.data.res[i].working_date;
            arrTime.week = response.data.res[i].week;
            arrTime.work_end_time = response.data.res[i].work_end_time;
            arrTime.work_hour_type = response.data.res[i].work_hour_type;
            arrTime.work_hour_value = response.data.res[i].work_hour_value;
            arrTime.work_start_time = response.data.res[i].work_start_time;
            arrTime.isActive = false;
            this.time_frame.push(arrTime);
          }
        } else {
          this.hasDate = false;

          this.time_frame = [];
          this.time_detail = '';
        }
      }, function () {
        console.log('service error');
      });
    }
  },
  created: function created() {
    var _this3 = this;

    var _this = this;

    var date = new Date();

    var yy = date.getFullYear();

    var mm = date.getMonth() + 1;

    var dd = date.getDate();

    mm = mm < 10 ? '0' + mm : mm;

    dd = dd < 10 ? '0' + dd : dd;

    this.$http.get('/common/getConfig?key=time_zone').then(function (d) {
      if (d.data.code == '75000') {
        _this3.d_time_zone = d.data.res.time_zone;

        _this3.$http.get('/demo/getTutorInfo').then(function (d) {
          if (d.data.code == '75000') {
            _this3.time_zone = d.data.res.tutor.time_zone;

            _this3.username = d.data.res.tutor.full_name;

            _this3.$watch(function () {
              return this.right_date_update;
            }, function () {
              this.update_right_time();
            });
            _this3.$watch(function () {
              return this.calendar.items.text;
            }, function () {
              this.update_right_time();
            });
          } else {
            _this3.$message.error('making appointments fail.');
          }
        });
      }
    });
  },

  watch: {
    time_zone: function time_zone() {
      var _this4 = this;

      var _this = this;

      this.$http.get('/demo/getDemoDate?timezone=' + this.time_zone).then(function (d) {
        console.log('watch');
        if (d.data.code == '75000') {
          var dates = d.data.res.cycles;

          var serve_date = new Date(d.data.res.first_date).getTime() + (dates * 1 - 1) * 24 * 60 * 60 * 1000;

          var dateEnd = new Date(serve_date);

          var year = dateEnd.getFullYear();

          var months = _this.addZero(dateEnd.getMonth() + 1);

          var day = _this.addZero(dateEnd.getDate());

          console.log('d.data.res.first_date:' + d.data.res.first_date, 'serve_date:' + serve_date, 'dateEnd:' + dateEnd);

          _this4.calendar.items.end = year + '-' + months + '-' + day;

          _this4.calendar.items.begin = d.data.res.first_date;

          _this4.calendar.items.value = d.data.res.default_date;

          _this4.calendar.items.text = d.data.res.default_date;

          console.log('end:' + year + '-' + months + '-' + day, 'begin:' + d.data.res.first_date, 'value+text:' + d.data.res.default_date);
          _this4.right_date_update = d.data.res.switch_datetime;

          _this4.switch_time = d.data.res.switch_time;

          _this4.calendar.show = false;

          _this4.calendar.show = true;
        } else if (d.data.code == '75001') {
          _this.$router.replace('/pending?status=no_date');
        }
      });
    }
  }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__other_tpg_demo_reschedule__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__other_tpg_demo_reschedule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__other_tpg_demo_reschedule__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__other_CancelConfirm_vue__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__other_CancelConfirm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__other_CancelConfirm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_ac_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_ac_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_ac_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__js__ = __webpack_require__(11);











/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      urls: __WEBPACK_IMPORTED_MODULE_7__js__["a" /* urls */],
      bookType: 'demo',
      data: [{
        label: '一级 1',
        children: [{
          label: '二级 1-1',
          children: [{
            label: '三级 1-1-1'
          }]
        }]
      }, {
        label: '一级 2',
        children: [{
          label: '二级 2-1',
          children: [{
            label: '三级 2-1-1'
          }]
        }, {
          label: '二级 2-2',
          children: [{
            label: '三级 2-2-1'
          }]
        }]
      }, {
        label: '一级 3',
        children: [{
          label: '二级 3-1',
          children: [{
            label: '三级 3-1-1'
          }]
        }, {
          label: '二级 3-2',
          children: [{
            label: '三级 3-2-1'
          }]
        }]
      }],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      options: '',
      value8: '',
      appointment: {
        timezone: ''
      },
      staff: {
        name: '',
        zoom_id: '',
        email: '',
        skype: ''
      },
      date_time: '',
      need_help: '',
      isMac: false,
      isWindows: false,
      words: {
        rescheduled: false
      },
      ntt_url: '',
      is1v1: false,
      canReschedule: false
    };
  },
  beforeRouteEnter: function beforeRouteEnter(from, to, next) {
    next(function (vm) {
      vm.$http.get('/Boarding/getTutor').then(function (d) {
        if (d.data.code == '75000') {
          var teacherType = d.data.res.info.sa_version;
          switch (teacherType) {
            case '1':
              vm.is1v1 = true;
              break;
            case '2':
              vm.is1v1 = false;
              break;
          }
        }
      });
      vm.$http.get('/common/getConfig?key=time_zone').then(function (d) {
        if (d.data.code == '75000') {
          vm.options = d.data.res.time_zone;
        }
      });
      vm.$http.get('/demo/getAppointmentInfo').then(function (d) {
        if (d.data.code == '75000' && d.data.res.appointment) {
          vm.appointment = d.data.res.appointment;

          vm.staff = d.data.res.staff;

          var start_date = vm.appointment.start_time;

          var end_date = vm.appointment.end_time;

          var start_hours = start_date.split(' ')[1].slice(0, 5);

          var end_hours = end_date.split(' ')[1].slice(0, 5);

          var years = start_date.split(' ')[0];

          var times = ['AM', 'Noon', 'PM'];

          var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

          var full_date = new Date(years);

          if (start_hours == '12:00:00') {
            times = times[1];
          } else if (start_hours.split(':')[0] > 12) {
            times = times[2];
          } else if (start_hours.split(':')[0] < 12) {
            times = times[0];
          }

          vm.date_time = start_hours + '-' + end_hours + ' / ' + vm.appointment.working_date_formatted;
        }
      });
    });
  },

  methods: {
    handleNodeClick: function handleNodeClick(data) {},
    getTutorInfo: function getTutorInfo(_ref) {
      var reschedule_status = _ref.reschedule_status,
          interviewer_info = _ref.interviewer_info;

      this.canReschedule = reschedule_status == 1;
      this.need_help = interviewer_info.interviewer_email;
    },
    showPop: function showPop() {
      if (!this.canReschedule) return;
      this.$store.commit('reschedule_pop_show');
    },
    cancel_apo: function cancel_apo() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref2, remark, params, date;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.canReschedule) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _context.next = 4;
                return _this.confirmOpen({
                  type: 'cancel'
                });

              case 4:
                _ref2 = _context.sent;
                remark = _ref2.remark;
                params = new URLSearchParams();
                date = _this.appointment.working_date + ' ' + _this.switch_time;

                params.append('timezone', _this.appointment.timezone_key);
                params.append('working_date', date);
                params.append('working_time', _this.appointment.work_hour_value);
                params.append('action', 'cancel');
                params.append('remark', remark);
                _this.axios.post('/demo/schedule', params).then(function (d) {
                  if (d.data.code == '75000') {
                    _this.$message.success('Success!');
                    window.location.reload();
                  } else {
                    _this.$message.error(d.data.message);
                  }
                });

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    confirmOpen: function confirmOpen(data) {
      return this.$refs.cancelConfirm.open(data);
    }
  },
  components: {
    reschedule: __WEBPACK_IMPORTED_MODULE_4__other_tpg_demo_reschedule___default.a,
    ac: __WEBPACK_IMPORTED_MODULE_6__common_ac_vue___default.a,
    CancelConfirm: __WEBPACK_IMPORTED_MODULE_5__other_CancelConfirm_vue___default.a
  },
  mounted: function mounted() {},
  computed: {
    reschedule_show: function reschedule_show() {
      return this.$store.state.pop_up;
    },
    switch_time: function switch_time() {
      return this.$store.state.switch_time;
    },
    from: function from() {
      try {
        var params = window.location.href.split('?')[1];
        var arrs = params.split('&');
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(arrs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var opt = _step.value;

            if (opt.split('=')[0] == 'status') {
              return opt.split('=')[1];
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } catch (e) {
        return '';
      }
    },
    complete_ntt: function complete_ntt() {
      return this.$store.state.ntt_self_complete;
    },
    full_name: function full_name() {
      return this.$store.state.full_name;
    }
  }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  data: function data() {
    return {
      full_name: '',
      recruiter_email: ''
    };
  },

  created: function created() {
    var _this = this;

    this.$http.get('/demo/getTutorInfo').then(function (d) {
      if (d.data.code == '75000') {
        _this.full_name = d.data.res.tutor.full_name;
        _this.recruiter_email = d.data.res.tutor.interviewer_info.interviewer_email;
      }
    });
  }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fillform_normal__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fillform_normal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__fillform_normal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fillform_pending__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fillform_pending___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fillform_pending__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      fillform: __WEBPACK_IMPORTED_MODULE_0__fillform_normal___default.a
    };
  },


  computed: {
    fillformStatus: function fillformStatus() {
      var status = this.$route.query.status;
      return status ? __WEBPACK_IMPORTED_MODULE_1__fillform_pending___default.a : __WEBPACK_IMPORTED_MODULE_0__fillform_normal___default.a;
    }
  },

  components: {
    fillformNormal: __WEBPACK_IMPORTED_MODULE_0__fillform_normal___default.a,
    fillformPending: __WEBPACK_IMPORTED_MODULE_1__fillform_pending___default.a
  }
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_reflect_delete_property__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_reflect_delete_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_reflect_delete_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_input_file__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_input_file___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_input_file__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_input_check_box__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_input_check_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_input_check_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__js__ = __webpack_require__(11);












var experienceData = {
  organization_name: {
    val: "",
    init: false
  },
  job_title: {
    val: "",
    init: false
  },
  period_teaching_experience: {
    val: "",
    init: false
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      state_change: false,
      state_loading: false,

      datas: {},
      checkboxInit: false,
      checkboxInit2: false,
      f_state: {
        inp1: false,
        inp2: false,
        inp4: false,
        inp5: false,
        inp6: false,
        inp7: false,
        inp8: false,
        inp9: false,
        inp10: false,
        inp11: false,
        inp12: false,

        inp16: false,
        inp17: false,
        inp18: false,
        inp19: false,
        inp20: false,
        checkbox: false,
        checkbox2: false
      },
      basic_info: {
        first_name: {
          val: "",
          init: false
        },
        last_name: {
          val: "",
          init: false
        },
        zoom_id: {
          val: "",
          init: false
        },
        country: {
          val: "",
          init: false
        },
        english_proficiency: {
          val: "",
          init: false
        },
        state: {
          val: "",
          init: false
        },
        city: {
          val: "",
          init: false
        },
        country_code: {
          val: "",
          init: false
        },
        phone_number: {
          val: "",
          init: false
        },
        time_zone: {
          val: "",
          init: false
        },
        educational_attainment: {
          val: "",
          init: false
        },
        school_name: {
          val: "",
          init: false
        },
        major: {
          val: "",
          init: false
        },

        teaching_experience: {
          val: [],
          init: false
        },

        desktop_or_laptop: {
          val: "",
          init: false
        },

        computer_purchase_year: {
          val: "",
          init: false
        },

        pc_type: {
          val: "",
          init: false
        }
      },

      teachingExperienceValMark: [],

      teachingExperience: {
        total_teaching_experience: {
          val: "",
          init: false
        },

        certification_tesol: {
          val: [],
          init: false,
          skip: true
        },
        certification_teyl: {
          val: [],
          init: false,
          skip: true
        },
        certification_other: {
          val: [],
          init: false,
          skip: true
        },
        teaching_experience_list: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js__["e" /* deepCopy */])(experienceData)]
      },
      channelStatus: false,
      total_teaching_experience: [],
      period_teaching_experience: [],
      educational_attainment: [],
      schoolNameSearchLanding: false,
      searchSchool: {},
      SchollNameVal: ""
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.axios.get("/Boarding/getTutor").then(function (d) {
      if (d.data.code == "75000") {
        if (d.data.res.info.source == 4 && d.data.res.info.source_details == 403) {
          _this.channelStatus = true;
        }
      }
    });

    this.axios.get("/common/getConfig").then(function (response) {
      if (response.data && response.data.code == "75000") {
        _this.datas = response.data.res;
        _this.total_teaching_experience = response.data.res.total_teaching_experience.filter(function (item) {
          return item.is_active == "ON";
        });
        _this.period_teaching_experience = response.data.res.period_teaching_experience.filter(function (item) {
          return item.is_active == "ON";
        });
        _this.educational_attainment = response.data.res.educational_attainment;
      }
    }, function () {
      console.log("service error");
    });

    this.$watch(function () {
      return this.basic_info.country.val;
    }, function (n, o) {
      var _this2 = this;

      var cache = this.datas["country"];
      this.basic_info.state.val = "";
      this.state_loading = true;

      this.axios.get("/common/getStatesByCountryId", {
        params: {
          country_id: this.basic_info.country.val
        }
      }).then(function (d) {
        if (d.data.code == 75000) {
          _this2.datas["country"] = {};
          _this2.datas["country"] = cache;
          _this2.datas["state"] = d.data.res;
          _this2.state_loading = false;
        }
      }, function () {
        console.log("error");
      });

      var country = this.basic_info.country.val;

      if (country == 1 || country == 2) {
        this.basic_info.country_code.val = "001";
      } else {
        this.basic_info.country_code.val = "";
      }
    });
  },

  methods: {
    teachingExperienceEdit: function teachingExperienceEdit(data, cb) {
      var _this3 = this;

      for (var key in data) {
        var item = data[key];
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js__["f" /* isArray */])(item)) {
          item.map(function (ele) {
            return _this3.teachingExperienceEdit(ele, cb);
          });
        } else {
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js__["g" /* isFunction */])(cb)) {
            cb(item);
          }
        }
      }
    },
    experienceDelete: function experienceDelete(index) {
      this.teachingExperience.teaching_experience_list.splice(index, 1);
    },
    experienceAdd: function experienceAdd() {
      this.teachingExperience.teaching_experience_list.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js__["e" /* deepCopy */])(experienceData));
    },
    mutexExperience: function mutexExperience() {
      var _this4 = this;

      var teachingExperienceVal = this.basic_info.teaching_experience.val;
      var teachingExperienceConfig = [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(this.teachingExperienceConfig));
      if (teachingExperienceConfig.length === 0) return;
      if (teachingExperienceVal.length > this.teachingExperienceValMark.length) {
        var increaseVal = teachingExperienceVal.filter(function (item) {
          return !_this4.teachingExperienceValMark.includes(item);
        })[0];

        if (increaseVal) {
          teachingExperienceConfig.map(function (item, index) {
            if (item.includes(increaseVal)) {
              teachingExperienceConfig.splice(index, 1);
            }
          });

          teachingExperienceConfig.map(function (item) {
            item.map(function (v) {
              var index = teachingExperienceVal.indexOf(v);
              if (index > -1) {
                teachingExperienceVal.splice(index, 1);
              }
            });
          });
        }
      }

      this.teachingExperienceValMark = [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(teachingExperienceVal));
    },
    form_result: function form_result() {
      var _this5 = this;

      var pass = true;
      this.isSubmit = true;

      if (!this.showTechnicalRequirements) {
        this.f_state.inp18 = true;
        this.f_state.inp19 = true;
        this.basic_info.computer_purchase_year.val = "";
        this.basic_info.pc_type.val = "";
      }

      for (var attr in this.basic_info) {
        if (this.basic_info[attr].val == "") {
          if (!this.showTechnicalRequirements && ["computer_purchase_year", "pc_type"].includes(attr)) {
            continue;
          }

          this.basic_info[attr].init = true;
        }
      }

      this.checkboxInit = true;
      this.checkboxInit2 = true;

      pass = !__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(this.f_state).includes(false);

      if (this.showFillExperience) {
        this.teachingExperienceEdit(this.teachingExperience, function (item) {
          return item.init = true;
        });

        pass = pass && this.teachingExperienceValidate;
      }

      if (!pass) return;

      var formdata = {};

      for (var _attr in this.basic_info) {
        formdata[_attr] = this.basic_info[_attr].val;
      }

      if (this.showFillExperience) {
        formdata.teaching_experience_list = [];
        for (var key in this.teachingExperience) {
          var item = this.teachingExperience[key];
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js__["f" /* isArray */])(item)) {
            item.map(function (ele) {
              var v = {};
              for (var k in ele) {
                v[k] = ele[k].val;
              }
              formdata.teaching_experience_list.push(v);
            });
          } else {
            formdata[key] = item.val;
          }
        }

        formdata.teaching_certification = {};

        ["certification_tesol", "certification_teyl", "certification_other"].forEach(function (key) {
          formdata.teaching_certification[key] = formdata[key].map(function (cert_code) {
            return {
              cert_code: cert_code,
              cert_url: ""
            };
          });

          __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_reflect_delete_property___default()(formdata, key);
        });
      }

      var loading = this.$loading();
      this.axios.post("/fillform/update", formdata).then(function (d) {
        loading.close();
        if (d.data.code == 75000) {
          var status = d.data.res.next;
          var exact_state = d.data.res.exact_state;
          if (status) {
            switch (status) {
              case "fillform":
                if (exact_state) {
                  _this5.$router.replace("/fillform?status=" + exact_state);
                  return;
                }

                _this5.$router.push("/fillform");
                break;
              case "interview":
                _this5.$router.replace("/book_interview?status=unassigned");
                break;
              case "pso":
                _this5.$router.push("/pso");
                break;
              case "ntt":
                _this5.$router.push("/ntt");
                break;
              case "onboarding":
                _this5.$router.push("/personal_profile/personal_qa");
                break;
              case "updatepwd":
                _this5.$router.push("/resetcode");
                break;
              default:
                _this5.$message.error("servers error.");
            }
          }
        } else {
          _this5.$message.error(d.data.message);
        }
      }).catch(function (err) {
        return loading.close();
      });
    },
    reciveMsg: function reciveMsg(msg) {
      this.f_state.checkbox = msg;
    },
    reciveMsg2: function reciveMsg2(msg) {
      this.f_state.checkbox2 = msg;
    },
    schoolSearch: function schoolSearch(val) {
      var _this6 = this;

      if (val !== "") {
        this.schoolNameSearchLanding = true;
        this.axios.get("/common/getUniversityList?name=" + val).then(function (d) {
          if (d.data.code == 75000) {
            _this6.searchSchool = d.data.res;
            _this6.schoolNameSearchLanding = false;
          }
        }, function () {
          console.log("error");
        });
      } else {
        this.searchSchool = {};
      }
    }
  },
  computed: {
    certification_show: function certification_show() {
      return this.datas.certification_tesol || this.datas.certification_teyl || this.datas.certification_other;
    },
    total_teaching_index: function total_teaching_index() {
      var total_teaching_experience = this.teachingExperience.total_teaching_experience.val;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.total_teaching_experience.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_step.value, 2),
              index = _step$value[0],
              value = _step$value[1];

          if (value.option_key === total_teaching_experience) {
            return index;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return -1;
    },

    teaching_certificate: {
      get: function get() {
        return this.teachingExperience.teaching_certificate.val;
      },
      set: function set(val) {
        var lastVal = val.slice(-1)[0];
        var key = "11";
        if (lastVal === key) {
          this.teachingExperience.teaching_certificate.val = [key];
        } else {
          var index = val.indexOf(key);
          if (index > -1) {
            val.splice(index, 1);
          }

          this.teachingExperience.teaching_certificate.val = val;
        }
      }
    },
    showTip: function showTip() {
      return this.showTechnicalRequirements && this.basic_info.computer_purchase_year.val === "2" && ["1", "2"].includes(this.basic_info.pc_type.val);
    },
    showTechnicalRequirements: function showTechnicalRequirements() {
      return this.basic_info.desktop_or_laptop.val === "1";
    },
    teachingExperienceValidate: function teachingExperienceValidate() {
      var res = true;
      this.teachingExperienceEdit(this.teachingExperience, function (item) {
        item.success = item.skip ? true : item.val instanceof Array ? item.val.length > 0 : item.val !== "";
        item.showFail = !item.success && item.init;

        if (!item.success) {
          res = item.success;
        }
      });

      return res;
    },
    teachingExperienceConfig: function teachingExperienceConfig() {
      if (!this.datas.teaching_experience) {
        return [];
      }

      var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.datas.teaching_experience);
      if (keys.length === 0) return [];
      return [keys.slice(0, 2), keys.slice(2)];
    },
    showFillExperience: function showFillExperience() {
      var teachingExperienceVal = this.basic_info.teaching_experience.val;
      var teachingExperienceConfig = this.teachingExperienceConfig;
      if (teachingExperienceVal.length === 0 || teachingExperienceConfig.length === 0) return false;
      return !teachingExperienceVal.includes(teachingExperienceConfig.slice(-1)[0][0]);
    },
    emp_obj: function emp_obj() {
      for (var i in this.datas.state) {
        return false;
      }
      return true;
    },
    inp12_complicated: function inp12_complicated() {
      return !(this.basic_info.major.val !== "") && this.basic_info.major.init;
    }
  },
  components: {
    "input-upload": __WEBPACK_IMPORTED_MODULE_6__common_input_file___default.a,
    checkBox: __WEBPACK_IMPORTED_MODULE_7__common_input_check_box___default.a
  },
  watch: {
    basic_info: {
      handler: function handler(o, n) {
        this.basic_info.first_name.val = this.basic_info.first_name.val.replace(/\W+/g, "").replace(/\_/g, "");
        this.basic_info.last_name.val = this.basic_info.last_name.val.replace(/\W+/g, "").replace(/\_/g, "");

        this.basic_info.phone_number.val = this.basic_info.phone_number.val.replace(/\D+/g, "");

        this.f_state.inp1 = !this.basic_info.first_name.val ? false : true;
        this.f_state.inp2 = !this.basic_info.last_name.val ? false : true;
        this.f_state.inp4 = !this.basic_info.country.val ? false : true;
        this.f_state.inp5 = !this.basic_info.state.val ? false : true;
        this.f_state.inp6 = !this.basic_info.city.val ? false : true;
        this.f_state.inp7 = !this.basic_info.country_code.val ? false : true;
        this.f_state.inp8 = !this.basic_info.phone_number.val ? false : true;
        this.f_state.inp9 = !this.basic_info.time_zone.val ? false : true;
        this.f_state.inp10 = !this.basic_info.educational_attainment.val ? false : true;
        this.f_state.inp11 = !this.basic_info.school_name.val ? false : true;
        this.f_state.inp12 = !(this.basic_info.major.val !== "") ? false : true;
        this.f_state.inp16 = this.basic_info.teaching_experience.val.length > 0;

        this.mutexExperience();

        this.f_state.inp17 = this.basic_info.desktop_or_laptop.val != "";
        this.f_state.inp18 = this.basic_info.computer_purchase_year.val != "";
        this.f_state.inp19 = this.basic_info.pc_type.val != "";
        this.f_state.inp20 = !this.basic_info.english_proficiency.val ? false : true;
      },
      deep: true
    }
  }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    status: {
      required: true,
      default: null
    }
  }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      wrong_state: '',
      email: '',
      wrong_words: ''
    };
  },

  methods: {
    next_reset: function next_reset() {
      var _this = this;
      _this.check_val();
      if (this.wrong_state !== false) return;
      this.axios.get('/index/verifybyemail', {
        params: {
          email: _this.email
        }
      }).then(function (response) {
        if (response.data && response.data.code == '75000') {
          _this.$router.push('forgot_password_step2');
        } else {
          _this.wrong_words = response.data.message;
          _this.wrong_state = true;
        }
      });
    },
    back_login: function back_login() {
      this.$router.go(-1);
    },
    check_val: function check_val() {
      var rule = this.email.match(/^(\w)+(\.\w+)*@(\w)+((\.\w{2,3}){1,3})$/g);
      var _this = this;
      if (!this.email) {
        this.wrong_state = true;
        this.wrong_words = "Please don't leave email address blank!";
      } else if (rule == null) {
        this.wrong_state = true;
        this.wrong_words = 'Email format is incorrect!';
      } else {
        window.localStorage.setItem('r_email', _this.email);
        this.wrong_state = false;
      }
    }
  }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      user_email: '',
      code: '',
      mis_state: '',
      mis_words: '测试数据'
    };
  },

  methods: {
    next_reset: function next_reset() {
      var _this = this;
      if (this.mis_state !== false) return;
      this.axios.get('/index/checkcode', {
        params: {
          email: _this.user_email,
          code: _this.code
        }
      }).then(function (response) {
        if (response.data && response.data.code == '75000') {
          window.localStorage.c_c = _this.code;

          _this.$router.push('forgot_password_step3');
        } else {
          _this.mis_state = true;
          _this.mis_words = response.data.message;
        }
      });
    },
    back_login: function back_login() {
      this.$router.go(-1);
    },
    check_code: function check_code() {
      if (!this.code) {
        this.mis_state = true;
        this.mis_words = 'Please enter the code you sent.';
      } else {
        this.mis_state = false;
      }
    }
  },
  beforeRouteEnter: function beforeRouteEnter(from, to, next) {
    next(function (vm) {
      vm.user_email = window.localStorage.r_email;
    });
  }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      init: false,
      focus_on: false,
      user_email: '',
      rpassword: '',
      password: '',
      init_status: {
        rule3: ''
      },
      notice: {
        words_3: ''
      },
      service_show: '',
      service_words: ''
    };
  },

  methods: {
    check_rcode: function check_rcode() {
      if (!this.rpassword) {
        this.notice.words_3 = "Please don't leave Your retyped password blank!.";
        this.init_status.rule3 = true;
      } else if (this.rpassword != this.password) {
        this.notice.words_3 = "The password you retyped doesn't match.";
        this.init_status.rule3 = true;
      } else {
        this.init_status.rule3 = false;
      }
    },
    next_reset: function next_reset() {
      var _this = this;
      this.init = true;
      this.check_rcode();
      var rule = this.passwordCheck.checkStatus && this.init_status.rule3 == false;

      if (!rule) return;

      var params = new URLSearchParams();

      var checkCode = window.localStorage.c_c ? window.localStorage.c_c : '';

      params.append('email', _this.user_email);

      params.append('password', _this.password);

      params.append('re_password', _this.rpassword);

      params.append('code', checkCode);

      this.axios.post('/index/resetpwd', params).then(function (response) {
        if (response && response.data.code == '75000') {
          _this.service_show = false;

          _this.$router.push('forgot_password_step4');
        } else {
          _this.service_words = response.data.message;

          _this.service_show = true;
        }
      });
    },
    back_login: function back_login() {
      this.$router.go(-1);
    },

    getClass: function getClass(type) {
      var passwordCheck = this.passwordCheck;
      if (passwordCheck.empty) return 'remind_normal';

      if (passwordCheck[type]) {
        return 'remind_pass';
      }

      return 'remind_wrong';
    }
  },
  computed: {
    show_off: function show_off() {
      if (!this.init) return;
      if (!this.focus_on && this.passwordCheck.checkStatus) return;

      return true;
    },

    passwordCheck: function passwordCheck() {
      var password = this.password;
      var empty = password === '';
      var type1 = password.length >= 8 && password.length <= 25;
      var type2 = password.search(/[a-z]/) > -1 && password.search(/[A-Z]/) > -1;
      var type3 = password.search(/[0-9]/) > -1;
      var type4 = /^[A-Za-z0-9\!\@\#\$\%\^\&\*\(\)\?\<\>\._-]*$/.test(password);

      return {
        type1: type1,
        type2: type2,
        type3: type3,
        type4: type4,
        checkStatus: type1 && type2 && type3 && type4,
        empty: empty
      };
    }
  },
  beforeRouteEnter: function beforeRouteEnter(from, to, next) {
    var params_arrys = [];
    var prams_c = [];
    next(function (vm) {
      if (window.localStorage.r_email) {
        vm.user_email = window.localStorage.r_email;
      } else {
        try {
          params_arrys = window.location.href.split('?')[1];
          prams_c = params_arrys.split('&');
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(prams_c), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var arr = _step.value;

              if (arr.split('=')[0] == 'email') {
                vm.user_email = arr.split('=')[1];
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        } catch (e) {}
      }
    });
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js__ = __webpack_require__(11);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      user_email: ''
    };
  },

  methods: {
    next_reset: function next_reset() {
      window.localStorage.removeItem('r_email');
      window.location.href = __WEBPACK_IMPORTED_MODULE_0__js__["a" /* urls */].ssoLogin;
    }
  }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_Calendar_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_Calendar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_Calendar_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rangeTime',
  components: {
    Calendar: __WEBPACK_IMPORTED_MODULE_0__common_Calendar_vue___default.a
  },
  data: function data() {
    return {
      calendar: {
        show: true,
        x: 0,
        y: 0,
        items: {
          type: 'date',
          begin: '',
          end: '',
          text: '',
          value: '',
          sep: '-',
          single: true,
          autoclose: true,
          weeks: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        }
      },
      datas: '',
      datas_time: '',
      time_zone: '',
      start_time: '',
      time_slot: {
        morning: [],
        afternoon: [],
        evening: []
      },
      book_cycles: '',
      select_time: '',
      status: '',
      time_hour: '',
      after_second: '',
      dayOne: true,
      addPixel: false,
      channelStatus: false
    };
  },


  created: function created() {
    var _this = this;

    this.axios.get('/Boarding/getTutor').then(function (d) {
      if (d.data.code == '75000') {
        if (d.data.res.info.source == 4 && d.data.res.info.source_details == 403) {
          _this.channelStatus = true;
        }
      }
    });
    this.$http.get('/register/getSourceAndSourceDetail').then(function (d) {
      if (d.data.code == '75000' && d.data.res.source_details == '403') {
        this.addPixel = true;
      }
    });

    this.$http.get('/common/getConfig?key=time_zone').then(function (response) {
      if (response.data.code == '75000') {
        this.datas_time = response.data.res;

        var time = new Date().getTime();
        var second = parseInt(time / 1000);
        this.start_time = second;

        this.$http.get('/interview/getInterViewTime?start_time=' + this.start_time + '&is_first=1').then(function (response) {
          if (response.data.code == '75000') {
            this.datas = response.data.res;
            if (this.datas.is_book) {

              this.book_cycles = this.datas.book_cycles;
              this.after_second = this.datas.after_second;

              var secondTime = (this.book_cycles * 1 - 1) * 24 * 60 * 60 * 1000;
              var start_day = new Date(this.datas.book_start_date).getTime();
              var endTime = new Date(start_day + secondTime);
              var year = endTime.getFullYear();
              var months = endTime.getMonth() + 1 < 10 ? '0' + (endTime.getMonth() + 1) : endTime.getMonth() + 1;
              var day = endTime.getDate() < 10 ? '0' + endTime.getDate() : endTime.getDate();
              this.calendar.items.end = year + '-' + months + '-' + day;

              console.log(this.datas.book_cycles, this.datas.book_start_date, this.calendar.items.end);

              this.calendar.items.begin = this.datas.book_start_date;
              this.calendar.items.value = this.datas.book_selected_date;
              this.calendar.items.text = this.datas.book_selected_date;

              this.calendar.show = false;
              this.calendar.show = true;

              this.time_zone = this.datas.selected_time_zone;
            } else if (this.datas.is_book == false) {
              this.$router.push('pending');
            }
          }
        }, function () {
          console.log('service error');
        });
      }
    }, function () {
      console.log('service error');
    });

    this.$watch(function () {
      return this.time_zone;
    }, function (o, n) {
      var time = new Date().getTime();
      var second = parseInt(time / 1000);
      this.start_time = second;

      this.$http.get('/interview/getInterViewTime?start_time=' + this.start_time + '&time_zone=' + this.time_zone + '&is_first=1').then(function (response) {
        if (response.data.code == '75000') {
          this.datas = response.data.res;
          if (this.datas.is_book) {
            var secondTime = (this.book_cycles * 1 - 1) * 24 * 60 * 60 * 1000;
            var start_day = new Date(this.datas.book_start_date).getTime();
            var endTime = new Date(start_day + secondTime);
            var year = endTime.getFullYear();
            var months = endTime.getMonth() + 1 < 10 ? '0' + (endTime.getMonth() + 1) : endTime.getMonth() + 1;
            var day = endTime.getDate() < 10 ? '0' + endTime.getDate() : endTime.getDate();
            this.calendar.items.end = year + '-' + months + '-' + day;
            this.calendar.items.begin = this.datas.book_start_date;
            this.calendar.items.value = this.datas.book_selected_date;
            if (this.calendar.items.text == this.datas.book_selected_date) {
              this.select_time = '';

              var _time = new Date().getTime();
              var _second = parseInt(_time / 1000);
              this.start_time = _second;

              var textAttr = void 0;
              var secondDate = void 0;
              var secondDates = void 0;

              if (this.calendar.items.text == this.calendar.items.begin) {
                secondDates = this.start_time * 1 + this.after_second * 1;
                console.log(this.after_second, this.start_time * 1, this.after_second * 1, secondDates);
              } else {
                textAttr = new Date(this.calendar.items.text + ' 00:00');
                secondDate = textAttr.getTime();
                secondDates = parseInt(secondDate / 1000);
              }
              console.log(secondDates);

              this.$http.get('/interview/getInterViewTime?start_time=' + secondDates + '&time_zone=' + this.time_zone + '&is_first=0&selected_date=' + this.calendar.items.text).then(function (response) {
                if (response.data.code == '75000') {
                  this.datas = response.data.res;
                  this.time_slot.morning = [];
                  this.time_slot.afternoon = [];
                  this.time_slot.evening = [];

                  if (this.datas.time_slot.length == 0) {
                    this.dayOne = false;
                  } else {
                    var getArr = function getArr(time_slot) {

                      var returnArr = {
                        morning: [],
                        afternoon: [],
                        evening: []
                      };
                      var typeArr = ['morning', 'afternoon', 'evening'];
                      typeArr.forEach(function (item) {
                        if (time_slot[item]) {
                          for (var i = 0; i < time_slot[item].length; i++) {
                            returnArr[item].push({
                              name: time_slot[item][i],
                              isActive: false
                            });
                          }
                        }
                      });
                      return returnArr;
                    };

                    this.dayOne = true;

                    this.time_slot = getArr(this.datas.time_slot);
                  }
                }
              }, function () {
                console.log('service error');
              });
            } else {
              this.calendar.items.text = this.datas.book_selected_date;
            }
            this.calendar.show = false;
            this.calendar.show = true;
          } else if (this.datas.is_book == false) {
            this.$router.push('pending');
          }
        }
      }, function () {
        console.log('service error');
      });
    });

    this.$watch(function () {
      return this.calendar.items.text;
    }, function (o, n) {
      this.select_time = '';

      var time = new Date().getTime();
      var second = parseInt(time / 1000);
      this.start_time = second;

      var textAttr = void 0;
      var secondDate = void 0;
      var secondDates = void 0;

      if (this.calendar.items.text == this.calendar.items.begin) {
        secondDates = this.start_time * 1 + this.after_second * 1;
        console.log(this.after_second, this.start_time * 1, this.after_second * 1, secondDates);
      } else {
        textAttr = new Date(this.calendar.items.text + ' 00:00');
        secondDate = textAttr.getTime();
        secondDates = parseInt(secondDate / 1000);
      }
      console.log(secondDates);

      this.$http.get('/interview/getInterViewTime?start_time=' + secondDates + '&time_zone=' + this.time_zone + '&is_first=0&selected_date=' + this.calendar.items.text).then(function (response) {
        if (response.data.code == '75000') {
          this.datas = response.data.res;
          this.time_slot.morning = [];
          this.time_slot.afternoon = [];
          this.time_slot.evening = [];

          if (this.datas.time_slot.length == 0) {
            this.dayOne = false;
          } else {
            var getArr = function getArr(time_slot) {

              var returnArr = {
                morning: [],
                afternoon: [],
                evening: []
              };
              var typeArr = ['morning', 'afternoon', 'evening'];
              typeArr.forEach(function (item) {
                if (time_slot[item]) {
                  for (var i = 0; i < time_slot[item].length; i++) {
                    returnArr[item].push({
                      name: time_slot[item][i],
                      isActive: false
                    });
                  }
                }
              });
              return returnArr;
            };

            this.dayOne = true;

            this.time_slot = getArr(this.datas.time_slot);
          }
        }
      }, function () {
        console.log('service error');
      });
    });
  },
  methods: {
    open: function open(e, type) {
      this.calendar.show = true;
      this.calendar.x = e.target.offsetLeft;
      this.calendar.y = e.target.offsetTop + e.target.offsetHeight + 8;
    },
    dateCancel: function dateCancel(obj) {
      this.calendar.show = obj.show;
    },
    dateOk: function dateOk(obj) {
      this.calendar.items.text = obj.values[0];
      this.calendar.items.value = obj.values[0];
    },

    addZero: function addZero(num) {
      num < 10 ? '0' + num : num;
    },
    MchoseFn: function MchoseFn(index, partTime) {
      for (var item in this.time_slot) {
        var arrItem = this.time_slot[item];
        for (var i = 0; i < arrItem.length; i++) {
          arrItem[i].isActive = false;
        }
      }
      var slotArr = this.time_slot;
      slotArr[partTime][index].isActive = !slotArr[partTime][index].isActive;
      this.select_time = slotArr[partTime][index].name;
      console.log(this.time_slot[partTime][index].isActive);
    },
    submitFn: function submitFn() {

      if (this.select_time == '') {
        this.$message.error('Please choose the interview time!');
        return;
      }

      var interview_time = this.calendar.items.value + ' ' + this.select_time;
      this.$http.get('/interview/reschedule' + '?interview_time=' + interview_time + '&time_zone=' + this.time_zone + '&type=I').then(function (d) {
        if (d.data.res = 75000) {
          this.$router.push('/interview?status=assigned');
        }
      }, function () {
        console.log('error');
      });
    }
  },
  computed: {
    disableDate: function disableDate() {
      '' + addZero(new Date().getFullYear()) + '-' + addZero(new Date().getMonth() + 1) + '-' + addZero(new Date().getDate());
    }
  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reschedule_vue__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reschedule_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__reschedule_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__other_CancelConfirm_vue__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__other_CancelConfirm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__other_CancelConfirm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__js__ = __webpack_require__(11);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  data: function data() {
    return {
      time_zone: '',
      t_id: '',
      interviewer_date: '',
      interviewer_origin_date: '',
      interviewer_name: '',
      interviewer_zoom: '',
      interviewer_email: '',
      options: '',
      need_help: '',
      interviewer: '',
      assigned: false,
      canceled: false,
      no_show: false,
      reschedule: false,
      full_name: '',
      reschedule_inner: '',
      reschedule_show1: false,
      reschedule_show2: false,
      canReschedule: false,
      urls: __WEBPACK_IMPORTED_MODULE_4__js__["a" /* urls */]
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.reschedule_show1 = false;
      var url = location.href;
      var urlStatus = void 0;
      urlStatus = url.split('=')[1];
      console.log(urlStatus);
      if (urlStatus == 'canceled') {
        vm.canceled = true;
        vm.reschedule_inner = 'Reschedule';
      } else if (urlStatus == 'no_show') {
        vm.$router.replace('/interview_result?status=noshow');
      } else if (urlStatus == 'rescheduled') {
        vm.reschedule_show1 = false;
        vm.reschedule = true;
        vm.reschedule_inner = 'Reschedule';
      }

      vm.$http.get('/common/getConfig?key=time_zone').then(function (d) {
        if (d.data.code == '75000') {
          this.options = d.data.res.time_zone;
        }
      });

      vm.$http.get('/interview/getTutorProfile?type=interview').then(function (d) {
        if (d.data.code == '75000') {
          var arrDate = d.data.res.tutor;
          vm.canReschedule = arrDate.reschedule_status == 1;

          vm.need_help = arrDate.interviewer_info.interviewer_email;
          vm.interviewer_date = arrDate.interviewer_date;
          vm.interviewer_origin_date = arrDate.interviewer_origin_date;
          vm.interviewer_name = arrDate.interviewer_info.interviewer_name;
          vm.interviewer_zoom = arrDate.interviewer_info.interviewer_zoom;
          vm.interviewer_email = arrDate.interviewer_info.interviewer_email;
          vm.full_name = arrDate.full_name;
          vm.interviewer = arrDate.interviewer;
          vm.time_zone = arrDate.appoint_time_zone;
          vm.t_id = arrDate.t_id;

          if (urlStatus == 'assigned') {
            if (vm.interviewer_date == '') {
              vm.reschedule_inner = 'Schedule';
              vm.$route.query.status = 'Schedule';
            } else {
              vm.reschedule_inner = 'Reschedule';
              vm.$route.query.status = 'Reschedule';
            }
          }
        }
      }, function () {
        console.log('service error');
      });
    });
  },

  methods: {
    showPop: function showPop() {
      if (!this.canReschedule) return;
      this.$store.commit('reschedule_pop_show');
    },
    cancel_apo: function cancel_apo() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, remark;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.canReschedule) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _context.next = 4;
                return _this.confirmOpen({
                  type: 'cancel'
                });

              case 4:
                _ref = _context.sent;
                remark = _ref.remark;


                _this.$http.get('/interview/cancelInterview?t_id=' + _this.t_id + '&remark=' + remark).then(function (d) {
                  if (d.data.res == '75000') {
                    _this.$message.success('Success!');
                    window.location.reload();
                  } else {
                    _this.$message.error(d.data.message);
                  }
                });

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    confirmOpen: function confirmOpen(data) {
      return this.$refs.cancelConfirm.open(data);
    }
  },
  components: {
    reschedule: __WEBPACK_IMPORTED_MODULE_2__reschedule_vue___default.a,
    CancelConfirm: __WEBPACK_IMPORTED_MODULE_3__other_CancelConfirm_vue___default.a
  },
  computed: {
    reschedule_show: function reschedule_show() {
      return this.$store.state.pop_up;
    }
  }
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	props: {},
	data: function data() {
		return {
			full_name: ''
		};
	},
	created: function created() {
		var _this = this;

		this.$http.get('/interview/getTutorProfile').then(function (d) {
			if (d.data.code = '75000') {
				_this.full_name = d.data.res.tutor.full_name;
			}
		});
	}
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Calendar__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_Calendar__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['timeZone', 'interviewerId', 'sureHandler', 'scheduledTimeZone', 'scheduledInterviewerDate'],
  data: function data() {
    return {
      calendar: {
        show: true,
        x: 0,
        y: 0,
        items: {
          type: 'date',
          begin: '',
          end: '',
          value: '',
          text: '',
          sep: '-',
          single: true,
          autoclose: true,
          weeks: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        }
      },
      time_zone: '',
      allow_time: [],
      datas: '',
      datasFn: true,
      dayOne: true,
      start_time: '',
      time_slot: {
        morning: [],
        afternoon: [],
        evening: []
      },
      book_cycles: '',
      select_time: '',
      staff_id: '',
      after_second: ''
    };
  },

  created: function created() {
    var time = new Date().getTime();
    var second = parseInt(time / 1000);
    this.start_time = second;
    this.$http.get('/interview/getInterViewTime?start_time=' + this.start_time + '&is_first=1').then(function (response) {
      if (response.data.code == '75000') {
        this.datas = response.data.res;
        if (this.datas.is_book) {
          this.book_cycles = this.datas.book_cycles;
          var secondTime = (this.book_cycles * 1 - 1) * 24 * 60 * 60 * 1000;
          var start_day = new Date(this.datas.book_start_date).getTime();
          var endTime = new Date(start_day + secondTime);
          var year = endTime.getFullYear();
          var months = endTime.getMonth() + 1 < 10 ? '0' + (endTime.getMonth() + 1) : endTime.getMonth() + 1;
          var day = endTime.getDate() < 10 ? '0' + endTime.getDate() : endTime.getDate();
          this.calendar.items.end = year + '-' + months + '-' + day;
          this.calendar.show = false;
          this.calendar.show = true;

          this.calendar.items.begin = this.datas.book_start_date;
          this.calendar.items.value = this.datas.book_selected_date;
          this.calendar.items.text = this.datas.book_selected_date;
        } else if (this.datas.is_book == false) {
          this.datasFn = false;
        }
      }
    }, function () {
      console.log('service error');
    });


    this.$watch(function () {
      return this.is_request;
    }, function (o, n) {
      if (this.is_request) {
        this.staff_id = this.interviewerId;

        var _time = new Date().getTime();
        var _second = parseInt(_time / 1000);
        this.start_time = _second;
        this.$http.get('/interview/getInterViewTime?start_time=' + this.start_time + '&is_first=1&staff_id=' + this.staff_id).then(function (response) {
          if (response.data.code == '75000') {
            this.datas = response.data.res;
            if (this.datas.is_book) {
              this.after_second = this.datas.after_second;
              this.book_cycles = this.datas.book_cycles;

              this.calendar.show = false;
              this.calendar.show = true;

              this.time_zone = this.datas.selected_time_zone;
            } else if (this.datas.is_book == false) {
              this.datasFn = false;
            }
          }
        }, function () {
          console.log('service error');
        });
      }
    });

    this.$watch(function () {
      return this.time_zone;
    }, function (o, n) {
      var time = new Date().getTime();
      var second = parseInt(time / 1000);
      this.start_time = second;

      this.$http.get('/interview/getInterViewTime?start_time=' + this.start_time + '&is_first=1&time_zone=' + this.time_zone + '&staff_id=' + this.staff_id).then(function (response) {
        if (response.data.code == '75000') {
          this.datas = response.data.res;
          if (this.datas.is_book) {
            console.log(this.datas.is_book);

            this.book_cycles = this.datas.book_cycles;
            var secondTime = (this.book_cycles * 1 - 1) * 24 * 60 * 60 * 1000;
            var start_day = new Date(this.datas.book_start_date).getTime();
            var endTime = new Date(start_day + secondTime);
            var year = endTime.getFullYear();
            var months = endTime.getMonth() + 1 < 10 ? '0' + (endTime.getMonth() + 1) : endTime.getMonth() + 1;
            var day = endTime.getDate() < 10 ? '0' + endTime.getDate() : endTime.getDate();
            this.calendar.items.end = year + '-' + months + '-' + day;
            this.calendar.items.begin = this.datas.book_start_date;
            this.calendar.items.value = this.datas.book_selected_date;
            if (this.calendar.items.text == this.datas.book_selected_date) {
              this.select_time = '';

              var _time2 = new Date().getTime();
              var _second2 = parseInt(_time2 / 1000);
              this.start_time = _second2;

              var textAttr = void 0;
              var secondDate = void 0;
              var secondDates = void 0;

              if (this.calendar.items.text == this.calendar.items.begin) {
                secondDates = this.start_time + this.after_second;
              } else {
                textAttr = new Date(this.calendar.items.text + ' 00:00');
                secondDate = textAttr.getTime();
                secondDates = parseInt(secondDate / 1000);
              }

              this.$http.get('/interview/getInterViewTime?start_time=' + secondDates + '&time_zone=' + this.time_zone + '&is_first=0&staff_id=' + this.staff_id + '&selected_date=' + this.calendar.items.text).then(function (response) {
                if (response.data.code == '75000') {
                  this.datas = response.data.res;
                  this.allow_time = [];
                  if (this.datas.time_slot.length == 0) {
                    this.dayOne = false;
                  } else {
                    var getArr = function getArr(time_slot) {
                      var returnArr = [];
                      var typeArr = ['morning', 'afternoon', 'evening'];
                      typeArr.forEach(function (item) {
                        if (time_slot[item]) {
                          for (var i = 0; i < time_slot[item].length; i++) {
                            returnArr.push({
                              name: time_slot[item][i],
                              isActive: false
                            });
                          }
                        }
                      });
                      return returnArr;
                    };

                    this.dayOne = true;

                    this.allow_time = getArr(this.datas.time_slot);
                  }
                }
              }, function () {
                console.log('service error');
              });
            } else {
              this.calendar.items.text = this.datas.book_selected_date;
            }
            this.calendar.show = false;
            this.calendar.show = true;
          } else if (this.datas.is_book == false) {
            this.datasFn = false;
          }
        }
      }, function () {
        console.log('service error');
      });
    });

    this.$watch(function () {
      return this.calendar.items.text;
    }, function (o, n) {
      this.select_time = '';

      var time = new Date().getTime();
      var second = parseInt(time / 1000);
      this.start_time = second;

      var textAttr = void 0;
      var secondDate = void 0;
      var secondDates = void 0;

      if (this.calendar.items.text == this.calendar.items.begin) {
        secondDates = this.start_time + this.after_second;
      } else {
        textAttr = new Date(this.calendar.items.text + ' 00:00');
        secondDate = textAttr.getTime();
        secondDates = parseInt(secondDate / 1000);
      }

      this.$http.get('/interview/getInterViewTime?start_time=' + secondDates + '&time_zone=' + this.time_zone + '&is_first=0&staff_id=' + this.staff_id + '&selected_date=' + this.calendar.items.text).then(function (response) {
        if (response.data.code == '75000') {
          this.datas = response.data.res;
          this.allow_time = [];
          if (this.datas.time_slot.length == 0) {
            this.dayOne = false;
          } else {
            var getArr = function getArr(time_slot) {
              var returnArr = [];
              var typeArr = ['morning', 'afternoon', 'evening'];
              typeArr.forEach(function (item) {
                if (time_slot[item]) {
                  for (var i = 0; i < time_slot[item].length; i++) {
                    returnArr.push({
                      name: time_slot[item][i],
                      isActive: false
                    });
                  }
                }
              });
              return returnArr;
            };

            this.dayOne = true;

            this.allow_time = getArr(this.datas.time_slot);
          }
        }
      }, function () {
        console.log('service error');
      });
    });
  },
  methods: {
    isTimeDisable: function isTimeDisable(time) {
      if (!this.scheduledTimeZone || !this.time_zone) return;
      var scheduledTimeZone = this.timeZone[this.scheduledTimeZone];
      if (!scheduledTimeZone) return;
      if (scheduledTimeZone != this.time_zone) return;

      if (!this.scheduledInterviewerDate) return;

      var _scheduledInterviewer = this.scheduledInterviewerDate.split(' '),
          _scheduledInterviewer2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_scheduledInterviewer, 2),
          scheduled_date = _scheduledInterviewer2[0],
          scheduled_time = _scheduledInterviewer2[1];

      return scheduled_date === this.calendar.items.value && scheduled_time.split(':').slice(0, 2).join(':') === time.name;
    },
    close: function close() {
      this.$store.commit('reschedule_pop_show');
    },
    open: function open(e, type) {
      this.calendar.show = true;
      this.calendar.x = e.target.offsetLeft;
      this.calendar.y = e.target.offsetTop + e.target.offsetHeight + 8;
    },
    dateCancel: function dateCancel(obj) {
      this.calendar.show = obj.show;
    },
    dateOk: function dateOk(obj) {
      this.calendar.items.text = obj.values[0];
      this.calendar.items.value = obj.values[0];
    },

    addZero: function addZero(num) {
      num < 10 ? '0' + num : num;
    },
    choseFn: function choseFn(index, disable) {
      if (disable) return;

      for (var i = 0; i < this.allow_time.length; i++) {
        this.allow_time[i].isActive = false;
      }
      this.allow_time[index].isActive = !this.allow_time[index].isActive;
      this.select_time = this.allow_time[index].name;
      console.log(this.select_time, this.allow_time[index].isActive);
    },
    submitFn: function submitFn() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var sureHandlerRes, isRemark, interview_time;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.select_time == '')) {
                  _context.next = 3;
                  break;
                }

                _this.$message.error('Please choose the interview time!');
                return _context.abrupt('return');

              case 3:
                sureHandlerRes = void 0;
                isRemark = void 0;

                if (!_this.sureHandler) {
                  _context.next = 10;
                  break;
                }

                isRemark = _this.$store.state.loginStatus.exact_status !== "canceled";
                _context.next = 9;
                return _this.sureHandler({
                  type: 'reschedule',
                  isRemark: isRemark
                });

              case 9:
                sureHandlerRes = _context.sent;

              case 10:
                interview_time = _this.calendar.items.value + ' ' + _this.select_time;


                _this.$http.get('/interview/reschedule' + '?interview_time=' + interview_time + '&time_zone=' + _this.time_zone + '&type=R' + (isRemark ? '&remark=' + sureHandlerRes.remark : '')).then(function (d) {
                  if (d.data.res = 75000) {
                    window.location.reload();
                  }
                }, function () {
                  console.log('error');
                });

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  computed: {
    window_size: function window_size() {
      return {
        width: window.outerWidth,
        height: window.outerHeight
      };
    },

    disableDate: function disableDate() {
      '' + addZero(new Date().getFullYear()) + '-' + addZero(new Date().getMonth() + 1) + '-' + addZero(new Date().getDate());
    },
    is_request: function is_request() {
      return this.$store.state.pop_up;
    }
  },
  components: {
    Calendar: __WEBPACK_IMPORTED_MODULE_3__common_Calendar___default.a
  }
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  data: function data() {
    return {
      full_name: '',
      recruiter_email: ''
    };
  },

  created: function created() {
    var _this = this;

    this.$http.get('/interview/getTutorProfile').then(function (d) {
      if (d.data.code == '75000') {
        _this.full_name = d.data.res.tutor.full_name;
        _this.recruiter_email = d.data.res.tutor.interviewer_info.interviewer_email;
      }
    });
  }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  data: function data() {
    return {
      datas: '',
      dataShow: '',
      basic_info: {
        first_name: '',
        last_name: '',
        nick_name: '',
        birthday: '',
        country_code: '',
        mobile: '',
        zoom_id: '',
        city: '',
        street: '',
        z_code: '',
        skype_id: '',
        pic: '',
        pc_type: ''
      },
      selects: {
        pc_type: [{
          value: '1',
          label: 'Mac'
        }, {
          value: '2',
          label: 'Windows'
        }]
      },
      selectShow: {
        country: '',
        time_zone: ''
      },
      changeShow: {
        state: ''
      },
      background: [],
      interests: []
    };
  },

  created: function created() {
    var _this = this;

    this.$http.get('/common/getConfig').then(function (response) {
      if (response.data && response.data.code == '75000') {
        _this.datas = response.data.res;
        this.$http.get('/Boarding/getTutor').then(function (response) {
          if (response.data && response.data.code == '75000') {
            this.dataShow = response.data.res.info;

            for (var item in this.basic_info) {
              this.basic_info[item] = this.dataShow[item];
              if (this.dataShow.pc_type == '1') {
                this.basic_info.pc_type = 'Mac';
              } else if (this.dataShow.pc_type == '2') {
                this.basic_info.pc_type = 'Windows';
              } else if (this.dataShow.pc_type == '0') {
                this.basic_info.pc_type = '';
              }
            }

            for (var key in this.selectShow) {
              var naCode = this.dataShow[key];
              var arrCode = this.datas[key];
              if (naCode <= 0) {
                this.selectShow[key] = '';
              } else if (naCode > 0) {
                this.selectShow[key] = arrCode[naCode];
              }
            }
            _this.background = this.objBgActiveFn;
            _this.interests = this.objInterestsFn;
            this.$http.get('/common/getStatesByCountryId' + '?country_id=' + _this.dataShow.country).then(function (d) {
              if (d.data.code = 75000) {
                var stateShow = d.data.res;
                _this.changeShow.state = stateShow[this.dataShow.state];
              }
            }, function () {
              console.log('error');
            });
          }
        }, function () {
          console.log('service error');
        });
      }
    }, function () {
      console.log('service error');
    });
  },
  methods: {},
  computed: {
    objBgActiveFn: function objBgActiveFn() {
      var objBgActive = [];
      if (this.dataShow.background == '') {
        objBgActive = [];
      } else if (this.dataShow.background != '') {
        var arrBg = this.dataShow.background.split(',');

        for (var item in arrBg) {
          var key = arrBg[item];
          objBgActive.item = {
            name: this.datas.background[key]
          };
          objBgActive.push(objBgActive.item);
        }
      }
      return objBgActive;
    },
    objInterestsFn: function objInterestsFn() {
      var objBgActive = [];
      if (this.dataShow.interests == '') {
        objBgActive = [];
      } else if (this.dataShow.interests != '') {
        var arrBg = this.dataShow.interests.split(',');
        for (var item in arrBg) {
          var key = arrBg[item];
          objBgActive.item = {
            name: this.datas.interests[key]
          };
          objBgActive.push(objBgActive.item);
        }
      }
      return objBgActive;
    }
  }
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_input_file_vue__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_input_file_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_input_file_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_basePath__ = __webpack_require__(71);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      file: '',
      up_loading: false,
      msg_json: {
        title: '1. Upload introductory audio',
        list: ['This recording will be used for your students to get a better idea of who you are.', "You can use this recording to introduce yourself, where you're from, and share your teaching experience, hobbies, and interests.", 'Please be sure that the recording is 30 seconds or less.'],
        title_self: '2. Submit your self-introduction',
        list_self: ['The introduction will be translated to Chinese and will be visible to the students, so please be spontaneous. ', 'You may include personal interests not included in the audio or other reasons why students should choose you as their teacher. ', 'Limit is 1000 characters.']
      },
      init_width: '377',
      words: ' audio format / less than 10MB  ＊',
      has_audio: '',
      self_intor: '',
      self_intor2: '',
      self_nub: '0',
      self_br: false,
      self_y: false,
      audioSrc: ''
    };
  },

  components: {
    inputUpload: __WEBPACK_IMPORTED_MODULE_0__common_input_file_vue___default.a
  },
  created: function created() {
    var _this2 = this;

    this.$http.get('/Boarding/getTutor').then(function (d) {
      if (d.data.code == '75000') {
        if (d.data.res.info.audio) {
          _this2.words = d.data.res.info.audio;
        }

        _this2.self_intor = d.data.res.info.desc || '';
      }
    });
  },

  methods: {
    beforeUpload: function beforeUpload(file) {
      var isDoc = file.type.indexOf('audio') > -1;

      var isLt10M = file.size / 1024 / 1024 < 10;

      if (!isDoc) {
        this.$message.error('The file format is wrong.');
      }

      if (!isLt10M) {
        this.$message.error('The audio size should be less than 10MB.');
      }
      if (isDoc && isLt10M) {
        this.up_loading = true;
      }

      return isDoc && isLt10M;
    },
    upload_s_fn: function upload_s_fn(response, file, fileList) {
      if (response.code == 75000) {
        this.$message.success('Congratulations, upload success!');
        this.up_loading = false;
        this.file = response.res.url;
        this.words = file.name;
      } else {
        this.up_loading = false;
        this.$message.error('Upload failed. Please try it again.');
      }
    },
    submit: function submit() {
      if (!this.has_audio || this.self_intor === '') return;
      var params = new URLSearchParams();
      var _this = this;
      this.file = this.file ? this.file : this.words;
      if (!this.file) return;
      if (!this.self_y) {
        this.$message.error('Please provide your self-introduction.');
        return;
      }
      if (this.self_br) {
        this.$message.error('The limit for your self-introduction is 1000 characters.');
        return;
      }
      var file_params = {
        audio: this.file,
        talk_desc: this.self_intor
      };
      for (var attr in file_params) {
        params.append(attr, file_params[attr]);
      }
      this.self_intor2 = this.self_intor;
      this.axios.post('/Boarding/upIntroductory', params).then(function (response) {
        if (response && response.data.code == '75000') {
          _this.$message.success('save success.');
          _this.$router.replace('/personal_profile/sign_sa');
        } else {
          _this.$message.error(response.data.message);
        }
      });
    },
    offShadow: function offShadow() {
      this.audioSrc = '';
    }
  },
  computed: {
    action: function action() {
      return __WEBPACK_IMPORTED_MODULE_1__api_basePath__["a" /* default */] + '/Fileupload/uploadToHkOss';
    }
  },
  watch: {
    self_intor: {
      handler: function handler(o, n) {
        ;this.self_nub = this.self_intor.length > this.self_nub ? this.self_intor.length : this.self_intor.length, this.self_y = this.self_intor.length > 0 ? true : false;
      },
      deep: true
    },
    self_nub: {
      handler: function handler(o, n) {
        this.self_br = this.self_nub > 1000 ? true : false;
      },
      deep: true
    },
    words: {
      handler: function handler(o, n) {
        this.has_audio = !this.words ? false : true;
      },
      deep: true
    }
  }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_file_upload__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_file_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_file_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_upload_img__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_upload_img___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_upload_img__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_input_check_box__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_input_check_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_input_check_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_basePath__ = __webpack_require__(71);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  data: function data() {
    return {
      paymentShow: '',
      paymentM: '',
      isCheck: false,
      isCheckT: true,
      isChange: false,
      curIdx: '',
      paypal: '',
      inp1: false,
      paymode: '',
      basic_info: {
        first_name: '',
        bank_num: '',
        bank_name: '',
        bank_state: '',
        bank_city: '',
        bank_branch: '',
        b_info: '',
        routing_swift_code: '',
        inter_bank: '',
        inter_code: '',
        routing_num: '',
        infor: '',
        valid_id: ''
      },
      f_state: {
        inp2: false,
        inp3: false,
        inp4: false,
        inp5: false,
        inp6: false,
        inp7: false,
        inp8: false,
        inp9: false
      },
      imgUrl: '',
      typeCode: '',
      typeCodeTxt: '',
      fullscreenLoading: false
    };
  },

  created: function created() {
    this.$http.get('/Boarding/getTutor?key=bank').then(function (response) {
      if (response.data && response.data.code == '75000') {
        this.paymentShow = response.data.res.info || {};
        for (var item in this.basic_info) {
          this.basic_info[item] = this.paymentShow[item] || '';
        }

        this.typeCode = this.basic_info.routing_swift_code ? '0' : '1';
        this.typeCodeTxt = this.basic_info.routing_swift_code ? this.basic_info.routing_swift_code : this.basic_info.routing_num;

        this.paypal = this.paymentShow.paypal;
        if (this.paymentShow.paymode == 2 || this.paymentShow.paymode == 3) {
          this.isCheck = true;
        }
      }
    }, function () {
      console.log('service error');
    });
  },
  components: {
    checkBox: __WEBPACK_IMPORTED_MODULE_2__common_input_check_box___default.a,
    uploadImg: __WEBPACK_IMPORTED_MODULE_1__common_upload_img___default.a,
    fileUpload: __WEBPACK_IMPORTED_MODULE_0__common_file_upload___default.a
  },
  computed: {
    action: function action() {
      return __WEBPACK_IMPORTED_MODULE_3__api_basePath__["a" /* default */] + '/Fileupload/uploadToHkOss';
    }
  },
  methods: {
    b_upload: function b_upload(file, event) {
      var isJPG = file.type === 'image/jpeg' || file.type === 'image/png';

      var isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('Upload avatar image can only be JPG and PNG format!');
      }
      if (!isLt2M) {
        this.$message.error('Upload avatar picture size no more than 2 MB.');
      }
      if (isJPG && isLt2M) {
        this.fullscreenLoading = true;
      }
      return isJPG && isLt2M;
    },

    proof_up_s_fn: function proof_up_s_fn(response, file) {
      if (response.code == 75000) {
        this.$message.success('Congratulations, upload success!');

        this.imgUrl = response.res.url;

        this.basic_info.valid_id = response.res.url;
      } else {
        this.$message.error('service error');
      }
      this.fullscreenLoading = false;
    },
    overtimeFn: function overtimeFn() {
      this.fullscreenLoading = false;
    },

    changeCheck: function changeCheck(isCheck) {
      this.isCheck = isCheck;
    },
    paypalFn: function paypalFn(isCheck) {
      this.isCheckT = isCheck;
    },
    changeActive: function changeActive(index) {
      this.curIdx = index;
    },
    saveBankFn: function saveBankFn() {
      var _this2 = this;

      var formdata = new URLSearchParams();
      var pass = false;
      var _this = this;
      if (this.isCheck && this.isCheckT) {

        this.paymode = '3';
        for (var opt in this.f_state) {
          console.log(opt + ':' + this.f_state[opt]);
          if (this.f_state[opt] && this.inp1) {
            pass = true;
          } else {
            pass = false;
            break;
          }
        }
        console.log('pass:' + pass);
        if (!pass) return;
        for (var attr in this.basic_info) {
          formdata.append(attr, this.basic_info[attr]);
        }
        formdata.append('paypal', this.paypal);
        if (!this.basic_info.valid_id) {
          this.$message.error('Please upload Valid ID with Picture.');
          return;
        }
      } else if (this.isCheck) {

        this.paymode = '2';
        for (var opt in this.f_state) {
          if (this.f_state[opt]) {
            pass = true;
          } else {
            pass = false;
            break;
          }
        }
        if (!pass) return;
        for (var _attr in this.basic_info) {
          formdata.append(_attr, this.basic_info[_attr]);
        }
        if (!this.basic_info.valid_id) {
          this.$message.error('Please upload Valid ID with Picture.');
          return;
        }
      } else if (this.isCheckT) {
        this.paymode = '1';
        if (this.inp1) {
          pass = true;
        } else {
          pass = false;
        }
        if (!pass) return;
        formdata.append('paypal', this.paypal);
      } else if (!this.isCheck && !this.isCheckT) {
        _this.$message.error('Please select payment type!');
        return;
      }

      formdata.append('paymode', this.paymode);

      this.$confirm('By clicking OK you declare that the bank details provided are true and correct to your best of your knowledge.', 'notice', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(function () {
        _this2.axios.post('/Boarding/addPaymode', formdata).then(function (d) {
          if (d.data.code == 75000) {
            _this.$message.success('save success.');
            _this.$router.replace('/personal_profile/on_board');
          }
        }, function () {
          _this.$message.error('service error');
        });
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: 'cancel'
        });
      });
    }
  },
  watch: {
    basic_info: {
      handler: function handler(o, n) {
        this.basic_info.first_name = this.basic_info.first_name.replace(/[^a-zA-z0-9\s]+/g, '').replace(/\^/g, '');
        this.f_state.inp2 = !this.basic_info.first_name ? false : true;
        this.f_state.inp3 = !this.basic_info.bank_num ? false : true;
        this.f_state.inp4 = !this.basic_info.bank_name ? false : true;
        this.f_state.inp5 = !this.basic_info.bank_branch ? false : true;
        this.f_state.inp6 = !this.basic_info.bank_state ? false : true;
        this.f_state.inp7 = !this.basic_info.bank_city ? false : true;
        this.f_state.inp8 = this.basic_info.routing_swift_code || this.basic_info.routing_num ? true : false;
        this.f_state.inp9 = !this.basic_info.b_info ? false : true;
      },
      deep: true
    },
    paypal: {
      handler: function handler(o, n) {
        this.inp1 = !this.paypal ? false : true;
      },
      deep: true
    },
    typeCodeTxt: function typeCodeTxt(o, n) {
      if (this.typeCode === '0') {
        this.basic_info.routing_swift_code = o;
        this.basic_info.routing_num = '';
      } else if (this.typeCode === '1') {
        this.basic_info.routing_num = o;
        this.basic_info.routing_swift_code = '';
      }
    }
  }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_upload_img__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_upload_img___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_upload_img__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_image_crop_upload_upload_2_vue__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_image_crop_upload_upload_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_image_crop_upload_upload_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_basePath__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_file_upload__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_file_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_file_upload__);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  components: {
    uploadImg: __WEBPACK_IMPORTED_MODULE_1__common_upload_img___default.a,
    'my-upload': __WEBPACK_IMPORTED_MODULE_2_vue_image_crop_upload_upload_2_vue___default.a,
    fileUpload: __WEBPACK_IMPORTED_MODULE_4__common_file_upload___default.a
  },
  data: function data() {
    return {
      state_change: false,
      datas: '',
      dataShow: '',
      message: 'This is required.',
      great: false,
      f_state: {
        inp1: false,
        inp2: false,
        inp3: true,
        inp4: false,
        inp5: false,
        inp6: false,
        inp7: false,
        inp8: false,
        inp9: false,
        inp10: false,
        inp11: false,
        inp12: false,
        inp13: false,
        inp14: false,
        inp15: false,
        inp16: false
      },
      basic_info: {
        first_name: '',
        last_name: '',

        birthday: '',
        on_boarding_is_legal: '',
        country_code: '',
        mobile: '',
        zoom_id: '',
        time_zone: '',
        country: '',
        state: '',
        city: '',
        street: '',
        z_code: '',
        pc_type: '',
        pic: '',
        background: [],
        interests: [],
        valid_ids_url: ''
      },
      background: [],
      interests: [],
      i: 0,
      state_num: '',
      show: false,
      imgDataUrl: '',
      english_proficiency: ''
    };
  },

  created: function created() {
    console.log(this.f_state.inp4);

    var _this = this;

    this.$http.get('/common/getConfig').then(function (response) {
      if (response.data && response.data.code == '75000') {
        _this.datas = response.data.res;
        _this.background = this.objBgActiveFn;
        _this.interests = this.objInterestsFn;

        this.$http.get('/Boarding/getTutor').then(function (response) {
          if (response.data && response.data.code == '75000') {
            console.log(response.data.res.info);
            this.dataShow = response.data.res.info;
            this.english_proficiency = response.data.res.info.english_proficiency;
            var showStr = this.dataShow.interests;
            var showStrB = this.dataShow.background;
            var arrShowB = [];
            var arrShow = [];
            if (showStr) {
              arrShow = showStr.split(',');
            }
            if (showStrB) {
              arrShowB = showStrB.split(',');
            }

            for (var item in this.basic_info) {
              if (item == 'background') {
                this.basic_info.background = arrShowB;
              } else if (item == 'interests') {
                this.basic_info.interests = arrShow;
              } else if (this.dataShow[item] <= '0') {
                this.basic_info[item] = '';
              } else {
                this.basic_info[item] = this.dataShow[item];
                console.log(this.dataShow[item]);
              }
            }

            if (this.basic_info.pic != '') {
              this.f_state.inp15 = true;
            }

            if (showStrB) {
              for (var i = 0; i < arrShowB.length; i++) {
                for (var item in this.background) {
                  if (this.background[item].num == arrShowB[i]) {
                    this.background[item].isActive = true;
                  }
                }
              }
            }
            if (showStr) {
              for (var i = 0; i < arrShow.length; i++) {
                for (var item in this.interests) {
                  if (this.interests[item].num == arrShow[i]) {
                    this.interests[item].isActiveIn = true;
                  }
                }
              }
            }
          }
        }, function () {
          console.log('service error');
        });
      }
    }, function () {
      console.log('service error');
    });

    this.$watch(function () {
      return this.basic_info.country;
    }, function (n, o) {
      var cache = this.datas['country'];
      this.basic_info.state = '';
      this.i++;
      this.$http.get('/common/getStatesByCountryId' + '?country_id=' + _this.basic_info.country).then(function (d) {
        if (d.data.code = 75000) {
          this.datas['country'] = {};
          this.datas['country'] = cache;
          this.datas['state'] = d.data.res;

          if (this.dataShow.state && this.i == 1) {
            if (this.dataShow.state == '0') {
              this.basic_info.state = '';
            } else {
              for (var item in d.data.res) {
                if (this.dataShow.state == d.data.res[item]) {
                  this.basic_info.state = item;
                  this.state_num = d.data.res[item];
                  console.log(this.basic_info.state, this.state_num);
                }
              }
            }
          }

          this.state_change = d.data.res.length == 0 ? false : true;
        }
      }, function () {
        console.log('error');
      });
    });
  },
  methods: {
    upload_id: function upload_id(response, file, idx, attr) {
      if (response.code == 75000) {
        this.$message.success('Congratulations, upload success!');
        this.basic_info.valid_ids_url = response.res.url;
      } else {
        this.$message.error('service error');
      }
    },
    b_upload: function b_upload(file, event) {
      var isJPG = file.type === 'image/jpeg' || file.type === 'image/png';

      var isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('Upload avatar image can only be JPG and PNG format!');
      }
      if (!isLt2M) {
        this.$message.error('Upload avatar picture size no more than 2 MB.');
      }
      return isJPG && isLt2M;
    },

    inActive: function inActive(index, typeIn, isTrue) {
      this[typeIn][index][isTrue] = !this[typeIn][index][isTrue];
      if (this[typeIn][index][isTrue]) {
        this.basic_info[typeIn].push(this[typeIn][index].num);
      } else {
        var arrIndex = this.basic_info[typeIn].indexOf(this[typeIn][index].num);
        this.basic_info[typeIn].splice(arrIndex, 1);
      }
      console.log(this.basic_info[typeIn]);
    },
    upload_img: function upload_img(res, file) {
      this.$message.success(' Upload successful！');
      this.f_state.inp15 = true;
      this.basic_info.pic = res.res.url;
    },
    beforeUploadImg: function beforeUploadImg(file) {
      var isJPG = file.type === 'image/jpeg' || file.type === 'image/png';

      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('The profile picture format should be JPG or PNG.');
      }
      if (!isLt2M) {
        this.$message.error('The profile picture size should be less than 2 MB.');
      }
      this.f_state.inp15 = false;
      return isJPG && isLt2M;
    },

    detectFn: function detectFn() {
      var _this = this;
      var formdata = new URLSearchParams();
      if (_this.basic_info.nick_name == '') return;
      formdata.append('nick_name', _this.basic_info.nick_name);
      this.axios.post('/Boarding/checkName', formdata).then(function (d) {
        if (d.data.code == 75070) {
          _this.message = d.data.message;
          _this.great = true;
          _this.f_state.inp3 = true;
        } else if (d.data.code == 75071) {
          _this.message = d.data.message;
          _this.great = false;
          _this.f_state.inp3 = false;
        }
      });
    },
    saveFn: function saveFn() {
      console.log(this.f_state.inp4, this.basic_info.birthday);
      var pass = false;
      var _this = this;
      var formdata = new URLSearchParams();
      for (var opt in this.f_state) {
        console.log(this.f_state[opt], opt);
        if (this.f_state[opt]) {
          pass = true;
        } else {
          pass = false;
          break;
        }
      }

      if (!pass) return;
      if (typeof this.basic_info.state == 'string') {
        this.basic_info.state = this.state_num;
      }

      for (var attr in this.basic_info) {
        formdata.append(attr, _this.basic_info[attr]);
      }

      this.axios.post('/Boarding/addInformtion', formdata).then(function (d) {
        if (d.data.code == 75000) {
          _this.$message.success('Success!');
          _this.$router.replace('/personal_profile/personal_qa');
        } else {
          _this.$message.error(d.data.message);
        }
      }).catch(function () {
        _this.$message.error('service error');
      });
    },
    toggleShow: function toggleShow() {
      this.show = !this.show;
    },
    cropSuccess: function cropSuccess(imgDataUrl, field) {
      this.imgDataUrl = imgDataUrl;
    },
    cropUploadSuccess: function cropUploadSuccess(jsonData, field) {
      if (jsonData.code == 75000) {
        this.f_state.inp15 = true;
        this.basic_info.pic = jsonData.res.url;
      } else {
        this.$message.error('upload error');
      }
    },
    cropUploadFail: function cropUploadFail(status, field) {}
  },
  watch: {
    basic_info: {
      handler: function handler(o, n) {
        this.f_state.inp1 = !this.basic_info.first_name ? false : true;
        this.f_state.inp2 = !this.basic_info.last_name ? false : true;
        this.f_state.inp4 = !this.basic_info.birthday ? false : true;
        this.f_state.inp5 = !this.basic_info.on_boarding_is_legal ? false : true;
        this.f_state.inp6 = !this.basic_info.zoom_id ? false : true;
        this.f_state.inp7 = !this.basic_info.country_code ? false : true;
        this.f_state.inp8 = !this.basic_info.mobile ? false : true;
        this.f_state.inp9 = !this.basic_info.time_zone ? false : true;
        this.f_state.inp10 = !this.basic_info.country ? false : true;
        this.f_state.inp11 = !this.basic_info.state ? false : true;
        this.f_state.inp12 = !this.basic_info.city ? false : true;
        this.f_state.inp13 = !this.basic_info.street ? false : true;
        this.f_state.inp14 = !this.basic_info.z_code ? false : true;
        this.f_state.inp16 = !this.basic_info.valid_ids_url ? false : true;
      },
      deep: true
    }
  },
  computed: {
    time: function time() {
      var _this = this;
      var time = new Date(_this.basic_info.birthday);
      var year = time.getFullYear();
      var mon = time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1;
      var day = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();

      time = year + '-' + mon + '-' + day;
      if (time == 'NaN-NaN-NaN') {
        this.basic_info.birthday = '';
      } else {
        this.basic_info.birthday = time;
      }
      return time;
    },
    action: function action() {
      return __WEBPACK_IMPORTED_MODULE_3__api_basePath__["a" /* default */] + '/Fileupload/uploadToHkOss';
    },

    objBgActiveFn: function objBgActiveFn() {
      var objBgActive = [];
      for (var key in this.datas.background) {
        objBgActive.item = {
          name: this.datas.background[key],
          isActive: false,
          num: key
        };
        objBgActive.push(objBgActive.item);
      }
      return objBgActive;
    },
    objInterestsFn: function objInterestsFn() {
      var objBgActive = [];
      for (var key in this.datas.interests) {
        objBgActive.item = {
          name: this.datas.interests[key],
          isActiveIn: false,
          num: key
        };
        objBgActive.push(objBgActive.item);
      }
      return objBgActive;
    }
  }
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_ac__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_ac___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_ac__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  data: function data() {
    return {
      isMac: false,
      isWindows: false
    };
  },

  methods: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])(['per_opt', 'init_state']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['_boardingStep'])),
  components: {
    ac: __WEBPACK_IMPORTED_MODULE_2__common_ac___default.a
  }
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_upload_img__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_upload_img___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_upload_img__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_file_upload__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_file_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_file_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_basePath__ = __webpack_require__(71);











/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  data: function data() {
    return {
      data_config: "",
      data_t_d: "",
      fileList: [],
      upload_file_wid: "490",
      f_state: {
        inp1: false,
        inp2: false,
        inp3: false
      },

      basic_info: {
        educational_attainment: "",
        teaching_experience_list: [],
        school_name: "",
        major: "",
        teaching_experience: [],
        years: "",
        total_teaching_experience: "",
        teaching_certificate: [],

        teaching_certification: {
          certification_tesol: {
            name: "TESOL",
            data: []
          },
          certification_teyl: {
            name: "TEYL",
            data: []
          },
          certification_other: {
            name: "Other Certificate",
            data: []
          },
          certification_academic: {
            name: "Please upload your highest attained diploma(Bachelor’s, Master’s, Doctoral)*",
            data: []
          }
        }
      },

      schoolNameSearchLanding: false,
      searchSchool: {},
      SchollNameVal: ""
    };
  },
  created: function created() {
    var _this = this;

    this.$http.get("/common/getConfig").then(function (response) {
      if (response.data && response.data.code == "75000") {
        var res = response.data.res;
        for (var key in res.majors) {
          res.majors[key] = res.majors[key] + "";
        }
        _this.data_config = response.data.res;

        _this.$http.get("/Boarding/getTutor").then(function (d) {
          if (d.data.code = "75000") {
            this.data_t_d = d.data.res.info;

            var teaching_certification = d.data.res.info.teaching_certification;

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(this.basic_info.teaching_certification)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _step$value = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_step.value, 2),
                    _key = _step$value[0],
                    value = _step$value[1];

                var config = res[_key];

                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                  var _loop = function _loop() {
                    var _step2$value = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_step2.value, 2),
                        cert_code = _step2$value[0],
                        cert_name = _step2$value[1];

                    var cert_url = "";

                    if (teaching_certification && teaching_certification[_key]) {
                      var findItem = teaching_certification[_key].find(function (item) {
                        return item.cert_code == cert_code;
                      });

                      if (findItem && findItem.cert_url) {
                        cert_url = findItem.cert_url;
                      }
                    }

                    value.data.push({
                      cert_code: cert_code,
                      cert_name: cert_name,
                      cert_url: cert_url
                    });
                  };

                  for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(config)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    _loop();
                  }
                } catch (err) {
                  _didIteratorError2 = true;
                  _iteratorError2 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                      _iterator2.return();
                    }
                  } finally {
                    if (_didIteratorError2) {
                      throw _iteratorError2;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            var arr = ["educational_attainment", "school_name", "major", "teaching_experience", "total_teaching_experience", "teaching_certificate", "teaching_experience_list"];

            var arrs = ["educational_attainment", "university", "major", "teaching_experience", "total_teaching_experience", "teaching_certificate", "teaching_experience_list"];

            for (var i = 0; i < arr.length; i++) {
              if (this.datas[arrs[i]]) {
                this.basic_info[arr[i]] = ["teaching_experience"].includes(arrs[i]) ? this.datas[arrs[i]].split(",") : this.datas[arrs[i]];
              }
            }
          }
        });
      }
    }, function () {
      console.log("service error");
    });
  },

  components: {
    uploadImg: __WEBPACK_IMPORTED_MODULE_5__common_upload_img___default.a,
    fileUpload: __WEBPACK_IMPORTED_MODULE_6__common_file_upload___default.a
  },
  computed: {
    teaching_certificate: {
      get: function get() {
        return this.basic_info.teaching_certificate;
      },
      set: function set(val) {
        var lastVal = val.slice(-1)[0];
        var key = "11";
        if (lastVal === key) {
          this.basic_info.teaching_certificate = [key];
        } else {
          var index = val.indexOf(key);
          if (index > -1) {
            val.splice(index, 1);
          }

          this.basic_info.teaching_certificate = val;
        }
      }
    },
    count: function count() {
      return this.$store.state.count;
    },
    action: function action() {
      return __WEBPACK_IMPORTED_MODULE_7__api_basePath__["a" /* default */] + "/Fileupload/uploadToHkOss";
    },
    isCancel: function isCancel() {
      var pass = void 0;

      for (var opt in this.f_state) {
        if (this.f_state[opt]) {
          pass = true;
        } else {
          pass = false;
          break;
        }
      }

      return pass;
    },

    datas: function datas() {
      var data = {};
      var inpKey = ["university", "esl_teaching_years", "certificate_url", "educational_attainment", "major", "teaching_experience", "total_teaching_experience", "teaching_experience_list", "teaching_certificate"];

      var second_step_key = [];

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(inpKey), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var key = _step3.value;

          if (!this.data_t_d[key] && key !== "major") {
            data[key] = "";
          } else {
            data[key] = this.data_t_d[key];
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return data;
    }
  },
  methods: {
    uploadComplete: function uploadComplete(response, file, idx, id, _ref) {
      var key = _ref.key,
          index = _ref.index;

      if (response.code == 75000) {
        this.$message.success("Congratulations, upload success!");
        this.basic_info.teaching_certification[key].data[index].cert_url = response.res.url;
      } else {
        this.$message.error("service error");
      }
    },
    beforeUpload: function beforeUpload(file, event) {
      var isJPG = file.type === "image/jpeg" || file.type === "image/png";

      var isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("Upload avatar image can only be JPG and PNG format!");
      }
      if (!isLt2M) {
        this.$message.error("Upload avatar picture size no more than 2 MB.");
      }
      return isJPG && isLt2M;
    },
    delUpload: function delUpload(_ref2) {
      var _this2 = this;

      var key = _ref2.key,
          index = _ref2.index;

      this.$confirm("Delete this item?").then(function () {
        _this2.basic_info.teaching_certification[key].data[index].cert_url = "";
      }).catch(function () {});
    },
    save: function save() {
      var _this3 = this;

      if (!this.isCancel) return;

      var teaching_certification = {};

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(this.basic_info.teaching_certification)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _step4$value = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_step4.value, 2),
              certificationKey = _step4$value[0],
              certification = _step4$value[1];

          var certificationData = certification.data.filter(function (_ref3) {
            var cert_url = _ref3.cert_url;
            return cert_url;
          }).map(function (_ref4) {
            var cert_code = _ref4.cert_code,
                cert_url = _ref4.cert_url;
            return { cert_code: cert_code, cert_url: cert_url };
          });

          if (certificationData.length > 0) {
            teaching_certification[certificationKey] = certificationData;
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var formdata = {
        university: this.basic_info.school_name,
        major: this.basic_info.major
      };

      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(teaching_certification).length > 0) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(formdata, {
          teaching_certification: teaching_certification
        });
      }

      this.axios.post("/Boarding/addQualific", formdata).then(function (d) {
        if (d && d.data.code == "75000") {
          _this3.$message.success("save success.");
          _this3.$router.replace("/personal_profile/payment");
        } else {
          _this3.$message.error(d.data.message);
        }
      }, function () {
        _this3.$message.error("service error");
      });
    },
    doc_up_s_fn: function doc_up_s_fn(response, file, fileList) {
      if (response.code == 75000) {
        this.$message.success("Upload successful!");

        this.words = file.raw.name;
      } else {
        this.$message.error("Upload failed.");
      }
    },
    doc_before_up: function doc_before_up(file) {
      var isDoc = file.type === "application/pdf" || file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || file.type === "application/msword";


      var isLt2M = file.size / 1024 / 1024 < 2;

      if (!isDoc) {
        this.$message.error("Only upload documents'type of .doc/.docx/.pdf!");
      }
      if (!isLt2M) {
        this.$message.error("Upload avatar picture size no more than 2 MB.");
      }

      return isDoc && isLt2M;
    },
    schoolSearch: function schoolSearch(val) {
      var _this4 = this;

      if (val !== "") {
        this.schoolNameSearchLanding = true;
        this.axios.get("/common/getUniversityList?name=" + val).then(function (d) {
          if (d.data.code == 75000) {
            _this4.searchSchool = d.data.res;
            _this4.schoolNameSearchLanding = false;
          }
        }, function () {
          console.log("error");
        });
      } else {
        this.searchSchool = {};
      }
    }
  },
  watch: {
    basic_info: {
      handler: function handler(o, n) {
        this.basic_info.years = this.basic_info.years.replace(/[^\d\.]+/g, "");

        this.basic_info.school_name = this.basic_info.school_name.replace(/[^a-zA-z0-9\s]+/g, "").replace(/\^/g, "");

        this.f_state.inp1 = !this.basic_info.educational_attainment ? false : true;
        this.f_state.inp2 = !this.basic_info.school_name ? false : true;
        this.f_state.inp3 = !this.basic_info.major ? false : true;
      },
      deep: true
    }
  }
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_input_check_box__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_input_check_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_input_check_box__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  data: function data() {
    return {
      isCheck: false,
      first_name: '',
      full_name: '',
      nick_name: '',
      country: '',
      datas: [],
      complete: false,
      date: '',
      great: false,
      message: '',
      has_set: false,
      has_set_ok: false,
      click_br: true,
      saImgPath: '',
      annexPath: '',
      saId: ''
    };
  },

  computed: {
    canSetSa: function canSetSa() {
      return !!this.isCheck && !!this.first_name && !!this.full_name && !!this.nick_name;
    }
  },
  components: {
    InputCheckbox: __WEBPACK_IMPORTED_MODULE_0__common_input_check_box___default.a
  },
  methods: {
    next: function next() {
      var _this2 = this;

      if (!this.complete) return;

      var loading = this.$loading();

      this.$http.get('/Boarding/boardingNext').then(function (d) {
        loading.close();

        if (d.data.code == '75000') {
          _this2.$message.success('save success.');
          _this2.$router.replace('/online_pending');
        } else {
          _this2.$message.error(d.data.message);
        }
      }).catch(function (err) {
        loading.close();
        console.log(err);
        _this2.$message.error('server error');
      });
    },

    detectFn: function detectFn() {
      var _this = this;
      var formdata = new URLSearchParams();
      if (this.nick_name == '') return;
      formdata.append('nick_name', _this.nick_name);
      this.axios.post('/Boarding/checkName', formdata).then(function (d) {
        _this.has_set = true;
        if (d.data.code == 75070) {
          _this.message = d.data.message;
          _this.great = true;
          _this.has_set_ok = true;
        } else if (d.data.code == 75071) {
          _this.message = d.data.message;
          _this.great = false;
          _this.has_set_ok = false;
        }
      });
    },
    changeCheck: function changeCheck(isCheck) {
      this.isCheck = isCheck;
    },
    sa_time: function sa_time(time) {
      var date = '';
      var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      var hh = time.getHours() < 10 ? '0' + time.getHours() : time.getHours();

      var mm = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();

      var ss = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds();

      return months[time.getMonth()] + ' ' + time.getDate() + ',' + time.getFullYear() + ' ' + hh + ':' + mm + ':' + ss;
    },
    setSa: function setSa() {
      var _this = this;

      if (!this.canSetSa) return;

      if (!_this.has_set) {
        this.$message.error('Please click on "Detect Availablity" to check if your teacher name is available.');
        return;
      }

      if (!_this.has_set_ok) {
        this.$message.error('Oops. This name is already taken. Please choose another one.');
        return;
      }

      var params = new URLSearchParams();

      params.append('sa_signed', _this.isCheck ? 'yes' : 'no');

      params.append('first_name', _this.first_name);

      params.append('full_name', _this.full_name);

      params.append('nationality', _this.country);

      params.append('nick_name', _this.nick_name);

      params.append('sa_id', _this.saId);

      var loading = this.$loading();

      this.axios.post('/Personal/setSa', params).then(function (d) {
        loading.close();

        if (d.data.code == '75000') {
          _this.complete = true;

          _this.date = d.data.res.show_sa_signed_time;
        } else {
          _this.$message.error(d.data.message);
        }
      }).catch(function (err) {
        loading.close();
        _this.$message.error('server error');
      });
    }
  },
  created: function created() {
    var _this3 = this;

    this.$http.get('/Personal/getServiceAgreement').then(function (d) {
      console.log(d);
      if (d.data.code == '75000') {
        _this3.saImgPath = d.data.res.url;
        _this3.annexPath = d.data.res.annex_url;
        _this3.saId = d.data.res.id;
        console.log(_this3.saImgPath, _this3.saId);
      } else {
        _this3.$message.error('service error.');
      }
    });

    this.$http.get('/common/getConfig?key=nationality').then(function (d) {
      var _this4 = this;

      if (d.data.code == 75000) {
        this.datas = d.data.res.nationality;
      } else {
        this.$message.error('service error.');
      }
      this.$http.get('/Boarding/getTutor').then(function (d) {
        if (d.data.code == '75000') {
          var sa_signed = d.data.res.info.sa_signed;

          var first_name = d.data.res.info.pso_first_name;

          var full_name = d.data.res.info.pso_full_name;

          var country = d.data.res.info.nationality;

          var nick_name = d.data.res.info.nick_name;

          if (country) {
            _this4.country = country;
          }

          if (sa_signed == 'yes') {

            _this4.complete = true;

            _this4.first_name = first_name;

            _this4.full_name = full_name;

            _this4.nick_name = nick_name;

            _this4.date = d.data.res.info.show_sa_signed_time;
          }
        }
      });
    });
  },
  watch: {
    nick_name: function nick_name(o, n) {
      if (this.has_set) {
        this.has_set = false;
        this.has_set_ok = false;
        this.message = '';
      }
    }
  }
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      dialogVisible: false,
      isRemark: true,
      remark: '',
      type: 'reschedule',
      resolve: function resolve() {},
      reject: function reject() {
        throw new Error('error');
      }
    };
  },


  computed: {
    typeText: function typeText() {
      var type = this.type;
      var typeText = '';

      switch (type) {
        case 'reschedule':
          typeText = 'rescheduling';
          break;

        case 'cancel':
          typeText = 'cancelling';
          break;
      }

      return typeText;
    }
  },

  methods: {
    open: function open(_ref) {
      var _this = this;

      var type = _ref.type,
          isRemark = _ref.isRemark;

      this.type = type;
      this.dialogVisible = true;

      if (isRemark !== undefined) {
        this.isRemark = isRemark;
      }

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.resolve = resolve;
        _this.reject = reject;
      });
    }
  }
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			time_out: '5s',
			time: 5,
			timer: ""
		};
	},

	methods: {
		started: function started() {
			clearTimeout(this.timer);
			this.$router.push('fillform');
		},
		time_out_func: function time_out_func() {
			var _this = this;
			this.timer = setTimeout(function () {
				_this.time--;
				if (_this.time == 0) {
					_this.started();
					clearTimeout(timer);
					return;
				}
				_this.time_out = _this.time + 's';
				_this.time_out_func();
			}, 1000);
		}
	},
	beforeRouteLeave: function beforeRouteLeave(to, from, next) {
		clearTimeout(this.timer);
		next();
	},
	beforeRouteEnter: function beforeRouteEnter(to, from, next) {
		next(function (vm) {
			if (vm.time == 5) {
				vm.time_out_func();
			} else {
				vm.time_out = '';
			}
		});
	}
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_ac__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_ac___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_ac__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js__ = __webpack_require__(11);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isMac: false,
      isWindows: false
    };
  },

  components: {
    ac: __WEBPACK_IMPORTED_MODULE_0__common_ac___default.a
  },
  methods: {
    letUsBegin: function letUsBegin() {
      var _this = this;

      this.$http.get('/boarding/setStartBtnStatus').then(function (d) {
        if (d.data.code == '75000') {
          window.location.href = __WEBPACK_IMPORTED_MODULE_1__js__["a" /* urls */].myPageLogTea;
        } else {
          _this.$message.error(d.data.message);
        }
      });
    }
  }
});

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js__ = __webpack_require__(11);




/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    if (this.$route.name == 'rigister_init' || this.$route.name == 'rigister') {
      var URL = __WEBPACK_IMPORTED_MODULE_0__js__["a" /* urls */].landingUsaRegister;
      var chennel = this.$route.query.channel;
      var detail = this.$route.query.detail;
      if (chennel && detail) {
        URL = URL + '?channel=' + chennel + '&detail=' + detail + '';
      }
      window.location.href = URL;
    }
  }
});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js__ = __webpack_require__(11);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  data: function data() {
    return {
      isCheck: false,
      test_d: {
        exact_status: 'failed',
        expire: 100,
        is_login: true,
        status: 'onboarding'
      }
    };
  },
  methods: {
    timeout: function timeout() {
      var _this = this;

      var now = new Date().getTime();
      setTimeout(function () {
        if (now >= _this.pass_date) {}
        _this.timeout();
      }, 5000);
    }
  },
  computed: {
    ticket: function ticket() {
      try {
        var params = window.location.href.split('?')[1];
        var arrs = params.split('&');
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(arrs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var opt = _step.value;

            if (opt.split('=')[0] == 'ticket') {
              return opt.split('=')[1];
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    pass_date: function pass_date() {
      return this.$store.state.pass_date;
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      var sid = vm.$route.query.sid;
      var url = '';

      console.log(vm.$route.query, vm.$route.query.sid);
      if (vm.ticket) {
        url = '/index/login' + '?ticket=' + vm.ticket;
      } else if (sid) {
        url = '/index/login' + '?sid=' + sid;
      } else {
        url = '/index/login';
      }

      vm.axios.get(url).then(function (d) {
        vm.$store.commit('update_login_status', d.data.res);

        try {
          vm.$store.commit('setCookie', {
            key: 'logined',
            value: d.data.res.expire
          });
          vm.$store.commit('getCookie', { name: 'logined' });
          vm.timeout();
        } catch (e) {
          console.log(e);
        }

        if (d.data.code == '75000' && d.data.res.is_login) {
          var state = d.data.res.status;

          var exact_state = d.data.res.exact_status;

          __WEBPACK_IMPORTED_MODULE_1__js__["b" /* routerController */].call(vm, { state: state, exact_state: exact_state });
        } else if (d.data.code == '75092') {
          window.location.href = d.data.res.url;
        } else {
          vm.$message({
            showClose: true,
            message: 'Oops, sign in failed. Please try again.',
            duration: 0,
            type: 'error',
            onClose: function onClose() {
              window.location.href = __WEBPACK_IMPORTED_MODULE_1__js__["a" /* urls */].ssoLogin;
            }
          });
        }
      });
    });
  }
});

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_ac__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_ac___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_ac__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_mypage__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_mypage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_mypage__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  data: function data() {
    return {
      full_name: ''
    };
  },

  components: {
    ac: __WEBPACK_IMPORTED_MODULE_0__common_ac___default.a,
    mypage: __WEBPACK_IMPORTED_MODULE_1__common_mypage___default.a
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.$http.get('/interview/getTutorProfile').then(function (d) {
        if (d.data.code = '75000') {
          vm.full_name = d.data.res.tutor.full_name;
        }
      });
    });
  }
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_ac__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_ac___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_ac__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_mypage__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_mypage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_mypage__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  data: function data() {
    return {
      full_name: ''
    };
  },

  components: {
    ac: __WEBPACK_IMPORTED_MODULE_0__common_ac___default.a,
    mypage: __WEBPACK_IMPORTED_MODULE_1__common_mypage___default.a
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.$http.get('/interview/getTutorProfile').then(function (d) {
        if (d.data.code = '75000') {
          vm.full_name = d.data.res.tutor.full_name;
        }
      });
    });
  },
  created: function created() {}
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_ac_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_ac_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_ac_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  components: {
    ac: __WEBPACK_IMPORTED_MODULE_0__common_ac_vue___default.a
  },
  data: function data() {
    return {
      full_name: '',
      inp1: false,
      inp2: false,
      e_mail: 'teach@51talk.com',
      need_mail: '',
      arrImg: {
        img_url: false,
        img_url2: false,
        img_url4: false
      },
      isMac: false,
      isWindows: false,
      step: null
    };
  },

  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (from.name == 'book_interview') {
        vm.inp1 = true;
        vm.$http.get('/interview/getTutorProfile').then(function (d) {
          if (d.data.code == '75000') {
            vm.full_name = d.data.res.tutor.full_name;
            vm.step = 2;
          }
        });
      } else if (from.name == 'book_tpg') {
        vm.inp2 = true;
        vm.$http.get('/tpg/getTutorInfo').then(function (d) {
          if (d.data.code == '75000') {
            vm.full_name = d.data.res.tutor.full_name;
            vm.step = 4;
          }
        });
      } else if (from.name == 'book_demo') {
        vm.inp2 = true;
        vm.$http.get('/demo/getTutorInfo').then(function (d) {
          if (d.data.code == '75000') {
            vm.full_name = d.data.res.tutor.full_name;
            vm.step = 4;
          }
        });
      }

      vm.need_mail = 'mailto:' + vm.e_mail;
    });
  }
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_fold__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_fold___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_fold__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      datas: [{
        title: 'Registration information',
        article: {
          partOne: '',
          partTwo: 'When you create your 51Talk Teacher Account, you will be required to provide certain personal information including: your first and last name, the country/state/city in which you reside, your highest level of education, your teaching experience, your resume, and your phone number. ',
          partTh: ''
        }
      }, {
        title: 'Automatic Collection of Data',
        article: {
          partOne: '',
          partTwo: 'When you visit our Website or click through hyperlinks appearing thereon, or use one or more of our services, we may use an industry-wide technology called "cookies" which stores certain information on your computer and which will allow us to customize your experience to better match your interests and preferences or simply facilitate your signing-in to use the services. Most browsers will allow you to erase cookies from your computer hard drive, block acceptance of cookies, or receive a warning before a cookie is stored. Please refer to your browser instructions or help screen to learn more about these functions. Please note, however, that if you set your browser to block acceptance of cookies, you may not be able to use the Service or enter our Website or it may otherwise adversely impact the functionality of the site. By allowing your browser settings to accept cookies from this Website or Service, you consent to our placement of cookies on your personal computer and/or technology device.',
          partTh: 'If you do not wish to share this information with 51Talk, then you should take steps to limit the passive collection of data about your activities on our site, for example, by changing your browser settings to disable cookies. We reserve the right to use and disclose such Non Personal Information, as well as any other Non-Personal Information we collect, with our advertisers and other third parties at our discretion.'
        }
      }, {
        title: 'Social media features and widgets',
        article: {
          partOne: '',
          partTwo: 'Our Site includes social media features and widgets, such as the Facebook “Like” button and the Facebook “Share” button. These features may collect your IP address, the URL of the page you are visiting on our site, and may set a cookie to enable the feature to function properly. Social media features and widgets are either hosted by a third party or hosted directly on our site. Your interactions with these features are governed by the privacy policy of the company providing it.',
          partTh: ''
        }
      }, {
        title: 'What we do with your information',
        article: {
          partOne: '',
          partTwo: 'In general, the Personal Information we collect is used to (1) improve our services and enhance your experience, (2) enable us to provide a safer community for all of our Registered Users, and (3) communicate with us. We may use your Personal Information to register and service your account, including teacher profiles, contact you for questions and to solicit feedback, enable students to search for you, verify information you provide us, help protect the safety and integrity of the site, target promotional messages or content on the site, via email or other ads.',
          partTh: ''
        }
      }, {
        title: 'Sharing Information with Affiliates',
        article: {
          partOne: '',
          partTwo: "From a teacher recruitment website to the 51Talk main website which is open to company members; your information will be stored in 51Talk's database, which is only accessible through the use of a Virtual Private Network (VPN) with access restricted to only a few key members in the company. Following termination or deactivation of your account, 51Talk, its affiliates, or its service providers may retain information associated with your profile information for a commercially reasonable time for backup, archival, and/or audit purposes.",
          partTh: ''
        }
      }, {
        title: 'Share information with third parties',
        article: {
          partOne: '',
          partTwo: 'We work with third parties who provide services, which may include website hosting, bank payment and other services of an administrative nature. Personal information, including financial information, may be shared with such third parties for the purpose of providing such services to you. We seek to impose confidentiality obligations on such service providers.',
          partTh: ''
        }
      }, {
        title: 'Registered students and parents',
        article: {
          partOne: '',
          partTwo: 'If you are a teacher, in order to increase your class booking rate, we share with registered users the information that is included in your profile, aside from your contact information, as well as the following registration information, which we may include in your profile: your first name, first initial of your last name, city, state, profile picture, your gender and your age.',
          partTh: ''
        }
      }, {
        title: 'Links to other sites',
        article: {
          partOne: '',
          partTwo: 'Linking to other sites is an integral part of the functionality of the Internet, including our Website. Any link to a page which displays a URL other than a domain name that ends in 51talk.com.cn in the address window of your browser is a link to a site outside of our service and thus outside the control of 51Talk. This includes links to our suppliers of content on the service, affiliates, and links to any other third parties that may be linked to 51Talk. These other sites may send their own cookies, collect data or solicit personal information. 51Talk cannot guarantee and is not responsible for the content of outside sites.',
          partTh: ''
        }
      }, {
        title: 'Not to use for profit (rent or sell)',
        article: {
          partOne: '',
          partTwo: 'If you provide 51Talk with personally identifiable information, we will take reasonable and appropriate steps to protect this information. Except as otherwise described in this privacy policy, 51Talk will not disclose, share, sell or rent personally identifiable information collected on our site to third-party organizations for their marketing or promotional use without your consent or except as part of a specific program or feature for which you will have the ability to opt-out. If we sell or otherwise transfer part or the whole of 51Talk business and/or our assets to another organization like in a course of a merger and acquisition transaction, or in the case of a bankruptcy, dissolution or liquidation, your information such as name and email address and any other information collected through our site or service may be among the items sold or transferred. The resulting buyer, surviving company or transferee will honor the commitments we have made in this privacy policy. We do not share your bank account information with affiliate sites or any other third parties, other than making salary payments for teachers.',
          partTh: ''
        }
      }, {
        title: 'Updating or deleting your registration information',
        article: {
          partOne: '',
          partTwo: 'As part of your use of our service, you are responsible for updating your submitted registration information so that it is current, complete and effective. You can update this information by logging into your account and accessing your account settings. If you would like to remove some of the personal information you have posted on the site, such as information you posted in profiles, you may do so by editing or deleting that item. To request removal of other personal information you have voluntarily posted on our site, such as information you may have posted in online group forums, contact 51Talk. In some cases, we may not be able to reasonably accommodate your request to remove your personal information, in which case we will let you know if we are unable to do so and why. Please note that by using our website, you signify your agreement to this privacy policy, as it may be amended from time to time. If you do not agree to this privacy policy, please do not use our site or the services provided thereon. We reserve the right to make changes to this privacy policy. We will provide notice to you of any material changes by any reasonable means including sending an email to the most recently updated address in your 51Talk Account and/or posting such notice and the amended policy on your 51Talk My Page. Your continued use of our site following changes to this privacy policy will mean that you accept and agree to the changes and that any information collected or provided after such change will be governed by the updated privacy policy.',
          partTh: ''
        }
      }, {
        title: 'Invitations - Refer a Friend',
        article: {
          partOne: '',
          partTwo: 'If you decide to refer a friend to our site, they will have to provide information for registration as outlined above. Your friend will be subject to this privacy policy and the terms of service of 51Talk.',
          partTh: ''
        }
      }, {
        title: 'Security',
        article: {
          partOne: '',
          partTwo: 'Whenever you give 51Talk sensitive information (e.g., bank information), 51Talk will take commercially reasonable steps to protect such information. We use reasonable security methods to protect the data that resides on our servers. However, because no security system is impenetrable, we cannot guarantee the security of our servers. It is also possible that information you supply to us will be intercepted during transmission. Please remember to sign out of your 51Talk account and close your browser window whenever you leave your computer. This is to ensure that others cannot access your personal information, because your computer may be accessible to others or used in a shared setting. To help protect your 51Talk account information, please keep your password secure. Your password will be maintained in our system in encrypted form. Ultimately, you are responsible for maintaining the secrecy of your passwords and any 51Talk account information. ',
          partTh: ''
        }
      }]
    };
  },

  components: {
    fold: __WEBPACK_IMPORTED_MODULE_0__common_fold___default.a
  },
  methods: {}
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js__ = __webpack_require__(11);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    var validatorEmpty = {
      required: true,
      message: 'This is required!',
      trigger: 'blur'
    };

    return {
      init: false,
      focus_on: false,

      changePassword: {
        current_pwd: '',
        new_pwd: '',
        re_new_pwd: ''
      },

      changePasswordRules: {
        current_pwd: [validatorEmpty],

        new_pwd: [validatorEmpty, {
          validator: function validator(rule, value, callback) {
            var res = _this.regTest(value);

            if (value !== '' && _this.changePassword.re_new_pwd !== '') {
              _this.$refs.changePassword.validateField('re_new_pwd');
            }

            if (!res.checkStatus) {
              callback(new Error('incorrect password format'));
              return;
            }

            callback();
          },
          trigger: 'blur'
        }],

        re_new_pwd: [validatorEmpty, {
          validator: function validator(rule, value, callback) {
            if (value !== _this.changePassword.new_pwd) {
              callback(new Error("the password you retyped doesn't match"));
              return;
            }

            callback();
          },
          trigger: 'blur'
        }]
      }
    };
  },


  computed: {
    show_off: function show_off() {
      if (!this.init) return;
      if (!this.focus_on && this.passwordCheck.checkStatus) return;

      return true;
    },

    passwordCheck: function passwordCheck() {
      return this.regTest(this.changePassword.new_pwd);
    }
  },

  methods: {
    getClass: function getClass(type) {
      var passwordCheck = this.passwordCheck;
      if (passwordCheck.empty) return 'remind_normal';

      if (passwordCheck[type]) {
        return 'remind_pass';
      }

      return 'remind_wrong';
    },
    regTest: function regTest(password) {
      var empty = password === '';
      var type1 = password.length >= 8 && password.length <= 25;
      var type2 = password.search(/[a-z]/) > -1 && password.search(/[A-Z]/) > -1;
      var type3 = password.search(/[0-9]/) > -1;
      var type4 = /^[A-Za-z0-9\!\@\#\$\%\^\&\*\(\)\?\<\>\._-]*$/.test(password);

      return {
        type1: type1,
        type2: type2,
        type3: type3,
        type4: type4,
        checkStatus: type1 && type2 && type3 && type4,
        empty: empty
      };
    },
    back: function back() {
      this.$router.go(-1);
    },
    save: function save() {
      var _this2 = this;

      this.$refs.changePassword.validate(function (valid) {
        if (!valid) return;
        var loading = _this2.$loading();
        _this2.axios.post('/index/updatePwd', _this2.changePassword).then(function (res) {
          loading.close();
          if (res.data.code == '75000') {
            _this2.$message.success('reset success!');

            setTimeout(function () {
              window.location.assign(__WEBPACK_IMPORTED_MODULE_0__js__["a" /* urls */].ssoLogin);
            }, 500);
          } else {
            _this2.$message.error(res.data.message);
          }
        }).catch(function (err) {
          _this2.$message.error('server error');
          loading.close();
        });
      });
    }
  }
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Calendar_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Calendar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_Calendar_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['timeZone', 'bookType', 'sureHandler', 'queryStatus', 'scheduledTimeZone', 'scheduledStartTime', 'scheduledEndTime'],
  data: function data() {
    return {
      no_date: false,
      hasDate: false,
      calendar: {
        show: true,
        x: 0,
        y: 0,
        items: {
          type: 'date',
          begin: '2017-03-04',
          end: '2018-03-04',
          value: '2017-03-04',
          text: '2017-03-04',
          sep: '-',
          single: true,
          autoclose: true,
          weeks: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        }
      },
      time_zone: '',
      switch_time: '',
      time_frame: [],
      update_right_time: '',
      chosedStartTime: ''
    };
  },

  methods: {
    isTimeDisable: function isTimeDisable(time) {

      if (!this.scheduledTimeZone || !this.time_zone) return;
      if (this.scheduledTimeZone != this.time_zone) return;
      if (!this.calendar.items.text || !this.scheduledStartTime || !this.scheduledEndTime) return;
      if (this.calendar.items.text != this.scheduledStartTime.split(' ')[0]) return;

      return this.scheduledStartTime.split(' ')[1].split(':').slice(0, 2).join(':') == time.work_start_time && this.scheduledEndTime.split(' ')[1].split(':').slice(0, 2).join(':') == time.work_end_time;
    },
    close: function close() {
      this.$store.commit('reschedule_pop_show');
    },
    open: function open(e, type) {
      this.calendar.show = true;
      this.calendar.x = e.target.offsetLeft;
      this.calendar.y = e.target.offsetTop + e.target.offsetHeight + 8;
    },
    dateCancel: function dateCancel(obj) {
      this.calendar.show = obj.show;
    },
    dateOk: function dateOk(obj) {
      this.calendar.items.text = obj.values[0];
      this.calendar.items.value = obj.values[0];
    },
    submit: function submit() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, date, sureHandlerRes, isRemark;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = new URLSearchParams();
                date = _this2.calendar.items.text + ' ' + _this2.chosedStartTime;

                if (!(!_this2.time_zone || !date || !_this2.time_detail)) {
                  _context.next = 5;
                  break;
                }

                _this2.$message.error('Please choose a training session!');
                return _context.abrupt('return');

              case 5:
                sureHandlerRes = void 0;
                isRemark = void 0;

                if (!_this2.sureHandler) {
                  _context.next = 12;
                  break;
                }

                isRemark = _this2.queryStatus !== 'canceled';
                _context.next = 11;
                return _this2.sureHandler({
                  type: 'reschedule',
                  isRemark: isRemark
                });

              case 11:
                sureHandlerRes = _context.sent;

              case 12:

                params.append('timezone', _this2.time_zone);

                params.append('working_date', date);

                params.append('working_time', _this2.time_detail);

                params.append('action', _this2.queryStatus === 'canceled' ? 'schedule' : 'reschedule');

                if (isRemark) {
                  params.append('remark', sureHandlerRes.remark);
                }

                _this2.axios.post('/' + _this2._bookType.normal + '/schedule', params).then(function (d) {
                  if (d.data.code == '75000') {
                    _this2.$message.success('Success!');
                    _this2.$store.commit('reschedule_pop_show');
                    window.location.reload();
                  } else {
                    _this2.$message.error(d.data.message);
                  }
                });

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    frameFn: function frameFn(d, idx, chosedStartTime, disable) {
      if (disable) return;

      for (var i = 0; i < this.time_frame.length; i++) {
        this.time_frame[i].isActive = false;
      }
      this.time_detail = d;
      this.time_frame[idx].isActive = true;
      this.chosedStartTime = chosedStartTime;
      console.log(this.chosedStartTime);
    },
    update_right_date: function update_right_date() {
      this.time_detail = '';
      var date = this.calendar.items.text + ' ' + this.chosedStartTime;
      console.log(this.chosedStartTime);

      this.$http.get('/' + this._bookType.normal + '/get' + this._bookType.upperOne + 'Time?timezone=' + this.time_zone + '&working_date=' + date).then(function (response) {
        if (response.data.code == '75000') {
          this.hasDate = true;
          this.time_frame = [];
          for (var i = 0; i < response.data.res.length; i++) {
            var arrTime = {};
            arrTime.service_id = response.data.res[i].service_id;
            arrTime.working_date = response.data.res[i].working_date;
            arrTime.week = response.data.res[i].week;
            arrTime.work_end_time = response.data.res[i].work_end_time;
            arrTime.work_hour_type = response.data.res[i].work_hour_type;
            arrTime.work_hour_value = response.data.res[i].work_hour_value;
            arrTime.work_start_time = response.data.res[i].work_start_time;
            arrTime.isActive = false;
            this.time_frame.push(arrTime);
          }
        } else if (response.data.code == '75001') {
          this.hasDate = false;

          this.time_frame = [];
        } else {
          this.hasDate = false;
        }
      }, function () {
        console.log('service error');
      });
    }
  },
  computed: {
    window_size: function window_size() {
      return {
        width: window.outerWidth,
        height: window.outerHeight
      };
    },
    _bookType: function _bookType() {
      if (!this.bookType) {
        return {};
      }

      return {
        normal: this.bookType,
        upper: this.bookType.toUpperCase(),
        upperOne: this.bookType.replace(/./, function (e) {
          return e.toUpperCase();
        })
      };
    }
  },
  created: function created() {
    var _this3 = this;

    this.$http.get('/' + this._bookType.normal + '/getTutorInfo').then(function (d) {
      if (d.data.code == '75000') {
        var complete_status = d.data.res.tutor.self_study_status == 'completed' ? true : false;
        var full_name = d.data.res.tutor.full_name;
        var reschedule_status = d.data.res.tutor.reschedule_status;
        _this3.time_zone = d.data.res.tutor.time_zone;
        _this3.$emit('getTutorInfo', d.data.res.tutor);
        console.log(complete_status);
        _this3.$store.commit('update_ntt_self_comlete', complete_status);
        _this3.$store.commit('update_full_name', full_name);
      }
    });

    this.$watch(function () {
      return this.calendar.items.text;
    }, function () {
      this.update_right_date();
    });

    this.$watch(function () {
      return this.update_right_time;
    }, function () {
      this.update_right_date();
    });
  },
  components: {
    Calendar: __WEBPACK_IMPORTED_MODULE_2__common_Calendar_vue___default.a
  },
  watch: {
    time_zone: function time_zone() {
      var _this4 = this;

      this.$http.get('/' + this._bookType.normal + '/get' + this._bookType.upperOne + 'Date?timezone=' + this.time_zone).then(function (d) {
        if (d.data.code == '75000') {
          var _this = _this4;

          var dates = d.data.res.cycles;

          var serve_date = new Date(d.data.res.first_date).getTime() + (dates * 1 - 1) * 24 * 60 * 60 * 1000;

          var dateEnd = new Date(serve_date);

          var year = dateEnd.getFullYear();

          var months = dateEnd.getMonth() + 1 < 10 ? '0' + (dateEnd.getMonth() + 1) : dateEnd.getMonth() + 1;

          var day = dateEnd.getDate() < 10 ? '0' + dateEnd.getDate() : dateEnd.getDate();

          _this4.no_date = false;

          _this4.calendar.items.end = year + '-' + months + '-' + day;

          _this4.calendar.items.begin = d.data.res.first_date;

          _this4.calendar.items.value = d.data.res.default_date;

          _this4.calendar.items.text = d.data.res.default_date;

          _this4.switch_time = d.data.res.switch_time;

          _this4.update_right_time = d.data.res.switch_datetime;

          _this4.$store.dispatch('update_switch_time', _this.switch_time);

          var date = _this4.calendar.items.text + ' ' + _this4.switch_time;

          var url = '/' + _this4._bookType.normal + '/get' + _this4._bookType.upperOne + 'Time?timezone=' + _this4.time_zone + '&working_date=' + date;
        } else {
          _this4.no_date = true;
        }
      });
    }
  }
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_image_crop_upload_upload_2_vue__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_image_crop_upload_upload_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_image_crop_upload_upload_2_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show: true,
      params: {
        token: '123456798',
        name: 'avatar'
      },
      headers: {
        smail: '*_~'
      },
      imgDataUrl: '' };
  },

  components: {
    'my-upload': __WEBPACK_IMPORTED_MODULE_0_vue_image_crop_upload_upload_2_vue___default.a
  },
  methods: {
    toggleShow: function toggleShow() {
      this.show = !this.show;
    },
    cropSuccess: function cropSuccess(imgDataUrl, field) {
      console.log('-------- crop success --------');
      this.imgDataUrl = imgDataUrl;
    },
    cropUploadSuccess: function cropUploadSuccess(jsonData, field) {
      console.log('-------- upload success --------');
      console.log(jsonData);
      console.log('field: ' + field);
    },
    cropUploadFail: function cropUploadFail(status, field) {
      console.log('-------- upload fail --------');
      console.log(status);
      console.log('field: ' + field);
    }
  }
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js__ = __webpack_require__(11);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  data: function data() {
    return {
      videoIsPlay: false,
      urls: __WEBPACK_IMPORTED_MODULE_2__js__["a" /* urls */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['_acDownloadUrl'])),
  methods: {
    playVideoHandler: function playVideoHandler() {
      this.videoIsPlay = true;
    },
    nextHandler: function nextHandler() {
      var _this = this;

      if (!this.videoIsPlay) return;
      var loading = this.$loading();
      this.$http.get('/Personal/psoNext').then(function (d) {
        loading.close();
        if (d.data.code == '75000') {
          var state = d.data.res.next;
          switch (state) {
            case 'fillform':
              _this.$router.replace('/fillform');
              break;

            case 'interview':
              _this.$router.replace('/book_interview');
              break;

            case 'pso':
              _this.$router.replace('/pso');
              break;

            case 'tpg':
              _this.$router.replace('/book_tpg');
              break;

            case 'onboarding':
              _this.$router.replace('/personal_profile/personal_qa');
              break;

            case 'updatepwd':
              _this.$router.replace('/resetcode');
              break;
            case 'end':
              _this.$router.replace('/get_started');
              break;
            default:
              console.log('pso 匹配 error.');
          }
        } else {
          _this.$message.error(d.data.message);
        }
      }).catch(function (err) {
        loading.close();
        _this.$message.error('server error');
      });
    }
  }
});

/***/ }),
/* 438 */
/***/ (function(module, exports) {



/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js__ = __webpack_require__(11);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show: false,
      direction: '',
      urls: __WEBPACK_IMPORTED_MODULE_0__js__["a" /* urls */]
    };
  },

  props: {},
  methods: {
    signOut: function signOut() {
      this.$http.get('/index/logout').then(function (d) {
        if (d.data.code == '75000' && d.data.res) {
          window.location.href = __WEBPACK_IMPORTED_MODULE_0__js__["a" /* urls */].ssoLogout;
        } else {
          this.$message.error('retry.');
        }
      });
    }
  },
  computed: {
    is_logined: function is_logined() {
      console.log(this.$store.state.is_logined);
      return this.$store.state.is_logined;
    }
  },
  created: function created() {
    var uri = window.location.origin.replace(/http.+\/\//, '');
    switch (uri) {
      case 'mypage.us.51talk.com':
        this.direction = __WEBPACK_IMPORTED_MODULE_0__js__["a" /* urls */].ssoUsLogin;
        break;
      case 'mypage.51talk.com':
        this.direction = __WEBPACK_IMPORTED_MODULE_0__js__["a" /* urls */].ssoLogin;
        break;
      default:
        console.log('Sign in match error!');
    }
  }
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_common_Calendar_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_common_Calendar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_common_Calendar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_common_ac_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_common_ac_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_common_ac_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rangeTime',
  components: {
    Calendar: __WEBPACK_IMPORTED_MODULE_0_components_common_Calendar_vue___default.a,
    ac: __WEBPACK_IMPORTED_MODULE_1_components_common_ac_vue___default.a
  },
  data: function data() {
    return {
      hasDate: false,
      username: '',
      words: {
        cancel: false,
        no_show: false
      },

      calendar: {
        show: true,
        x: 0,
        y: 0,
        items: {
          type: 'date',
          begin: '',
          end: '',
          value: '',
          text: '',
          sep: '-',
          rangeValue: '',
          single: true,
          autoclose: true,
          weeks: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        }
      },
      d_time_zone: '',
      time_zone: '',
      time_detail: '',
      switch_time: '',
      time_frame: [],
      right_date_update: '',
      work_start_time: ''
    };
  },

  methods: {
    frameFn: function frameFn(d, idx, work_start_time) {
      for (var i = 0; i < this.time_frame.length; i++) {
        this.time_frame[i].isActive = false;
      }
      this.time_detail = d;
      this.time_frame[idx].isActive = true;
      this.work_start_time = work_start_time;
    },
    open: function open(e, type) {
      this.calendar.show = true;
      this.calendar.x = e.target.offsetLeft;
      this.calendar.y = e.target.offsetTop + e.target.offsetHeight + 8;
    },
    dateCancel: function dateCancel(obj) {
      this.calendar.show = obj.show;
    },
    dateOk: function dateOk(obj) {
      this.calendar.items.text = obj.values[0];
      this.calendar.items.value = obj.values[0];
    },
    submit: function submit() {
      var _this2 = this;

      var params = new URLSearchParams();
      var _this = this;
      var date = this.calendar.items.text + ' ' + this.work_start_time;

      if (!this.time_zone || !date || !this.time_detail) {
        this.$message.error('Please choose a training session!');
        return;
      }
      params.append('timezone', _this.time_zone);
      params.append('working_date', date);
      params.append('working_time', _this.time_detail);
      params.append('action', 'schedule');

      this.axios.post('/tpg/schedule', params).then(function (d) {
        if (d.data.code == '75000') {
          _this2.$message.success('Success!');
          _this2.$router.replace('/tpg?status=assigned');
        } else {
          _this2.$message.error(d.data.message);
        }
      });
    },
    addZero: function addZero(n) {
      return n < 10 ? '0' + n : n;
    },
    update_right_time: function update_right_time() {
      this.time_detail = '';

      var date = this.calendar.items.text + ' ' + this.switch_time;
      this.$http.get('/tpg/getTpgTime?timezone=' + this.time_zone + '&working_date=' + date).then(function (response) {
        if (response.data.code == '75000') {
          this.hasDate = true;
          this.time_frame = [];
          for (var i = 0; i < response.data.res.length; i++) {
            var arrTime = {};
            arrTime.service_id = response.data.res[i].service_id;
            arrTime.working_date = response.data.res[i].working_date;
            arrTime.week = response.data.res[i].week;
            arrTime.work_end_time = response.data.res[i].work_end_time;
            arrTime.work_hour_type = response.data.res[i].work_hour_type;
            arrTime.work_hour_value = response.data.res[i].work_hour_value;
            arrTime.work_start_time = response.data.res[i].work_start_time;
            arrTime.isActive = false;
            this.time_frame.push(arrTime);
          }
        } else {
          this.hasDate = false;

          this.time_frame = [];
          this.time_detail = '';
        }
      }, function () {
        console.log('service error');
      });
    }
  },
  created: function created() {
    var _this3 = this;

    var _this = this;

    var date = new Date();

    var yy = date.getFullYear();

    var mm = date.getMonth() + 1;

    var dd = date.getDate();

    mm = mm < 10 ? '0' + mm : mm;

    dd = dd < 10 ? '0' + dd : dd;

    this.$http.get('/common/getConfig?key=time_zone').then(function (d) {
      if (d.data.code == '75000') {
        _this3.d_time_zone = d.data.res.time_zone;

        _this3.$http.get('/tpg/getTutorInfo').then(function (d) {
          if (d.data.code == '75000') {
            _this3.time_zone = d.data.res.tutor.time_zone;

            _this3.username = d.data.res.tutor.full_name;

            _this3.$watch(function () {
              return this.right_date_update;
            }, function () {
              this.update_right_time();
            });
            _this3.$watch(function () {
              return this.calendar.items.text;
            }, function () {
              this.update_right_time();
            });
          } else {
            _this3.$message.error('making appointments fail.');
          }
        });
      }
    });
  },

  watch: {
    time_zone: function time_zone() {
      var _this4 = this;

      var _this = this;

      this.$http.get('/tpg/getTpgDate?timezone=' + this.time_zone).then(function (d) {
        console.log('watch');
        if (d.data.code == '75000') {
          var dates = d.data.res.cycles;

          var serve_date = new Date(d.data.res.first_date).getTime() + (dates * 1 - 1) * 24 * 60 * 60 * 1000;

          var dateEnd = new Date(serve_date);

          var year = dateEnd.getFullYear();

          var months = _this.addZero(dateEnd.getMonth() + 1);

          var day = _this.addZero(dateEnd.getDate());

          console.log('d.data.res.first_date:' + d.data.res.first_date, 'serve_date:' + serve_date, 'dateEnd:' + dateEnd);

          _this4.calendar.items.end = year + '-' + months + '-' + day;

          _this4.calendar.items.begin = d.data.res.first_date;

          _this4.calendar.items.value = d.data.res.default_date;

          _this4.calendar.items.text = d.data.res.default_date;

          console.log('end:' + year + '-' + months + '-' + day, 'begin:' + d.data.res.first_date, 'value+text:' + d.data.res.default_date);
          _this4.right_date_update = d.data.res.switch_datetime;

          _this4.switch_time = d.data.res.switch_time;

          _this4.calendar.show = false;

          _this4.calendar.show = true;
        } else if (d.data.code == '75001') {
          _this.$router.replace('/pending?status=no_date');
        }
      });
    }
  }
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  data: function data() {
    return {
      full_name: '',
      recruiter_email: ''
    };
  },

  created: function created() {
    var _this = this;

    this.$http.get('/tpg/getTutorInfo').then(function (d) {
      if (d.data.code == '75000') {
        _this.full_name = d.data.res.tutor.full_name;
        _this.recruiter_email = d.data.res.tutor.interviewer_info.interviewer_email;
      }
    });
  }
});

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__other_tpg_demo_reschedule__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__other_tpg_demo_reschedule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__other_tpg_demo_reschedule__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__other_CancelConfirm_vue__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__other_CancelConfirm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__other_CancelConfirm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_ac__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_ac___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_ac__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__js__ = __webpack_require__(11);











/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      urls: __WEBPACK_IMPORTED_MODULE_7__js__["a" /* urls */],
      bookType: 'tpg',
      data: [{
        label: '一级 1',
        children: [{
          label: '二级 1-1',
          children: [{
            label: '三级 1-1-1'
          }]
        }]
      }, {
        label: '一级 2',
        children: [{
          label: '二级 2-1',
          children: [{
            label: '三级 2-1-1'
          }]
        }, {
          label: '二级 2-2',
          children: [{
            label: '三级 2-2-1'
          }]
        }]
      }, {
        label: '一级 3',
        children: [{
          label: '二级 3-1',
          children: [{
            label: '三级 3-1-1'
          }]
        }, {
          label: '二级 3-2',
          children: [{
            label: '三级 3-2-1'
          }]
        }]
      }],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      options: '',
      value8: '',
      appointment: {
        timezone: ''
      },
      staff: {
        name: '',
        zoom_id: '',
        email: '',
        skype: ''
      },
      date_time: '',
      need_help: '',
      isMac: false,
      isWindows: false,
      words: {
        rescheduled: false
      },
      ntt_url: '',
      is1v1: false,
      canReschedule: false
    };
  },
  beforeRouteEnter: function beforeRouteEnter(from, to, next) {
    next(function (vm) {
      vm.$http.get('/Boarding/getTutor').then(function (d) {
        if (d.data.code == '75000') {
          var teacherType = d.data.res.info.sa_version;
          switch (teacherType) {
            case '1':
              vm.is1v1 = true;
              break;
            case '2':
              vm.is1v1 = false;
              break;
          }
        }
      });
      vm.$http.get('/common/getConfig?key=time_zone').then(function (d) {
        if (d.data.code == '75000') {
          vm.options = d.data.res.time_zone;
        }
      });
      vm.$http.get('/tpg/getAppointmentInfo').then(function (d) {
        if (d.data.code == '75000' && d.data.res.appointment) {
          vm.appointment = d.data.res.appointment;

          vm.staff = d.data.res.staff;

          var start_date = vm.appointment.start_time;

          var end_date = vm.appointment.end_time;

          var start_hours = start_date.split(' ')[1].slice(0, 5);

          var end_hours = end_date.split(' ')[1].slice(0, 5);

          var years = start_date.split(' ')[0];

          var times = ['AM', 'Noon', 'PM'];

          var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

          var full_date = new Date(years);

          if (start_hours == '12:00:00') {
            times = times[1];
          } else if (start_hours.split(':')[0] > 12) {
            times = times[2];
          } else if (start_hours.split(':')[0] < 12) {
            times = times[0];
          }

          vm.date_time = start_hours + '-' + end_hours + ' / ' + vm.appointment.working_date_formatted;
        }
      });
    });
  },

  methods: {
    handleNodeClick: function handleNodeClick(data) {},
    getTutorInfo: function getTutorInfo(_ref) {
      var reschedule_status = _ref.reschedule_status,
          interviewer_info = _ref.interviewer_info;

      this.canReschedule = reschedule_status == 1;
      this.need_help = interviewer_info.interviewer_email;
    },
    showPop: function showPop() {
      if (!this.canReschedule) return;
      this.$store.commit('reschedule_pop_show');
    },
    cancel_apo: function cancel_apo() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref2, remark, params, date;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.canReschedule) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _context.next = 4;
                return _this.confirmOpen({
                  type: 'cancel'
                });

              case 4:
                _ref2 = _context.sent;
                remark = _ref2.remark;
                params = new URLSearchParams();
                date = _this.appointment.working_date + ' ' + _this.switch_time;

                params.append('timezone', _this.appointment.timezone_key);
                params.append('working_date', date);
                params.append('working_time', _this.appointment.work_hour_value);
                params.append('action', 'cancel');
                params.append('remark', remark);
                _this.axios.post('/tpg/schedule', params).then(function (d) {
                  if (d.data.code == '75000') {
                    _this.$message.success('Success!');
                    window.location.reload();
                  } else {
                    _this.$message.error(d.data.message);
                  }
                });

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    confirmOpen: function confirmOpen(data) {
      return this.$refs.cancelConfirm.open(data);
    }
  },
  components: {
    reschedule: __WEBPACK_IMPORTED_MODULE_4__other_tpg_demo_reschedule___default.a,
    ac: __WEBPACK_IMPORTED_MODULE_6__common_ac___default.a,
    CancelConfirm: __WEBPACK_IMPORTED_MODULE_5__other_CancelConfirm_vue___default.a
  },
  mounted: function mounted() {},
  computed: {
    reschedule_show: function reschedule_show() {
      return this.$store.state.pop_up;
    },
    switch_time: function switch_time() {
      return this.$store.state.switch_time;
    },
    from: function from() {
      try {
        var params = window.location.href.split('?')[1];
        var arrs = params.split('&');
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(arrs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var opt = _step.value;

            if (opt.split('=')[0] == 'status') {
              return opt.split('=')[1];
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } catch (e) {
        return '';
      }
    },
    complete_ntt: function complete_ntt() {
      return this.$store.state.ntt_self_complete;
    },
    full_name: function full_name() {
      return this.$store.state.full_name;
    }
  }
});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StepStatus',
  props: {
    step: {
      default: 1,
      type: Number
    }
  },

  data: function data() {
    return {
      status: [['Application Form'], ['Interview', '& Demo'], ['New Teacher', 'Orientation'], ['New Teacher', 'Training'], ['Onboarding']]
    };
  }
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isDev; });
/* unused harmony export getType */
/* unused harmony export isObject */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isArray; });
/* unused harmony export isEmptyObject */
/* unused harmony export getNow */
/* unused harmony export getDouble */
/* unused harmony export isToday */
/* unused harmony export getTime */
/* unused harmony export getShortTime */
/* unused harmony export logPrint */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deepCopy; });
/* unused harmony export stringToJson */
/* unused harmony export jsonToString */
/* unused harmony export getObjectLength */
/* unused harmony export lazyExec */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isMac; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return routerController; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return urls; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);






var isDev = function isDev() {
	return (typeof process === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(process)) !== undefined && "production" === 'development';
};

var getType = function getType(src) {
	return Object.prototype.toString.call(src).split(' ').slice(-1)[0].slice(0, -1).toLowerCase();
};

var isObject = function isObject(src) {
	return getType(src) === 'object';
};

var isFunction = function isFunction(src) {
	return getType(src) === 'function';
};

var isArray = function isArray(src) {
	return getType(src) === 'array';
};

var isEmptyObject = function isEmptyObject(src) {
	return getObjectLength(src) === 0;
};

var getNow = function getNow(_) {
	var date = new Date();
	var _ref = [date.toLocaleTimeString(), date.getMilliseconds()],
	    localeTime = _ref[0],
	    milliSeconds = _ref[1];

	var time = localeTime + ' ' + milliSeconds + 'ms';
	return time;
};

var getDouble = function getDouble(str) {
	var _str = str + '';
	return _str.length > 1 ? _str : '0' + _str;
};

var isToday = function isToday(timestamp) {
	return new Date(timestamp).toDateString() === new Date().toDateString();
};

var getTime = function getTime(timestamp) {
	var time = new Date(+timestamp);
	var timeArr = [time.getFullYear(), time.getMonth() + 1, time.getDate(), time.getHours(), time.getMinutes(), time.getSeconds()].map(function (item) {
		return getDouble(item);
	});

	return [timeArr.slice(0, 3).join('/'), timeArr.slice(3).join(':')].join(' ');
};

var getShortTime = function getShortTime(timestamp) {
	var istoday = isToday(timestamp);
	var time = new Date(+timestamp);
	var timeArr = istoday ? [time.getHours(), time.getMinutes()] : [time.getFullYear(), time.getMonth() + 1, time.getDate()];
	timeArr = timeArr.map(function (item) {
		return getDouble(item);
	});
	return timeArr.join(istoday ? ':' : '/');
};

var logPrint = function logPrint(des, tem) {
	if (!isDev()) return;
	if (!tem) {
		tem = des;
		des = 'print';
	}
	var now = getNow();
	console.log('print ====== start ' + now);
	console.log(des, tem);
	console.log('print ====== end ' + now);
};

var deepCopy = function deepCopy(src, res) {
	var result = {};
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(src)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var key = _step.value;

			var item = src[key];
			if (isObject(item)) {
				result[key] = deepCopy(item, res);
			} else {
				result[key] = item;
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	if (isFunction(res)) {
		return res(result);
	} else {
		return result;
	}
};

var stringToJson = function stringToJson(src) {
	try {
		var res = JSON.parse(src);
		if (isObject(res)) {
			return res;
		} else {
			return src;
		}
	} catch (e) {
		return src;
	}
};

var jsonToString = function jsonToString(src) {
	return deepCopy(src, function (res) {
		try {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res);
		} catch (e) {
			console.error('jsonToString err', res);
		}
	});
};

var getObjectLength = function getObjectLength(src) {
	return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(src).length;
};

var lazyExec = function lazyExec(context) {
	var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;

	var timer = null;

	return function (_) {
		clearTimeout(timer);
		timer = setTimeout(context, time);
	};
};

var isMac = function isMac() {
	var reg = /macintosh|mac os x/i;
	return reg.test(window.navigator.userAgent);
};

var routerController = function routerController(_ref2) {
	var state = _ref2.state,
	    exact_state = _ref2.exact_state;

	if (state == 'interview') {
		switch (exact_state) {
			case 'unassigned':
				this.$router.replace('/book_interview?status=unassigned');
				break;
			case 'assigned':
				this.$router.replace('/interview?status=assigned');
				break;
			case 'no show':
				this.$router.replace('/interview_result?status=noshow');
				break;
			case 'canceled':
				this.$router.replace('/interview?status=canceled');
				break;
			case 'rescheduled':
				this.$router.replace('/interview?status=rescheduled');
				break;
			case 'failed':
				this.$router.replace('/interview_result?status=failed');
				break;
			case 'passed':
				this.$router.replace('/interview_pass?status=passed');
				break;
			default:
				console.log('interview流程匹配错误');
		}

		return;
	}

	if (state == 'tpg') {
		switch (exact_state) {
			case 'unassigned':
				this.$router.replace('/book_tpg?status=unassigned');
				break;
			case 'canceled':
				this.$router.replace('/tpg?status=canceled');
				break;

			case 'no show':
				this.$router.replace('/tpg_result?status=noshow');
				break;
			case 'assigned':
				this.$router.replace('/tpg?status=assigned');
				break;
			case 'rescheduled':
				this.$router.replace('/tpg?status=rescheduled');
				break;
			case 'failed':
				this.$router.replace('/tpg_result?status=failed');
				break;
			default:
				console.log('tpg流程匹配错误');
		}

		return;
	}

	if (state == 'new_demo') {
		switch (exact_state) {
			case 'unassigned':
				this.$router.replace('/book_demo?status=unassigned');
				break;
			case 'canceled':
				this.$router.replace('/demo?status=canceled');
				break;

			case 'no show':
				this.$router.replace('/demo_result?status=noshow');
				break;
			case 'assigned':
				this.$router.replace('/demo?status=assigned');
				break;
			case 'rescheduled':
				this.$router.replace('/demo?status=rescheduled');
				break;
			case 'failed':
				this.$router.replace('/demo_result?status=failed');
				break;
			default:
				console.log('demo流程匹配错误');
		}

		return;
	}

	if (state == 'onboarding') {
		switch (exact_state) {
			case 'info':
				this.$router.replace('/personal_profile/personal_in');
				break;
			case 'qualific':
				this.$router.replace('/personal_profile/personal_qa');
				break;
			case 'paymode':
				this.$router.replace('/personal_profile/payment');
				break;
			case 'video':
				this.$router.replace('/personal_profile/on_board');
				break;
			case 'sa':
				this.$router.replace('/personal_profile/sign_sa');
				break;
			default:
				console.log('onboardoing service error!');
		}

		return;
	}

	if (state == 'end') {
		switch (exact_state) {
			case 'upased':
				this.$router.replace('/online_pending');
				break;
			case 'success':
				this.$router.replace('/get_started');
				break;
			case 'failed':
				this.$router.replace('/online_failed');
				break;
			case 'assigned':
				window.location.href = urls.myPageLogTea;
				break;
			default:
				console.log('end流程返回错误.');
		}

		return;
	}

	switch (state) {
		case 'fillform':
			if (exact_state) {
				this.$router.replace('/fillform?status=' + exact_state);
				return;
			}

			this.$router.replace('/fillform');
			break;
		case 'pso':
			this.$router.replace('/pso');
			break;
		case 'updatepwd':
			this.$router.replace('/resetcode');
			break;
		case 'end':
			this.$router.replace('/get_started');
			break;
		default:
			console.log('大流程匹配失败!');
	}
};

var urls = {
	ssoLogin: 'http://sso.51talk.com/sso/admin?client=13&lang=english',
	ssoUsLogin: 'http://sso.us.51talk.com/sso/admin?client=13&lang=english',
	ssoLogout: 'http://sso.51talk.com/sso/logout?client=13&lang=english',
	myPageLogTea: 'http://mypage.51talk.com/admin/main.php?flag=trues&log_tea=tea',
	goLogout: 'https://login.51talk.com/sso/logout?client=13',
	landingUsaRegister: 'https://mypage.51talk.com/ph/landing_usa_register.php',
	naFaq: 'https://www.51talk.com/na/faq.php',

	trainingModulesLink: 'https://elearning.easygenerator.com/35334358-aa1c-4ee6-a579-251db1020ba8',

	zoomPdfLink: '//static.51talk.com/text/ImmediatelyExperience/zoom.pdf?v=65738933',
	interviewPdfLink: '//static.51talk.com/text/ImmediatelyExperience/nademomaterial_20180818.pdf',

	psoVideoLink: '//static.51talk.com/upload/video/Orientation%20Video-PSO.mp4',

	acMacDownloadLink: 'https://ac.51talk.com/PcAc/version/51Talk-MAC.1.15.0.1.dmg',
	acPcDownloadLink: 'https://ac.51talk.com/PcAc/version/51Talk-AC.2.15.0.72.exe'
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(331)))

/***/ }),
/* 445 */
/***/ (function(module, exports) {



/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_index_css__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins__ = __webpack_require__(343);












__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9__plugins__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en___default.a });

var vm = new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
	el: '#app',
	router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
	store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].beforeEach(function (to, from, next) {
	if (to.query.test === 'open') {
		next();
		return;
	}


	if (to.path == '/FAQ' || to.path == '/POLICY') {
		next();
		return;
	}
	window.scrollTo(0, 0);

	vm.$http.get('/index/islogin').then(function (d) {
		vm.$store.commit('update_login_status', d.data.res);

		if (d.data && d.data.code == '75000' && d.data.res.is_login) {

			var state = d.data.res.status;

			var exact_state = d.data.res.exact_status;
			vm.$store.commit('update_login_state', d.data.res.is_login);

			var nextReset = function nextReset() {
				return next('/login_status');
			};


			if (to.path == '/resetcode' || to.path == '/login_status') {
				next();
				return;
			}

			if (to.path == '/' || to.path == '/rigister') {
				next(false);
				return;
			}

			if (state == 'interview') {
				if (to.path == '/interview' || to.path == '/interview_result' || to.path == '/book_interview' || to.path == '/pending' || to.path == '/interview_pass') {
					if (from.path == '/interview_result' || from.path == '/pending' || from.path == '/interview_pass' || from.path == '/interview') {
						nextReset();
					} else {
						next();
					}
				} else {
					nextReset();
				}

				return;
			}

			if (state == 'tpg') {
				if (to.path == '/tpg' || to.path == '/book_tpg' || to.path == '/interview_result' || to.path == '/pending' || to.path == '/tpg_result') {
					if (from.path == '/pending' || from.path == '/tpg_result' || from.path == '/tpg') {
						nextReset();
					} else {
						next();
					}
				} else {
					nextReset();
				}

				return;
			}

			if (state == 'demo') {
				if (to.path == '/demo' || to.path == '/book_demo' || to.path == '/tpg_result' || to.path == '/pending' || to.path == '/demo_result') {
					if (from.path == '/pending' || from.path == '/demo_result' || from.path == '/demo') {
						nextReset();
					} else {
						next();
					}
				} else {
					nextReset();
				}

				return;
			}

			if (state == 'onboarding') {
				if (to.path == '/personal_profile/personal_in' || to.path == '/personal_profile/personal_qa' || to.path == '/personal_profile/payment' || to.path == '/personal_profile/on_board' || to.path == '/personal_profile/sign_sa' || to.path == '/online_pending' || to.path == '/online_failed') {
					next();
				} else {
					nextReset();
				}

				return;
			}

			if (state == 'end') {
				if (to.path == '/online_pending' || to.path == '/online_failed' || to.path == '/get_started') {
					next();
				} else {
					nextReset();
				}

				return;
			}

			if (to.path == '/pso' && state != 'pso') {
				nextReset();
			} else {
				next();
			}
		} else {
			next();

			vm.$store.commit('update_login_state', false);

			if (to.name != 'rigister_init' && to.name != 'rigister' && to.name != 'privacy_policy' && to.name != 'forgot_password_step1' && to.name != 'forgot_password_step2' && to.name != 'forgot_password_step3' && to.name != 'forgot_password_step4' && to.name != 'FAQ' && to.name != 'POLICY') {
				window.location.href = __WEBPACK_IMPORTED_MODULE_8__js__["a" /* urls */].ssoLogin;
			}
		}
	});
});

/***/ }),
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 705 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 706 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 707 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 708 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 709 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 710 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 711 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 712 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 713 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 714 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 715 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 716 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 717 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 718 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 719 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 720 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 721 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 722 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 723 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 725 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 726 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 727 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 728 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 729 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 730 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 731 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 732 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 733 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 734 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 735 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 736 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 737 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 738 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 739 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 740 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 741 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 742 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 743 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 744 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 745 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 746 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 747 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 748 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 749 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 750 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 751 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 752 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 753 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 754 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 755 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 756 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 758 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 759 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 760 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 762 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 763 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 216,
	"./af.js": 216,
	"./ar": 223,
	"./ar-dz": 217,
	"./ar-dz.js": 217,
	"./ar-kw": 218,
	"./ar-kw.js": 218,
	"./ar-ly": 219,
	"./ar-ly.js": 219,
	"./ar-ma": 220,
	"./ar-ma.js": 220,
	"./ar-sa": 221,
	"./ar-sa.js": 221,
	"./ar-tn": 222,
	"./ar-tn.js": 222,
	"./ar.js": 223,
	"./az": 224,
	"./az.js": 224,
	"./be": 225,
	"./be.js": 225,
	"./bg": 226,
	"./bg.js": 226,
	"./bn": 227,
	"./bn.js": 227,
	"./bo": 228,
	"./bo.js": 228,
	"./br": 229,
	"./br.js": 229,
	"./bs": 230,
	"./bs.js": 230,
	"./ca": 231,
	"./ca.js": 231,
	"./cs": 232,
	"./cs.js": 232,
	"./cv": 233,
	"./cv.js": 233,
	"./cy": 234,
	"./cy.js": 234,
	"./da": 235,
	"./da.js": 235,
	"./de": 238,
	"./de-at": 236,
	"./de-at.js": 236,
	"./de-ch": 237,
	"./de-ch.js": 237,
	"./de.js": 238,
	"./dv": 239,
	"./dv.js": 239,
	"./el": 240,
	"./el.js": 240,
	"./en-au": 241,
	"./en-au.js": 241,
	"./en-ca": 242,
	"./en-ca.js": 242,
	"./en-gb": 243,
	"./en-gb.js": 243,
	"./en-ie": 244,
	"./en-ie.js": 244,
	"./en-nz": 245,
	"./en-nz.js": 245,
	"./eo": 246,
	"./eo.js": 246,
	"./es": 248,
	"./es-do": 247,
	"./es-do.js": 247,
	"./es.js": 248,
	"./et": 249,
	"./et.js": 249,
	"./eu": 250,
	"./eu.js": 250,
	"./fa": 251,
	"./fa.js": 251,
	"./fi": 252,
	"./fi.js": 252,
	"./fo": 253,
	"./fo.js": 253,
	"./fr": 256,
	"./fr-ca": 254,
	"./fr-ca.js": 254,
	"./fr-ch": 255,
	"./fr-ch.js": 255,
	"./fr.js": 256,
	"./fy": 257,
	"./fy.js": 257,
	"./gd": 258,
	"./gd.js": 258,
	"./gl": 259,
	"./gl.js": 259,
	"./gom-latn": 260,
	"./gom-latn.js": 260,
	"./he": 261,
	"./he.js": 261,
	"./hi": 262,
	"./hi.js": 262,
	"./hr": 263,
	"./hr.js": 263,
	"./hu": 264,
	"./hu.js": 264,
	"./hy-am": 265,
	"./hy-am.js": 265,
	"./id": 266,
	"./id.js": 266,
	"./is": 267,
	"./is.js": 267,
	"./it": 268,
	"./it.js": 268,
	"./ja": 269,
	"./ja.js": 269,
	"./jv": 270,
	"./jv.js": 270,
	"./ka": 271,
	"./ka.js": 271,
	"./kk": 272,
	"./kk.js": 272,
	"./km": 273,
	"./km.js": 273,
	"./kn": 274,
	"./kn.js": 274,
	"./ko": 275,
	"./ko.js": 275,
	"./ky": 276,
	"./ky.js": 276,
	"./lb": 277,
	"./lb.js": 277,
	"./lo": 278,
	"./lo.js": 278,
	"./lt": 279,
	"./lt.js": 279,
	"./lv": 280,
	"./lv.js": 280,
	"./me": 281,
	"./me.js": 281,
	"./mi": 282,
	"./mi.js": 282,
	"./mk": 283,
	"./mk.js": 283,
	"./ml": 284,
	"./ml.js": 284,
	"./mr": 285,
	"./mr.js": 285,
	"./ms": 287,
	"./ms-my": 286,
	"./ms-my.js": 286,
	"./ms.js": 287,
	"./my": 288,
	"./my.js": 288,
	"./nb": 289,
	"./nb.js": 289,
	"./ne": 290,
	"./ne.js": 290,
	"./nl": 292,
	"./nl-be": 291,
	"./nl-be.js": 291,
	"./nl.js": 292,
	"./nn": 293,
	"./nn.js": 293,
	"./pa-in": 294,
	"./pa-in.js": 294,
	"./pl": 295,
	"./pl.js": 295,
	"./pt": 297,
	"./pt-br": 296,
	"./pt-br.js": 296,
	"./pt.js": 297,
	"./ro": 298,
	"./ro.js": 298,
	"./ru": 299,
	"./ru.js": 299,
	"./sd": 300,
	"./sd.js": 300,
	"./se": 301,
	"./se.js": 301,
	"./si": 302,
	"./si.js": 302,
	"./sk": 303,
	"./sk.js": 303,
	"./sl": 304,
	"./sl.js": 304,
	"./sq": 305,
	"./sq.js": 305,
	"./sr": 307,
	"./sr-cyrl": 306,
	"./sr-cyrl.js": 306,
	"./sr.js": 307,
	"./ss": 308,
	"./ss.js": 308,
	"./sv": 309,
	"./sv.js": 309,
	"./sw": 310,
	"./sw.js": 310,
	"./ta": 311,
	"./ta.js": 311,
	"./te": 312,
	"./te.js": 312,
	"./tet": 313,
	"./tet.js": 313,
	"./th": 314,
	"./th.js": 314,
	"./tl-ph": 315,
	"./tl-ph.js": 315,
	"./tlh": 316,
	"./tlh.js": 316,
	"./tr": 317,
	"./tr.js": 317,
	"./tzl": 318,
	"./tzl.js": 318,
	"./tzm": 320,
	"./tzm-latn": 319,
	"./tzm-latn.js": 319,
	"./tzm.js": 320,
	"./uk": 321,
	"./uk.js": 321,
	"./ur": 322,
	"./ur.js": 322,
	"./uz": 324,
	"./uz-latn": 323,
	"./uz-latn.js": 323,
	"./uz.js": 324,
	"./vi": 325,
	"./vi.js": 325,
	"./x-pseudo": 326,
	"./x-pseudo.js": 326,
	"./yo": 327,
	"./yo.js": 327,
	"./zh-cn": 328,
	"./zh-cn.js": 328,
	"./zh-hk": 329,
	"./zh-hk.js": 329,
	"./zh-tw": 330,
	"./zh-tw.js": 330
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 764;

/***/ }),
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/KEOT.9485dfc.jpg";

/***/ }),
/* 770 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/stared_bird.4966f9a.png";

/***/ }),
/* 772 */,
/* 773 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(754)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(860),
  /* scopeId */
  "data-v-76120e0d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(760)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(865),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(721)
__webpack_require__(722)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(833),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(708)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(819),
  /* scopeId */
  "data-v-0cd07cfe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(742)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(850),
  /* scopeId */
  "data-v-64ee553b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(704)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(815),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(748)
__webpack_require__(747)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(855),
  /* scopeId */
  "data-v-68006215",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(715)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(827),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(743)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(851),
  /* scopeId */
  "data-v-655e05f7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(744)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(852),
  /* scopeId */
  "data-v-656c1d78",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(745)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(853),
  /* scopeId */
  "data-v-657a34f9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(746)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(854),
  /* scopeId */
  "data-v-65884c7a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(727)
__webpack_require__(726)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(837),
  /* scopeId */
  "data-v-41f87235",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(759)
__webpack_require__(758)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(864),
  /* scopeId */
  "data-v-92cf4a36",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(709)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(821),
  /* scopeId */
  "data-v-12f5c75d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(733)
__webpack_require__(732)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(842),
  /* scopeId */
  "data-v-4cdde596",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(719)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(830),
  /* scopeId */
  "data-v-39a2c869",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(737)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(845),
  /* scopeId */
  "data-v-5c8e9010",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(717)
__webpack_require__(718)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(829),
  /* scopeId */
  "data-v-2eee1aec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(752)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(858),
  /* scopeId */
  "data-v-6f308110",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(740)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(848),
  /* scopeId */
  "data-v-64189510",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(736)
__webpack_require__(735)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(844),
  /* scopeId */
  "data-v-5a96e40e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(761)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(866),
  /* scopeId */
  "data-v-d55acbcc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(739)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(847),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(763)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(868),
  /* scopeId */
  "data-v-fe3c3870",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(728)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(838),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(820),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(823),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(861),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(725)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(836),
  /* scopeId */
  "data-v-40b49bdc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(705)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(816),
  /* scopeId */
  "data-v-05ec4e08",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(731)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(841),
  /* scopeId */
  "data-v-49a5470a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(751)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(857),
  /* scopeId */
  "data-v-6e57bdb4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(713)
__webpack_require__(712)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(825),
  /* scopeId */
  "data-v-19c283ef",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(832),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(716)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(828),
  /* scopeId */
  "data-v-2edbcd0a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(714)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(826),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(729)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(839),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(749)
__webpack_require__(750)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(856),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(706)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(817),
  /* scopeId */
  "data-v-072246bf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(762)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(867),
  /* scopeId */
  "data-v-e9a27f8e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(734)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(843),
  /* scopeId */
  "data-v-4e327297",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 815 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form_wrapper"
  }, [_c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.$route.meta.step
    }
  }), _vm._v(" "), _c(_vm.fillformStatus, {
    tag: "components",
    attrs: {
      "status": _vm.$route.query.status
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 816 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pending_wrap"
  }, [_c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.$route.meta.step
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Pending result")]), _vm._v(" "), _c('div', {
    staticClass: "letter"
  }, [_c('p', [_vm._v("Dear " + _vm._s(_vm.full_name) + ",")]), _vm._v(" "), _c('p', [_vm._v("Thank you for completing all of the steps in the application,interview,and training stages,this is the final total teacher profile check performed to ensure the requirements and qualifications of new teachers meet the overall standards prior to being added to the system. You will receive a feedback from our team within 3 business days.")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "download"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', [_c('ac')], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Best,"), _c('br'), _vm._v("HAWO Recruitment Team")])
}]}

/***/ }),
/* 817 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pending_wrap"
  }, [_c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.$route.meta.step
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Teaching practice guide result")]), _vm._v(" "), (_vm.$route.query.status == "noshow") ? _c('div', {
    staticClass: "letter"
  }, [_c('p', [_vm._v("\n      It looks like your HAWO teaching practice guide didn't take place. "), _c('br'), _vm._v("Kindly contact your recruiter via email at\n      "), _c('a', {
    attrs: {
      "href": ("mailto:" + _vm.recruiter_email)
    }
  }, [_vm._v(_vm._s(_vm.recruiter_email))]), _vm._v(" to further assist you.\n    ")]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.$route.query.status == "failed") ? _c('div', {
    staticClass: "letter"
  }, [_c('p', [_vm._v("Dear " + _vm._s(_vm.full_name) + ",")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("We wish you all the best in your future endeavors.")]), _vm._v(" "), _vm._m(2)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      Kind Regards, "), _c('br'), _vm._v(" HAWO Recruitment Team\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Thank you for your interest in joining the HAWO team. "), _c('br'), _vm._v("After thorough evaluation of your profile, we regret to inform you that your application was not selected for further consideration. While your qualifications are impressive, our selection process is highly competitive.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Best,"), _c('br'), _vm._v("The HAWO Recruitment Team")])
}]}

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showHeader) ? _c('app-header') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "route_view"
  }, [_c('keep-alive', [_c('router-view')], 1)], 1), _vm._v(" "), (_vm.showFooter) ? _c('app-footer') : _vm._e(), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('img', {
    staticStyle: {
      "border-style": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "alt": "",
      "src": "//googleads.g.doubleclick.net/pagead/viewthroughconversion/852175291/?guid=ON&script=0"
    }
  })])
}]}

/***/ }),
/* 819 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "interview_wrapper"
  }, [_c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.$route.meta.step
    }
  }), _vm._v(" "), (_vm.$route.query.status !== "canceled" && _vm.$route.query.status !== "rescheduled") ? _c('h1', [_vm._v("\n      Hi " + _vm._s(_vm.full_name) + ", "), _c('br'), _vm._v(" Thank you for attending the Teaching Practice Session. Please see your final demo schedule: "), _c('br'), _vm._v(" Please make sure to finish modules 4-10. These must be finished prior to the Final Demo.\n    ")]) : _vm._e(), _vm._v(" "), (_vm.$route.query.status == "rescheduled") ? _c('h1', [_vm._v("Hi " + _vm._s(_vm.full_name) + ", your demo appointment has been rescheduled.")]) : _vm._e(), _vm._v(" "), (_vm.$route.query.status == "canceled") ? _c('h1', [_vm._v("Dear " + _vm._s(_vm.full_name) + ", you've cancelled your scheduled demo time. You may request a new appointment. ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "schedule"
  }, [_c('h4', [_vm._v("Your scheduled demo time")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "date_select"
  }), _vm._v(" "), _c('div', {
    staticClass: "schedule_de clearfix"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('ul', [_c('li', {
    staticClass: "clearfix"
  }, [_c('span', [_vm._v("Time Zone：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.appointment.timezone))])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('span', [_vm._v("Date & Time：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.date_time))])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Kindly contact your recruiter since you've already rescheduled/cancelled once.",
      "placement": "right",
      "disabled": _vm.canReschedule
    }
  }, [_c('a', {
    staticClass: "style reschedule",
    class: {
      dis: !_vm.canReschedule
    },
    on: {
      "click": _vm.showPop
    }
  }, [_vm._v(_vm._s(_vm.$route.query.status == "canceled" ? 'Schedule' : 'Reschedule'))])]), _vm._v(" "), (_vm.date_time) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Kindly contact your recruiter since you've already rescheduled/cancelled once.",
      "placement": "right",
      "disabled": _vm.canReschedule
    }
  }, [_c('a', {
    staticClass: "style cancel",
    class: {
      dis: !_vm.canReschedule
    },
    on: {
      "click": _vm.cancel_apo
    }
  }, [_vm._v("Cancel Appointment")])]) : _vm._e(), _vm._v(" "), (_vm.need_help) ? _c('a', {
    staticClass: "need_help",
    attrs: {
      "href": ("mailto:" + _vm.need_help)
    }
  }, [_vm._v("Have questions? Email here")]) : _vm._e()], 1)]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "session session-s"
  }, [_c('h4', [_vm._v("Training Modules")]), _vm._v(" "), _c('div', {
    staticClass: "preparation_de no_bg"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": _vm.urls.trainingModulesLink,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.urls.trainingModulesLink))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reschedule_show),
      expression: "reschedule_show"
    }],
    staticClass: "pop"
  }, [_c('reschedule', {
    attrs: {
      "scheduled-time-zone": _vm.appointment.timezone_key,
      "scheduled-start-time": _vm.appointment.start_time,
      "scheduled-end-time": _vm.appointment.end_time,
      "time-zone": _vm.options,
      "book-type": _vm.bookType,
      "sureHandler": _vm.confirmOpen,
      "queryStatus": _vm.$route.query.status
    },
    on: {
      "getTutorInfo": _vm.getTutorInfo
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "download"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', [_c('ac')], 1)])]), _vm._v(" "), _c('cancel-confirm', {
    ref: "cancelConfirm"
  }), _vm._v(" "), (_vm.$route.query.status == "assigned") ? _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('img', {
    staticStyle: {
      "border-style": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "alt": "",
      "src": "//www.googleadservices.com/pagead/conversion/852175291/?label=jUeFCKHuyngQu9OslgM&guid=ON&script=0"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.$route.query.status == "canceled") ? _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('img', {
    staticStyle: {
      "border-style": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "alt": "",
      "src": "//www.googleadservices.com/pagead/conversion/852175291/?label=5q8jCM_HsngQu9OslgM&guid=ON&script=0"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.$route.query.status == "rescheduled") ? _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('img', {
    staticStyle: {
      "border-style": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "alt": "",
      "src": "//www.googleadservices.com/pagead/conversion/852175291/?label=iMvTCMvGsngQu9OslgM&guid=ON&script=0"
    }
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "clearfix"
  }, [_c('span', [_vm._v("Where：")]), _vm._v(" "), _c('p', [_vm._v("Your teaching practice session will be conducted on AC."), _c('br'), _vm._v(" Please contact your recruiter for your AC login credentials.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tip"
  }, [_vm._v("\n        Please contact your recruiter if you need any assistance, or if you have any questions."), _c('br'), _vm._v(" Failure to attend your scheduled demo may disqualify you for the position.\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "session"
  }, [_c('h4', [_vm._v("Live Training Session")]), _vm._v(" "), _c('div', {
    staticClass: "preparation_de"
  }, [_c('p', [_vm._v("Please take note of these further instructions for the session:")]), _vm._v(" "), _c('div', [_c('ul', [_c('li', [_vm._v("Please add trainer as a contact on Zoom 30 minutes before the training and send them your updated speed test result link as a confirmation for "), _c('br'), _vm._v("the training session.")]), _vm._v(" "), _c('li', [_vm._v("Please have your HEADSET set up for the session. You need a corded headset (USB plugged) with noise cancellation feature. ")]), _vm._v(" "), _c('li', [_vm._v("Please have the right background set up. You should have a solid light colored background with adequate lighting and no distractions.")]), _vm._v(" "), _c('li', [_vm._v("You must be using a laptop or PC (Windows or Mac) – Do not use a mobile or tablet.")])])])])])
}]}

/***/ }),
/* 820 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pending_wrap"
  }, [_c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.$route.meta.step
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Pending result")]), _vm._v(" "), _c('div', {
    staticClass: "letter"
  }, [_c('p', [_vm._v("Dear " + _vm._s(_vm.full_name) + ",")]), _vm._v(" "), _c('p', [_vm._v("Thank you for completing all of the steps in the application,interview,and training stages,this is the final total teacher profile check performed to ensure the requirements and qualifications of new teachers meet the overall standards prior to being added to the system. You will receive a feedback from our team within 3 business days.")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.$route.query.status == "passed") ? _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('img', {
    staticStyle: {
      "border-style": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "alt": "",
      "src": "//www.googleadservices.com/pagead/conversion/852175291/?label=dFR5CIzryngQu9OslgM&guid=ON&script=0"
    }
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Best,"), _c('br'), _vm._v("The HAWO Recruitment Team")])
}]}

/***/ }),
/* 822 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "downLoad mypage_icon",
    attrs: {
      "href": _vm.myPageLogTea,
      "target": "_blank"
    }
  }, [_vm._v("My Page")])
},staticRenderFns: []}

/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 824 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file_upload_input",
    style: ({
      width: _vm.c_wid + 'px'
    }),
    on: {
      "change": _vm.upload
    }
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.words))]), _vm._v(" "), _c('a', [_vm._v(_vm._s(_vm.BtnText))])])])
},staticRenderFns: []}

/***/ }),
/* 825 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reset_wrapper"
  }, [_c('div', {
    staticClass: "reset_container"
  }, [_c('div', {
    staticClass: "reset_option"
  }, [_c('h4', [_vm._v("Change Password")]), _vm._v(" "), _c('el-form', {
    ref: "changePassword",
    attrs: {
      "model": _vm.changePassword,
      "status-icon": "",
      "rules": _vm.changePasswordRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "current_pwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "Current Password ＊"
    },
    model: {
      value: (_vm.changePassword.current_pwd),
      callback: function($$v) {
        _vm.changePassword.current_pwd = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "changePassword.current_pwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "new_pwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "New Password ＊"
    },
    on: {
      "focus": function($event) {
        _vm.focus_on = true;
        _vm.init = true
      },
      "blur": function($event) {
        _vm.focus_on = false
      }
    },
    model: {
      value: (_vm.changePassword.new_pwd),
      callback: function($$v) {
        _vm.changePassword.new_pwd = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "changePassword.new_pwd"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_off),
      expression: "show_off"
    }],
    staticClass: "notice"
  }, [_c('p', {
    class: _vm.getClass('type1')
  }, [_vm._v("8 to 25 characters")]), _vm._v(" "), _c('p', {
    class: _vm.getClass('type2')
  }, [_vm._v("Upper & lowercase letters")]), _vm._v(" "), _c('p', {
    class: _vm.getClass('type3')
  }, [_vm._v("At least one number")]), _vm._v(" "), _c('p', {
    class: _vm.getClass('type4')
  }, [_vm._v("Can not use special numeric except !@#$%^&*()?\n              <>._-")])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "re_new_pwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "Retype New Password ＊"
    },
    model: {
      value: (_vm.changePassword.re_new_pwd),
      callback: function($$v) {
        _vm.changePassword.re_new_pwd = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "changePassword.re_new_pwd"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('a', {
    staticClass: "cancel",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('a', {
    staticClass: "save",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "orange_bar"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(336),
      "alt": "",
      "width": "60"
    }
  }), _vm._v(" "), _c('dl', {
    staticClass: "company"
  }, [_c('dt', {
    staticClass: "clearfix concact_us"
  }, [_c('div', [_c('h4', [_vm._v("LET'S BE FRIENDS")]), _vm._v(" "), _c('ul', {
    staticClass: "icon_list clearfix"
  }, [_c('li', [_c('a', {
    staticClass: "facebook",
    attrs: {
      "href": "https://www.facebook.com/51TalkHelloWorldAA/",
      "target": "_blank"
    }
  })]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "twitter",
    attrs: {
      "href": "https://twitter.com/51TalkHWAA",
      "target": "_blank"
    }
  })])])]), _vm._v(" "), _c('div', {}, [_c('h4', [_vm._v("CONTACT US")]), _vm._v(" "), _c('ul', {
    staticClass: "concact_type has_l_border"
  }, [_c('li', {
    staticClass: "p27"
  }, [_vm._v("teach@51talk.com")])])])]), _vm._v(" "), _c('dd', [_c('p', [_vm._v("51Talk English International, Inc. 2017 All Rights Reserved")])])])])
}]}

/***/ }),
/* 827 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form_wrapper_inner fill_form_fail"
  }, [(_vm.status == 'pending') ? [_c('h1', [_vm._v("Pending Confirmation")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)] : _vm._e(), _vm._v(" "), (_vm.status == 'failure') ? [_c('h1', [_vm._v("Confirmation Result")]), _vm._v(" "), _c('p', [_vm._v("Thank you for your application to teach with 51Talk.")]), _vm._v(" "), _c('p', [_vm._v("Unfortunately, we have decided not to move forward in the recruitment process with your application.")]), _vm._v(" "), _c('p', [_vm._v("We appreciate the time and effort you have put into applying, and wish you the best of luck in your job search.")]), _vm._v(" "), _vm._m(2)] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Thank you for submitting your application. We will review your information and provide you with feedback via email.\n      "), _c('br'), _vm._v(" You may also log in here to see the results within 3 business days.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Best,"), _c('br'), _vm._v("The HAWO Recruitment Team")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Best,"), _c('br'), _vm._v("The HAWO Recruitment Team")])
}]}

/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pso"
  }, [_c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.$route.meta.step
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "video"
  }, [_c('div', {
    staticClass: "video_cont"
  }, [_c('video', {
    attrs: {
      "src": _vm.urls.psoVideoLink,
      "controls": "controls"
    },
    on: {
      "play": _vm.playVideoHandler
    }
  })])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "next_cont"
  }, [_c('a', {
    staticClass: "button",
    class: {
      cancel: !_vm.videoIsPlay
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.nextHandler
    }
  }, [_vm._v("Next")])]), _vm._v(" "), _vm._m(2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "guide"
  }, [_vm._v("\n    Congratulations on passing your final interview with our Recruitment Team! "), _c('br'), _vm._v("\n    To learn more about our HAWO Group Class training program, please watch the videos below:\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pso_tip"
  }, [_c('p', [_vm._v("We hope you were able to get a better understanding of the basics of Group Class, the training path, and the expectations we have for this training.")]), _vm._v(" "), _c('p', [_vm._v("\n      Please make sure to check your email or Skype for the next step/s in the process. Your recruiter will be reaching out to you via those channels."), _c('br'), _vm._v("\n      You may also add the HAWO Recruitment Skype: live:.cid.9d7dbebba05d49b9 for faster coordination.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('img', {
    staticStyle: {
      "border-style": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "alt": "",
      "src": "//www.googleadservices.com/pagead/conversion/852175291/?label=uP-SCPvDsngQu9OslgM&guid=ON&script=0"
    }
  })])
}]}

/***/ }),
/* 829 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.up_loading),
      expression: "up_loading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticClass: "on_board",
    attrs: {
      "element-loading-text": "Uploading..."
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg_json.title))]), _vm._v(" "), _c('ol', _vm._l((_vm.msg_json.list), function(msg, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(msg))])
  })), _vm._v(" "), _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.action,
      "before-upload": _vm.beforeUpload,
      "on-success": _vm.upload_s_fn,
      "mul10ple": false,
      "show-file-list": false
    }
  }, [_c('inputUpload', {
    attrs: {
      "init_width": _vm.init_width,
      "words": _vm.words
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "self"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg_json.title_self))]), _vm._v(" "), _c('ol', _vm._l((_vm.msg_json.list_self), function(msg, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(msg))])
  })), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.self_intor),
      expression: "self_intor",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "name": "",
      "id": "",
      "cols": "30",
      "rows": "10",
      "placeholder": "Write your self-introduction here *"
    },
    domProps: {
      "value": (_vm.self_intor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.self_intor = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', [_c('span', {
    class: {
      red: _vm.self_br
    }
  }, [_vm._v(_vm._s(_vm.self_nub))]), _vm._v("/1000")])]), _vm._v(" "), _c('a', {
    staticClass: "save",
    class: {
      cancel: !_vm.has_audio || _vm.self_intor === ''
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Save")]), _vm._v(" "), (_vm.audioSrc) ? _c('div', {
    staticClass: "audio"
  }, [_c('audio', {
    attrs: {
      "src": _vm.audioSrc,
      "controls": "",
      "autoplay": "autoplay"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shadow",
    on: {
      "click": function($event) {
        _vm.offShadow()
      }
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 830 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pending_wrap"
  }, [_c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.$route.meta.step
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Interview result")]), _vm._v(" "), (_vm.$route.query.status == "noshow") ? _c('div', {
    staticClass: "letter"
  }, [_c('p', [_vm._v("\n      It looks like your HAWO interview didn't take place. "), _c('br'), _vm._v("Kindly contact your recruiter via email at\n      "), _c('a', {
    attrs: {
      "href": ("mailto:" + _vm.recruiter_email)
    }
  }, [_vm._v(_vm._s(_vm.recruiter_email))]), _vm._v(" to further assist you.\n    ")]), _vm._v(" "), _vm._m(0)]) : _c('div', {
    staticClass: "letter"
  }, [_c('p', [_vm._v("Dear " + _vm._s(_vm.full_name) + ",")]), _vm._v(" "), _c('p', [_vm._v("Thank you for your application. Unfortunately, we will be unable to move forward in the recruitment process with your application.")]), _vm._v(" "), _c('p', [_vm._v("I appreciate the time and effort you have put into applying, and wish you the best of luck in your job search.")]), _vm._v(" "), _vm._m(1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Kind Regards, "), _c('br'), _vm._v("HAWO Recruitment Team")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Kind Regards,"), _c('br'), _vm._v("HAWO Recruitment Team")])
}]}

/***/ }),
/* 831 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.mac_sys_url) ? _c('a', {
    staticClass: "downLoad",
    attrs: {
      "href": _vm.mac_sys_url,
      "download": "AC"
    }
  }, [_vm._v("AC")]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 832 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticClass: "btn",
    on: {
      "click": _vm.toggleShow
    }
  }, [_vm._v("设置头像")]), _vm._v(" "), _c('my-upload', {
    attrs: {
      "field": "img",
      "width": 300,
      "height": 300,
      "url": "/upload",
      "params": _vm.params,
      "headers": _vm.headers,
      "img-format": "png"
    },
    on: {
      "crop-success": _vm.cropSuccess,
      "crop-upload-success": _vm.cropUploadSuccess,
      "crop-upload-fail": _vm.cropUploadFail
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imgDataUrl
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 833 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "b_inter_wrap"
  }, [_c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.$route.meta.step
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "book_date"
  }, [_c('h4', [_vm._v("Request Demo Time")]), _vm._v(" "), _c('div', {
    staticClass: "choose_timezone"
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Time Zone＊"
    },
    model: {
      value: (_vm.time_zone),
      callback: function($$v) {
        _vm.time_zone = $$v
      },
      expression: "time_zone"
    }
  }, _vm._l((_vm.d_time_zone), function(key, val) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": val,
        "value": key
      }
    })
  })), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "date_detail clearfix"
  }, [_c('div', {
    staticClass: "calendar_wrapper"
  }, [_c('Calendar', {
    attrs: {
      "show": _vm.calendar.show,
      "type": _vm.calendar.items.type,
      "value": _vm.calendar.items.value,
      "x": _vm.calendar.x,
      "y": _vm.calendar.y,
      "begin": _vm.calendar.items.begin,
      "end": _vm.calendar.items.end,
      "sep": _vm.calendar.items.sep,
      "single": _vm.calendar.items.single,
      "rangeValue": _vm.calendar.items.rangeValue,
      "autoclose": _vm.calendar.items.autoclose
    },
    on: {
      "cancel": _vm.dateCancel,
      "ok": _vm.dateOk
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "time_quantum clearfix"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasDate),
      expression: "hasDate"
    }],
    staticClass: "clearfix"
  }, _vm._l((_vm.time_frame), function(time, idx) {
    return _c('li', {
      key: idx,
      class: {
        active: time.isActive
      },
      on: {
        "click": function($event) {
          _vm.frameFn(time.work_hour_value, idx, time.work_start_time)
        }
      }
    }, [_vm._v("\n              " + _vm._s(time.work_start_time) + "-" + _vm._s(time.work_end_time) + "\n            ")])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasDate),
      expression: "!hasDate"
    }],
    staticClass: "no_date"
  }, [_c('p', [_vm._v("No available times that day, please check other dates.")])])])]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" Submit")])]), _vm._v(" "), _c('div', {
    staticClass: "download"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', [_c('ac')], 1)])]), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.$route.query.status == "canceled") ? _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('img', {
    staticStyle: {
      "border-style": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "alt": "",
      "src": "//www.googleadservices.com/pagead/conversion/852175291/?label=5q8jCM_HsngQu9OslgM&guid=ON&script=0"
    }
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The times listed below are presented"), _c('br'), _vm._v(" according to the time zone you selected. ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('img', {
    staticStyle: {
      "border-style": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "alt": "",
      "src": "//www.googleadservices.com/pagead/conversion/852175291/?label=6w1jCNWDxngQu9OslgM&guid=ON&script=0"
    }
  })])
}]}

/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "vue-image-crop-upload"
  }, [_c('div', {
    staticClass: "vicp-wrap"
  }, [_c('div', {
    staticClass: "vicp-close",
    on: {
      "click": _vm.off
    }
  }, [_c('i', {
    staticClass: "vicp-icon4"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 1),
      expression: "step == 1"
    }],
    staticClass: "vicp-step1"
  }, [_c('div', {
    staticClass: "vicp-drop-area",
    on: {
      "dragleave": _vm.preventDefault,
      "dragover": _vm.preventDefault,
      "dragenter": _vm.preventDefault,
      "click": _vm.handleClick,
      "drop": _vm.handleChange
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading != 1),
      expression: "loading != 1"
    }],
    staticClass: "vicp-icon1"
  }, [_c('i', {
    staticClass: "vicp-icon1-arrow"
  }), _vm._v(" "), _c('i', {
    staticClass: "vicp-icon1-body"
  }), _vm._v(" "), _c('i', {
    staticClass: "vicp-icon1-bottom"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading !== 1),
      expression: "loading !== 1"
    }],
    staticClass: "vicp-hint"
  }, [_vm._v(_vm._s(_vm.lang.hint))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSupported),
      expression: "!isSupported"
    }],
    staticClass: "vicp-no-supported-hint"
  }, [_vm._v(_vm._s(_vm.lang.noSupported))]), _vm._v(" "), (_vm.step == 1) ? _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "fileinput",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.handleChange
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasError),
      expression: "hasError"
    }],
    staticClass: "vicp-error"
  }, [_c('i', {
    staticClass: "vicp-icon2"
  }), _vm._v(" " + _vm._s(_vm.errorMsg) + "\r\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "vicp-operate"
  }, [_c('a', {
    on: {
      "click": _vm.off,
      "mousedown": _vm.ripple
    }
  }, [_vm._v(_vm._s(_vm.lang.btn.off))])])]), _vm._v(" "), (_vm.step == 2) ? _c('div', {
    staticClass: "vicp-step2"
  }, [_c('div', {
    staticClass: "vicp-crop"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "vicp-crop-left"
  }, [_c('div', {
    staticClass: "vicp-img-container"
  }, [_c('img', {
    ref: "img",
    staticClass: "vicp-img",
    style: (_vm.sourceImgStyle),
    attrs: {
      "src": _vm.sourceImgUrl,
      "draggable": "false"
    },
    on: {
      "drag": _vm.preventDefault,
      "dragstart": _vm.preventDefault,
      "dragend": _vm.preventDefault,
      "dragleave": _vm.preventDefault,
      "dragover": _vm.preventDefault,
      "dragenter": _vm.preventDefault,
      "drop": _vm.preventDefault,
      "touchstart": _vm.imgStartMove,
      "touchmove": _vm.imgMove,
      "touchend": _vm.createImg,
      "touchcancel": _vm.createImg,
      "mousedown": _vm.imgStartMove,
      "mousemove": _vm.imgMove,
      "mouseup": _vm.createImg,
      "mouseout": _vm.createImg
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "vicp-img-shade vicp-img-shade-1",
    style: (_vm.sourceImgShadeStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "vicp-img-shade vicp-img-shade-2",
    style: (_vm.sourceImgShadeStyle)
  })]), _vm._v(" "), _c('div', {
    staticClass: "vicp-range"
  }, [_c('input', {
    attrs: {
      "type": "range",
      "step": "1",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": _vm.scale.range
    },
    on: {
      "input": _vm.zoomChange
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "vicp-icon5",
    on: {
      "mousedown": _vm.startZoomSub,
      "mouseout": _vm.endZoomSub,
      "mouseup": _vm.endZoomSub
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "vicp-icon6",
    on: {
      "mousedown": _vm.startZoomAdd,
      "mouseout": _vm.endZoomAdd,
      "mouseup": _vm.endZoomAdd
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "vicp-crop-right"
  }, [_c('div', {
    staticClass: "vicp-preview"
  }, [_c('div', {
    staticClass: "vicp-preview-item"
  }, [_c('img', {
    style: (_vm.previewStyle),
    attrs: {
      "src": _vm.createImgUrl
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.preview))])]), _vm._v(" "), (!_vm.noCircle) ? _c('div', {
    staticClass: "vicp-preview-item"
  }, [_c('img', {
    style: (_vm.previewStyle),
    attrs: {
      "src": _vm.createImgUrl
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.preview))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "vicp-operate"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setStep(1)
      },
      "mousedown": _vm.ripple
    }
  }, [_vm._v(_vm._s(_vm.lang.btn.back))]), _vm._v(" "), _c('a', {
    staticClass: "vicp-operate-btn",
    on: {
      "click": _vm.upload,
      "mousedown": _vm.ripple
    }
  }, [_vm._v(_vm._s(_vm.lang.btn.save))])])]) : _vm._e(), _vm._v(" "), (_vm.step == 3) ? _c('div', {
    staticClass: "vicp-step3"
  }, [_c('div', {
    staticClass: "vicp-upload"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading === 1),
      expression: "loading === 1"
    }],
    staticClass: "vicp-loading"
  }, [_vm._v(_vm._s(_vm.lang.loading))]), _vm._v(" "), _c('div', {
    staticClass: "vicp-progress-wrap"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading === 1),
      expression: "loading === 1"
    }],
    staticClass: "vicp-progress",
    style: (_vm.progressStyle)
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasError),
      expression: "hasError"
    }],
    staticClass: "vicp-error"
  }, [_c('i', {
    staticClass: "vicp-icon2"
  }), _vm._v(" " + _vm._s(_vm.errorMsg) + "\r\n                ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading === 2),
      expression: "loading === 2"
    }],
    staticClass: "vicp-success"
  }, [_c('i', {
    staticClass: "vicp-icon3"
  }), _vm._v(" " + _vm._s(_vm.lang.success) + "\r\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "vicp-operate"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setStep(2)
      },
      "mousedown": _vm.ripple
    }
  }, [_vm._v(_vm._s(_vm.lang.btn.back))]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.off,
      "mousedown": _vm.ripple
    }
  }, [_vm._v(_vm._s(_vm.lang.btn.close))])])]) : _vm._e(), _vm._v(" "), _c('canvas', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "canvas",
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 835 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "cancel-confirm",
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("Our slots are limited and you may only reschedule once throughout your application and training process with HAWO. Please show up on time, and try to select times that will not conflict with other obligations.")]), _vm._v(" "), _c('p', [_vm._v("Your cancellations/reschedules will be taken into consideration when assessing your overall application results. Emergency cancellations will be reviewed on a case-by-case basis.")]), _vm._v(" "), _c('p', [_vm._v("A \"no show\" at any point in the process disqualifies you from completing the application process.")]), _vm._v(" "), (_vm.isRemark) ? _c('dl', {
    staticClass: "reason"
  }, [_c('dt', [_vm._v("Kindly specify your reason for " + _vm._s(_vm.typeText))]), _vm._v(" "), _c('dd', [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3
    },
    model: {
      value: (_vm.remark),
      callback: function($$v) {
        _vm.remark = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "remark"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "medium"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false;
        _vm.remark = '';
        _vm.reject()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium",
      "disabled": _vm.isRemark && _vm.remark === ''
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false;
        _vm.resolve({
          type: _vm.type,
          remark: _vm.remark
        });
        _vm.remark = '';
      }
    }
  }, [_vm._v("OK")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 836 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pending_wrap"
  }, [_c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.$route.meta.step
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Application Status")]), _vm._v(" "), _c('div', {
    staticClass: "letter"
  }, [_c('p', [_vm._v("Dear " + _vm._s(_vm.full_name) + ",")]), _vm._v(" "), _c('p', [_vm._v("After a thorough evaluation of your overall performance in the HAWO recruitment process, we regret to inform you that you did not meet our standards. We will not be moving forward with your application. While your qualifications are impressive, our selection process is highly competitive.")]), _vm._v(" "), _c('p', [_vm._v("Thank you for your interest, and we wish you all the best in your future endeavors.")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "download"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', [_c('ac')], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Best,"), _c('br'), _vm._v("HAWO Recruitment Team")])
}]}

/***/ }),
/* 837 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "b_inter_wrap"
  }, [_c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.$route.meta.step
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "book_date"
  }, [_c('h4', [_vm._v("Request an Interview Time")]), _vm._v(" "), _c('dl', {
    staticClass: "timeZone"
  }, [_c('dt', [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Your current time zone＊  "
    },
    model: {
      value: (_vm.time_zone),
      callback: function($$v) {
        _vm.time_zone = $$v
      },
      expression: "time_zone"
    }
  }, _vm._l((_vm.datas_time.time_zone), function(key, val) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": val,
        "value": key
      }
    })
  }))], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "date_detail clearfix"
  }, [_c('div', {
    staticClass: "calendar_wrapper"
  }, [_c('Calendar', {
    attrs: {
      "show": _vm.calendar.show,
      "type": _vm.calendar.items.type,
      "value": _vm.calendar.items.value,
      "x": _vm.calendar.x,
      "y": _vm.calendar.y,
      "begin": _vm.calendar.items.begin,
      "end": _vm.calendar.items.end,
      "sep": _vm.calendar.items.sep,
      "single": _vm.calendar.items.single,
      "rangeValue": _vm.calendar.items.rangeValue,
      "autoclose": _vm.calendar.items.autoclose
    },
    on: {
      "cancel": _vm.dateCancel,
      "ok": _vm.dateOk
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "date_time clearfix"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dayOne),
      expression: "!dayOne"
    }],
    staticClass: "no_times"
  }, [_vm._v("No available times that day, please check other dates.")]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dayOne),
      expression: "dayOne"
    }],
    staticClass: "time_quantum clearfix"
  }, [_c('li', [_c('h4', [_vm._v("Morning")]), _vm._v(" "), _c('ul', {
    staticClass: "time_list clearfix"
  }, _vm._l((_vm.time_slot.morning), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        active: item.isActive
      },
      on: {
        "click": function($event) {
          _vm.MchoseFn(index, 'morning')
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }))]), _vm._v(" "), _c('li', [_c('h4', [_vm._v("Afternoon")]), _vm._v(" "), _c('ul', {
    staticClass: "time_list clearfix"
  }, _vm._l((_vm.time_slot.afternoon), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        active: item.isActive
      },
      on: {
        "click": function($event) {
          _vm.MchoseFn(index, 'afternoon')
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }))]), _vm._v(" "), _c('li', [_c('h4', [_vm._v("Evening")]), _vm._v(" "), _c('ul', {
    staticClass: "time_list clearfix"
  }, _vm._l((_vm.time_slot.evening), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        active: item.isActive
      },
      on: {
        "click": function($event) {
          _vm.MchoseFn(index, 'evening')
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }))])])])]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.submitFn
    }
  }, [_vm._v(" Submit")]), _vm._v(" "), (_vm.addPixel) ? _c('img', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": "https://pixel.appcast.io/homegrown-9k/a17.png?ent=0&e=4405&t=1506715226",
      "width": "1px",
      "height": "1px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.query.status == "unassigned") ? _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('img', {
    staticStyle: {
      "border-style": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "alt": "",
      "src": "//www.googleadservices.com/pagead/conversion/852175291/?label=muXOCOXCsngQu9OslgM&guid=ON&script=0"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.channelStatus) ? _c('img', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": "https://click.appcast.io/generic-9k/a17.png?ent=147&e=5728&t=1523371553225",
      "width": "1px",
      "height": "1px"
    }
  }) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dd', [_vm._v("The interview times listed below are presented "), _c('br'), _vm._v(" according to the time zone you selected")])
}]}

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "started_wrapper"
  }, [_c('div', {
    staticClass: "download"
  }, [_c('ul', [_c('li', [_c('ac')], 1)])]), _vm._v(" "), _c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.$route.meta.step
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "started_container"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(771),
      "alt": "bird"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Congratulations!")]), _vm._v(" "), _c('p', {
    staticClass: "words"
  }, [_vm._v("You're ready to become a HAWO teacher. We're excited to have you on our team, and we hope that you'll enjoy your experience with us!\n\t\t\t")]), _vm._v(" "), _c('a', {
    staticClass: "started",
    on: {
      "click": _vm.letUsBegin
    }
  }, [_vm._v("Let's get started!")]), _vm._v(" "), _c('p', {
    staticClass: "msg"
  }, [_vm._v("Please click on the button below to launch.")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "head_wrap clearfix"
  }, [_vm._m(0), _vm._v(" "), (_vm.is_logined !== null) ? _c('div', {
    staticClass: "user_msg"
  }, [_c('a', {
    attrs: {
      "href": _vm.urls.naFaq,
      "target": "_blank"
    }
  }, [_vm._v("FAQ")]), _vm._v(" "), (_vm.is_logined) ? _c('el-dropdown', [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n          My Account\n          "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "account-menu",
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        _vm.$router.push('/resetcode')
      }
    }
  }, [_vm._v("Change Password")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        _vm.signOut($event)
      }
    }
  }, [_vm._v("Sign Out")])], 1)], 1) : _c('a', {
    attrs: {
      "href": _vm.direction
    }
  }, [_vm._v("Sign in")])], 1) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(336),
      "alt": "logo",
      "width": "40"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Teacher Application Portal")])])
}]}

/***/ }),
/* 840 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload_img"
  }, [(_vm.imageUrl) ? _c('div', {
    staticClass: "img"
  }, [_c('p', {
    style: ('background-image: url(' + _vm.imageUrl + ')')
  }), _vm._v(" "), _c('i'), _vm._v(" "), _c('b')]) : _c('div', {
    staticClass: "add"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.message))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span')])
}]}

/***/ }),
/* 841 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pending_wrap"
  }, [(_vm.step) ? _c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.step
    }
  }) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v("Pending result")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inp1),
      expression: "inp1"
    }],
    staticClass: "letter"
  }, [_c('p', [_vm._v("Dear " + _vm._s(_vm.full_name) + ",")]), _vm._v(" "), _c('p', [_vm._v("Thank you for requesting an interview with HAWO. "), _c('br'), _vm._v("Currently there are no available times. You may check our interview availability again tomorrow, or reach out to us at\n\t\t\t\t"), _c('a', {
    attrs: {
      "href": _vm.need_mail
    }
  }, [_vm._v(_vm._s(_vm.e_mail))]), _vm._v(".")]), _vm._v(" "), _c('p'), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inp2),
      expression: "inp2"
    }],
    staticClass: "letter"
  }, [_c('p', [_vm._v("Dear " + _vm._s(_vm.full_name) + ",")]), _vm._v(" "), _c('p', [_vm._v("Please make sure to check your email or Skype for the next step/s in the process. Your recruiter will be reaching out to you via those channels.")]), _vm._v(" "), _c('p', [_vm._v("You may also add the HAWO Recruitment Skype: live:.cid.9d7dbebba05d49b9 for faster coordination.")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "download"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', [_c('ac')], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Best,"), _c('br'), _vm._v("The HAWO Recruitment Team")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Best,"), _c('br'), _vm._v("The HAWO Recruitment Team")])
}]}

/***/ }),
/* 842 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reschedule_wrap"
  }, [_c('div', {
    staticClass: "res_container"
  }, [_c('div', {
    staticClass: "res_head"
  }, [_c('h1', [_vm._v("Reschedule\n        "), _c('span', {
    on: {
      "click": _vm.close
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.datasFn),
      expression: "datasFn"
    }],
    staticClass: "date_list"
  }, [_c('dl', {
    staticClass: "timeZone clearfix"
  }, [_c('dt', [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Time zone＊"
    },
    model: {
      value: (_vm.time_zone),
      callback: function($$v) {
        _vm.time_zone = $$v
      },
      expression: "time_zone"
    }
  }, _vm._l((_vm.timeZone), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": val,
        "value": key
      }
    })
  }))], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "choose_time"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('Calendar', {
    attrs: {
      "show": _vm.calendar.show,
      "type": _vm.calendar.items.type,
      "value": _vm.calendar.items.value,
      "x": _vm.calendar.x,
      "y": _vm.calendar.y,
      "begin": _vm.calendar.items.begin,
      "end": _vm.calendar.items.end,
      "sep": _vm.calendar.items.sep,
      "single": _vm.calendar.items.single,
      "rangeValue": _vm.calendar.items.rangeValue,
      "autoclose": _vm.calendar.items.autoclose
    },
    on: {
      "cancel": _vm.dateCancel,
      "ok": _vm.dateOk
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dayOne),
      expression: "dayOne"
    }],
    staticClass: "clearfix"
  }, _vm._l((_vm.allow_time), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        active: item.isActive, disable: _vm.isTimeDisable(item)
      },
      on: {
        "click": function($event) {
          _vm.choseFn(index, _vm.isTimeDisable(item))
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dayOne),
      expression: "!dayOne"
    }],
    staticClass: "no_dates"
  }, [_vm._v("No available times that day, please check other dates.")])])]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.submitFn
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.datasFn),
      expression: "!datasFn"
    }],
    staticClass: "no_dates"
  }, [_vm._v("Currently there are no available times. You may check our schedule availability again tomorrow, or contact your interviewer for help.")])]), _vm._v(" "), _c('div', {
    staticClass: "shadow_pop",
    style: ({
      height: _vm.window_size.height + 'px',
      width: _vm.window_size.width + 'px'
    })
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dd', [_vm._v("The interview times listed below are presented "), _c('br'), _vm._v(" according to the time zone you selected")])
}]}

/***/ }),
/* 843 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "status"
  }, [_c('ul', _vm._l((_vm.status), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        'active': index + 1 <= _vm.step, 'current': index + 1 === _vm.step
      }
    }, [_c('span', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(item.join('<br/>'))
      }
    })])
  }))])
},staticRenderFns: []}

/***/ }),
/* 844 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qualification"
  }, [_c('h3', {
    staticClass: "education_tit"
  }, [_vm._v("Education")]), _vm._v(" "), _c('ul', {
    staticClass: "education clearfix"
  }, [_c('li', {
    staticClass: "clearfix"
  }, [_c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Highest Level of Education*")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.basic_info.educational_attainment),
      callback: function($$v) {
        _vm.basic_info.educational_attainment = $$v
      },
      expression: "basic_info.educational_attainment"
    }
  }, _vm._l((_vm.data_config.educational_attainment), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  })), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp1),
      expression: "!f_state.inp1"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "input_info marginR"
  }, [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("School Name*")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "remote-method": _vm.schoolSearch,
      "loading": _vm.schoolNameSearchLanding,
      "filterable": "",
      "remote": "",
      "placeholder": "Please Search School Name *"
    },
    model: {
      value: (_vm.basic_info.school_name),
      callback: function($$v) {
        _vm.basic_info.school_name = $$v
      },
      expression: "basic_info.school_name"
    }
  }, _vm._l((_vm.searchSchool), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": key
      }
    })
  })), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp2),
      expression: "!f_state.inp2"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Major / Specialization*")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.basic_info.major),
      callback: function($$v) {
        _vm.basic_info.major = $$v
      },
      expression: "basic_info.major"
    }
  }, _vm._l((_vm.data_config.majors), function(key, val) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": val,
        "value": key
      }
    })
  })), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp3),
      expression: "!f_state.inp3"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v(_vm._s(_vm.basic_info.teaching_certification.certification_academic.name))]), _vm._v(" "), _c('ul', {
    staticClass: "img_list clearfix"
  }, _vm._l((_vm.basic_info.teaching_certification.certification_academic.data), function(item, index) {
    return _c('li', {
      key: index
    }, [(item.cert_url) ? _c('i', {
      staticClass: "del el-icon-circle-close",
      on: {
        "click": function($event) {
          _vm.delUpload({
            key: 'certification_academic',
            index: index
          })
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('file-upload', {
      attrs: {
        "action": _vm.action,
        "before-upload": _vm.beforeUpload,
        "uploadKey": {
          key: 'certification_academic',
          index: index
        }
      },
      on: {
        "complete": _vm.uploadComplete
      }
    }, [_c('uploadImg', {
      attrs: {
        "message": "Upload proof",
        "imageUrl": item.cert_url
      }
    })], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.cert_name))])], 1)
  }))])]), _vm._v(" "), _c('h3', {
    staticClass: "education_tit"
  }, [_vm._v("Teaching Experience")]), _vm._v(" "), _c('div', {
    staticClass: "education clearfix education-experience"
  }, [_c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("What kind of experience do you have with K-12 education in the US and/or Canada?")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "multiple": "",
      "disabled": ""
    },
    model: {
      value: (_vm.basic_info.teaching_experience),
      callback: function($$v) {
        _vm.basic_info.teaching_experience = $$v
      },
      expression: "basic_info.teaching_experience"
    }
  }, _vm._l((_vm.data_config.teaching_experience), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  }))], 1)]), _vm._v(" "), (_vm.basic_info.total_teaching_experience.length > 0) ? _c('ul', {
    staticClass: "education clearfix"
  }, [_c('li', {
    staticClass: "clearfix"
  }, [_c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("In total how much teaching experience do you have?")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.basic_info.total_teaching_experience),
      callback: function($$v) {
        _vm.basic_info.total_teaching_experience = $$v
      },
      expression: "basic_info.total_teaching_experience"
    }
  }, _vm._l((_vm.data_config.total_teaching_experience), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key.option_value,
        "value": key.option_key
      }
    })
  }))], 1)])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "education education-experience-list clearfix"
  }, _vm._l((_vm.datas.teaching_experience_list), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "clearfix"
    }, [_c('div', [_c('h3', {
      staticClass: "tile_name"
    }, [_vm._v("Organization Name")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (item.organization_name),
        expression: "item.organization_name",
        modifiers: {
          "trim": true
        }
      }],
      attrs: {
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": (item.organization_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          item.organization_name = $event.target.value.trim()
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', [_c('h3', {
      staticClass: "tile_name"
    }, [_vm._v("Job Title")]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": item.job_title in _vm.data_config.job_title ? _vm.data_config.job_title[item.job_title] : item.job_title
      }
    })]), _vm._v(" "), _c('div', [_c('h3', {
      staticClass: "tile_name"
    }, [_vm._v("Time period")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "filterable": "",
        "disabled": ""
      },
      model: {
        value: (item.period_teaching_experience),
        callback: function($$v) {
          item.period_teaching_experience = $$v
        },
        expression: "item.period_teaching_experience"
      }
    }, _vm._l((_vm.data_config.period_teaching_experience), function(key, val) {
      return _c('el-option', {
        key: val,
        attrs: {
          "label": key.option_value,
          "value": key.option_key
        }
      })
    }))], 1)])
  })), _vm._v(" "), _c('h3', {
    staticClass: "education_tit"
  }, [_vm._v("Teaching certificates:")]), _vm._v(" "), _c('div', {
    staticClass: "teaching-main clearfix"
  }, _vm._l((_vm.basic_info.teaching_certification), function(certification, certificationKey) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (certificationKey !== 'certification_academic'),
        expression: "certificationKey !== 'certification_academic'"
      }],
      key: certificationKey,
      staticClass: "teaching-text"
    }, [_c('h6', [_vm._v(_vm._s(certification.name) + ":")]), _vm._v(" "), _c('ul', {
      staticClass: "img_list clearfix"
    }, _vm._l((certification.data), function(item, index) {
      return _c('li', {
        key: index
      }, [(item.cert_url) ? _c('i', {
        staticClass: "del el-icon-circle-close",
        on: {
          "click": function($event) {
            _vm.delUpload({
              key: certificationKey,
              index: index
            })
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('file-upload', {
        attrs: {
          "action": _vm.action,
          "before-upload": _vm.beforeUpload,
          "uploadKey": {
            key: certificationKey,
            index: index
          }
        },
        on: {
          "complete": _vm.uploadComplete
        }
      }, [_c('uploadImg', {
        attrs: {
          "message": "Upload proof",
          "imageUrl": item.cert_url
        }
      })], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.cert_name))])], 1)
    }))])
  })), _vm._v(" "), _c('p', {
    staticClass: "save"
  }, [_c('a', {
    class: {
      cancel: !_vm.isCancel
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])])
},staticRenderFns: []}

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "information"
  }, [_c('dl', {
    staticClass: "picture"
  }, [_c('dt', [_c('img', {
    staticClass: "img_img",
    attrs: {
      "src": _vm.basic_info.pic,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "show_part"
  }, [_c('ul', {
    staticClass: "part_list clearfix"
  }, [_c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("First Name＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.basic_info.first_name))])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("Last Name＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.basic_info.last_name))])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("Teacher Name＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.basic_info.nick_name))])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("Birthday＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.basic_info.birthday))])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("Nationality＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.selectShow.country))])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("Zoom account＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.basic_info.zoom_id))])]), _vm._v(" "), _c('li', {
    staticClass: "width490"
  }, [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("Skype ID")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.basic_info.skype_id))])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("Computer's Operating Systerm＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.basic_info.pc_type))])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("Country Code＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.basic_info.country_code))])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("Phone Number＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.basic_info.mobile))])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("Your Current Time Zone＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.selectShow.time_zone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "show_part"
  }, [_c('h3', {
    staticClass: "interests_tit"
  }, [_vm._v("The country, state, and city you choose will automatically generate your time zone and zip code.")]), _vm._v(" "), _c('ul', {
    staticClass: "part_list clearfix"
  }, [_c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("Country＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.selectShow.country))])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("State＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.changeShow.state))])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("City＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.basic_info.city))])]), _vm._v(" "), _c('li', {
    staticClass: "width490"
  }, [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("Street＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.basic_info.street))])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("Zip Code＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.basic_info.z_code))])])])]), _vm._v(" "), _c('div', {
    staticClass: "interest"
  }, [_c('h3', {
    staticClass: "interests_tit"
  }, [_vm._v("The background and interests below will help our students get to know you better.")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "item_left"
  }, [_vm._v("Background＊")]), _vm._v(" "), _c('ul', {
    staticClass: "background_list clearfix"
  }, _vm._l((_vm.background), function(item, index) {
    return _c('li', {
      staticClass: "active"
    }, [_vm._v(_vm._s(item.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "item_left"
  }, [_vm._v("Interests＊")]), _vm._v(" "), _c('ul', {
    staticClass: "background_list clearfix"
  }, _vm._l((_vm.interests), function(item, index) {
    return _c('li', {
      staticClass: "active"
    }, [_vm._v(_vm._s(item.name))])
  }))])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dd', [_c('div', {
    staticClass: "picture_decoration"
  }, [_c('p', [_vm._v("Please upload a photo of yourself here. ")]), _vm._v(" "), _c('p', [_vm._v("This photo will be used for your teacher profile page.")]), _vm._v(" "), _c('p', [_vm._v("Your photo should be professional, and have adequate lighting. Don't forget to smile!")]), _vm._v(" "), _c('p', [_vm._v("The photo may be in jpg or png formats, and the size should be 120 x 120.")])]), _vm._v(" "), _c('div', {
    staticClass: "picture_sample"
  }, [_c('div', {
    staticClass: "picture_img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(337),
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Sample profile picture")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "edit"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Edit")])])
}]}

/***/ }),
/* 846 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "mo-upload"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": _vm.accepts
    },
    on: {
      "change": _vm.upload
    }
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 847 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 848 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "personal_profile"
  }, [_c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.$route.meta.step
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "profile_text"
  }, [_vm._v("Please complete the following personal profile to assist us in completing your American Academy account.")]), _vm._v(" "), _c('div', {
    staticClass: "personal_top"
  }, [_c('ul', {
    staticClass: "personal_list"
  }, _vm._l((_vm.per_opt), function(item, index) {
    return _c('li', {
      key: index
    }, [(_vm._boardingStep.reachStep.includes(item.step)) ? _c('router-link', {
      class: {
        complete: _vm._boardingStep.doneStep.includes(item.step)
      },
      attrs: {
        "to": item.to,
        "replace": "",
        "active-class": "active",
        "tag": "div"
      }
    }, [_c('span', {
      class: item.addClass
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
      staticClass: "step_text"
    }, [_vm._v(_vm._s(item.names))]), _vm._v(" "), _c('em', {
      staticClass: "icon"
    }), _vm._v(" "), _c('b')]) : _c('div', {
      class: {
        complete: _vm._boardingStep.doneStep.includes(item.step)
      }
    }, [_c('span', {
      class: item.addClass
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
      staticClass: "step_text"
    }, [_vm._v(_vm._s(item.names))]), _vm._v(" "), _c('em', {
      staticClass: "icon"
    }), _vm._v(" "), _c('b')])], 1)
  }))]), _vm._v(" "), _c('div', {
    staticClass: "basic_information"
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "download"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', [_c('ac')], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('span', [_vm._v("Personal Profile")])])
}]}

/***/ }),
/* 849 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar",
    style: ({
      'left': _vm.x + 'px',
      'top': _vm.y + 'px'
    }),
    attrs: {
      "transition": "calendar",
      "transition-mode": "out-in"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "calendar-tools"
  }, [_c('span', {
    staticClass: "calendar-prev",
    on: {
      "click": _vm.prev
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-menu-left"
  })]), _vm._v(" "), _c('span', {
    staticClass: "calendar-next",
    on: {
      "click": _vm.next
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-menu-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "cursor": "pointer"
    }
  }, [_vm._v(_vm._s(_vm.timeSwitch))])]), _vm._v(" "), _c('table', [_c('thead', [(_vm.list.head.length > 0) ? _c('tr', _vm._l((_vm.list.head), function(item) {
    return _c('td', [_c('span', [_vm._v(_vm._s(item))])])
  })) : _vm._e()]), _vm._v(" "), _c('tbody', _vm._l((_vm.list.body), function(item) {
    return _c('tr', _vm._l((item), function(td) {
      return _c('td', {
        class: _vm.getCssClass(td.value, td.cssClass),
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.select(td.value)
          }
        }
      }, [_c('span', [_vm._v(_vm._s(td.text))])])
    }))
  }))]), _vm._v(" "), (!_vm.autoclose) ? _c('div', {
    staticClass: "calendar-button"
  }, [_c('span', {
    staticClass: "submit",
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("确定")]), _c('span', {
    staticClass: "cancel",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 850 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pending_wrap"
  }, [_c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.$route.meta.step
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Demo result")]), _vm._v(" "), (_vm.$route.query.status == "noshow") ? _c('div', {
    staticClass: "letter"
  }, [_c('p', [_vm._v("\n      It looks like your HAWO demo didn't take place. "), _c('br'), _vm._v("Kindly contact your recruiter via email at\n      "), _c('a', {
    attrs: {
      "href": ("mailto:" + _vm.recruiter_email)
    }
  }, [_vm._v(_vm._s(_vm.recruiter_email))]), _vm._v(" to further assist you.\n    ")]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.$route.query.status == "failed") ? _c('div', {
    staticClass: "letter"
  }, [_c('p', [_vm._v("Dear " + _vm._s(_vm.full_name) + ",")]), _vm._v(" "), _c('p', [_vm._v("Thank you for your application. Unfortunately, we are unable to move forward in the recruitment process with your application.")]), _vm._v(" "), _c('p', [_vm._v("We appreciate the time and effort you have put into applying, and wish you the best of luck in your job search.")]), _vm._v(" "), _vm._m(1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      Kind Regards, "), _c('br'), _vm._v(" HAWO Recruitment Team\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Kind Regards,"), _c('br'), _vm._v("HAWO Recruitment Team")])
}]}

/***/ }),
/* 851 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot_wrap"
  }, [_c('div', {
    staticClass: "table_container"
  }, [_c('h1', [_vm._v("Reset your password")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wrong_state),
      expression: "wrong_state"
    }],
    staticClass: "wrong"
  }, [_vm._v(_vm._s(_vm.wrong_words))]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.email),
      expression: "email",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "Email Adress"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "blur": [_vm.check_val, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value.trim()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix btns"
  }, [_c('a', {
    staticClass: "continue",
    on: {
      "click": _vm.next_reset
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('a', {
    staticClass: "cancel",
    on: {
      "click": _vm.back_login
    }
  }, [_vm._v("Cancel")])])])])
},staticRenderFns: []}

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot_wrap"
  }, [_c('div', {
    staticClass: "table_container"
  }, [_c('h1', [_vm._v("Reset your password")]), _vm._v(" "), _c('p', {
    staticClass: "notice"
  }, [_vm._v("We've emailed your 6-digit code to\n\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.user_email))]), _vm._v(", so please check your inbox. If necessary, please also check your spam and junk folders."), _c('br'), _vm._v("If you cannot receive the system e-mail, please contact us by teach@51talk.com")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mis_state),
      expression: "mis_state"
    }],
    staticClass: "wrong"
  }, [_c('span'), _vm._v(_vm._s(_vm.mis_words))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.code),
      expression: "code",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "Code",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "blur": [_vm.check_code, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix btns"
  }, [_c('a', {
    staticClass: "continue",
    on: {
      "click": _vm.next_reset
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('a', {
    staticClass: "cancel",
    on: {
      "click": _vm.back_login
    }
  }, [_vm._v("Cancel")])])])])
},staticRenderFns: []}

/***/ }),
/* 853 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot_wrap"
  }, [_c('div', {
    staticClass: "table_container"
  }, [_c('h1', [_vm._v("Reset your password")]), _vm._v(" "), _c('div', {
    staticClass: "new_p"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "password",
      "placeholder": "New Password",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "focus": function($event) {
        _vm.focus_on = true;
        _vm.init = true
      },
      "blur": [function($event) {
        _vm.focus_on = false
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_off),
      expression: "show_off"
    }],
    staticClass: "notice"
  }, [_c('p', {
    class: _vm.getClass('type1')
  }, [_vm._v("8 to 25 characters")]), _vm._v(" "), _c('p', {
    class: _vm.getClass('type2')
  }, [_vm._v("Upper & lowercase letters")]), _vm._v(" "), _c('p', {
    class: _vm.getClass('type3')
  }, [_vm._v("At least one number")]), _vm._v(" "), _c('p', {
    class: _vm.getClass('type4')
  }, [_vm._v("Can not use special numeric except !@#$%^&*()?<>._-")])])]), _vm._v(" "), _c('div', {
    staticClass: "confirm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.rpassword),
      expression: "rpassword",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "password",
      "placeholder": "Confirm Password",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.rpassword)
    },
    on: {
      "blur": [_vm.check_rcode, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rpassword = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init_status.rule3),
      expression: "init_status.rule3"
    }],
    staticClass: "notice wrong"
  }, [_vm._v(_vm._s(_vm.notice.words_3))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix btns"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.service_show),
      expression: "service_show"
    }],
    staticClass: "service_words"
  }, [_vm._v(_vm._s(_vm.service_words))]), _vm._v(" "), _c('a', {
    staticClass: "continue",
    on: {
      "click": _vm.next_reset
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('a', {
    staticClass: "cancel",
    on: {
      "click": _vm.back_login
    }
  }, [_vm._v("Cancel")])])])])
},staticRenderFns: []}

/***/ }),
/* 854 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot_wrap"
  }, [_c('div', {
    staticClass: "table_container"
  }, [_c('h1', [_vm._v("It’s done!")]), _vm._v(" "), _c('p', {
    staticClass: "notice"
  }, [_vm._v("You have reset your password.")]), _vm._v(" "), _c('a', {
    staticClass: "sign_in_ag",
    on: {
      "click": _vm.next_reset
    }
  }, [_vm._v("Sign in again")])])])
},staticRenderFns: []}

/***/ }),
/* 855 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form_wrapper_inner"
  }, [_c('h1', [_vm._v("Please provide your complete information below.")]), _vm._v(" "), _c('div', {
    staticClass: "basic_info"
  }, [_c('h4', [_vm._v("Basic information")]), _vm._v(" "), _c('div', {
    staticClass: "line_f clearfix"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.basic_info.first_name.val),
      expression: "basic_info.first_name.val"
    }],
    attrs: {
      "type": "text",
      "placeholder": "First Name *"
    },
    domProps: {
      "value": (_vm.basic_info.first_name.val)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.first_name.val = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp1 && _vm.basic_info.first_name.init),
      expression: "!f_state.inp1 && basic_info.first_name.init"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.basic_info.last_name.val),
      expression: "basic_info.last_name.val"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Last Name *"
    },
    domProps: {
      "value": (_vm.basic_info.last_name.val)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.last_name.val = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp2 && _vm.basic_info.last_name.init),
      expression: "!f_state.inp2 && basic_info.last_name.init"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.zoom_id.val),
      expression: "basic_info.zoom_id.val",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "Zoom account  (optional)"
    },
    domProps: {
      "value": (_vm.basic_info.zoom_id.val)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.zoom_id.val = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "words_f"
  }, [_vm._v("Location you plan to work from and contact details.")]), _vm._v(" "), _c('div', {
    staticClass: "geo_local clearfix"
  }, [_c('div', {
    staticClass: "g_line clearfix"
  }, [_c('div', {
    staticClass: "g_child"
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Country *"
    },
    model: {
      value: (_vm.basic_info.country.val),
      callback: function($$v) {
        _vm.basic_info.country.val = $$v
      },
      expression: "basic_info.country.val"
    }
  }, _vm._l((_vm.datas.country), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  })), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp4 && _vm.basic_info.country.init),
      expression: "!f_state.inp4 && basic_info.country.init"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])], 1), _vm._v(" "), _c('div', [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "State/Province/Region *",
      "loading": _vm.state_loading
    },
    model: {
      value: (_vm.basic_info.state.val),
      callback: function($$v) {
        _vm.basic_info.state.val = $$v
      },
      expression: "basic_info.state.val"
    }
  }, _vm._l((_vm.datas.state), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": val,
        "value": key
      }
    })
  })), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp5 && _vm.basic_info.state.init),
      expression: "!f_state.inp5 && basic_info.state.init"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])], 1), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.city.val),
      expression: "basic_info.city.val",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "City *"
    },
    domProps: {
      "value": (_vm.basic_info.city.val)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.city.val = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp6 && _vm.basic_info.city.init),
      expression: "!f_state.inp6 && basic_info.city.init"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])])]), _vm._v(" "), _c('div', {
    staticClass: "g_line clearfix"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.country_code.val),
      expression: "basic_info.country_code.val",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "Country Code *"
    },
    domProps: {
      "value": (_vm.basic_info.country_code.val)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.country_code.val = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp7 && _vm.basic_info.country_code.init),
      expression: "!f_state.inp7 && basic_info.country_code.init"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.basic_info.phone_number.val),
      expression: "basic_info.phone_number.val"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Mobile number *"
    },
    domProps: {
      "value": (_vm.basic_info.phone_number.val)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.phone_number.val = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp8 && _vm.basic_info.phone_number.init),
      expression: "!f_state.inp8 && basic_info.phone_number.init"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('div', [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Your current time zone *"
    },
    model: {
      value: (_vm.basic_info.time_zone.val),
      callback: function($$v) {
        _vm.basic_info.time_zone.val = $$v
      },
      expression: "basic_info.time_zone.val"
    }
  }, _vm._l((_vm.datas.time_zone), function(val, key) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  })), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp9 && _vm.basic_info.time_zone.init),
      expression: "!f_state.inp9 && basic_info.time_zone.init"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "qualifications"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Please select your English proficiency *"
    },
    model: {
      value: (_vm.basic_info.english_proficiency.val),
      callback: function($$v) {
        _vm.basic_info.english_proficiency.val = $$v
      },
      expression: "basic_info.english_proficiency.val"
    }
  }, _vm._l((_vm.datas.english_proficiency), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  })), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp20 && _vm.basic_info.english_proficiency.init),
      expression: "!f_state.inp20 && basic_info.english_proficiency.init"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "qualifications"
  }, [_c('h4', [_vm._v("Educational Attainment")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Highest Level of Education *"
    },
    model: {
      value: (_vm.basic_info.educational_attainment.val),
      callback: function($$v) {
        _vm.basic_info.educational_attainment.val = $$v
      },
      expression: "basic_info.educational_attainment.val"
    }
  }, _vm._l((_vm.educational_attainment), function(key, val) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": key,
        "value": val
      }
    })
  })), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp10 && _vm.basic_info.educational_attainment.init),
      expression: "!f_state.inp10 && basic_info.educational_attainment.init"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])], 1), _vm._v(" "), _c('div', [_c('el-select', {
    attrs: {
      "remote-method": _vm.schoolSearch,
      "loading": _vm.schoolNameSearchLanding,
      "filterable": "",
      "remote": "",
      "placeholder": "Please Search School Name *"
    },
    model: {
      value: (_vm.basic_info.school_name.val),
      callback: function($$v) {
        _vm.basic_info.school_name.val = $$v
      },
      expression: "basic_info.school_name.val"
    }
  }, _vm._l((_vm.searchSchool), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": key
      }
    })
  })), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp11 && _vm.basic_info.school_name.init),
      expression: "!f_state.inp11 && basic_info.school_name.init"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])], 1), _vm._v(" "), _c('div', [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Major/Specialization *"
    },
    model: {
      value: (_vm.basic_info.major.val),
      callback: function($$v) {
        _vm.basic_info.major.val = $$v
      },
      expression: "basic_info.major.val"
    }
  }, _vm._l((_vm.datas.majors), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": val,
        "value": key
      }
    })
  })), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inp12_complicated),
      expression: "inp12_complicated"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-part"
  }, [_c('h4', [_vm._v("Teaching Experience")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', [_c('el-select', {
    attrs: {
      "placeholder": "What kind of experience do you have with K-12 education in the US and/or Canada?",
      "multiple": ""
    },
    model: {
      value: (_vm.basic_info.teaching_experience.val),
      callback: function($$v) {
        _vm.basic_info.teaching_experience.val = $$v
      },
      expression: "basic_info.teaching_experience.val"
    }
  }, _vm._l((_vm.datas.teaching_experience), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  })), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp16 && _vm.basic_info.teaching_experience.init),
      expression: "!f_state.inp16 && basic_info.teaching_experience.init"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])], 1)])]), _vm._v(" "), (_vm.showFillExperience) ? _c('div', {
    staticClass: "form-part",
    attrs: {
      "teachingExperienceValidate": _vm.teachingExperienceValidate
    }
  }, [_c('h4', [_vm._v("Please fill in your teaching experience")]), _vm._v(" "), _c('ul', {
    staticClass: "ch-ul ch-two clearfix"
  }, [_c('li', [_c('el-select', {
    attrs: {
      "placeholder": "In total how much teaching experience do you have?"
    },
    model: {
      value: (_vm.teachingExperience.total_teaching_experience.val),
      callback: function($$v) {
        _vm.teachingExperience.total_teaching_experience.val = $$v
      },
      expression: "teachingExperience.total_teaching_experience.val"
    }
  }, _vm._l((_vm.total_teaching_experience), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key.option_value,
        "value": key.option_key
      }
    })
  })), _vm._v(" "), (_vm.teachingExperience.total_teaching_experience.showFail) ? _c('p', {
    staticClass: "state_notice"
  }, [_vm._v("This is required.")]) : _vm._e()], 1)]), _vm._v(" "), _vm._l((_vm.teachingExperience.teaching_experience_list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "experience-fill"
    }, [_c('ul', {
      staticClass: "ch-ul ch-three clearfix"
    }, [_c('li', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (item.organization_name.val),
        expression: "item.organization_name.val",
        modifiers: {
          "trim": true
        }
      }],
      attrs: {
        "type": "text",
        "placeholder": "Organization Name"
      },
      domProps: {
        "value": (item.organization_name.val)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          item.organization_name.val = $event.target.value.trim()
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), (item.organization_name.showFail) ? _c('p', {
      staticClass: "state_notice"
    }, [_vm._v("This is required.")]) : _vm._e()]), _vm._v(" "), _c('li', [_c('el-select', {
      attrs: {
        "placeholder": "Job Title"
      },
      model: {
        value: (item.job_title.val),
        callback: function($$v) {
          item.job_title.val = $$v
        },
        expression: "item.job_title.val"
      }
    }, _vm._l((_vm.datas.job_title), function(key, val) {
      return _c('el-option', {
        key: val,
        attrs: {
          "label": key,
          "value": val
        }
      })
    })), _vm._v(" "), (item.job_title.showFail) ? _c('p', {
      staticClass: "state_notice"
    }, [_vm._v("This is required.")]) : _vm._e()], 1), _vm._v(" "), _c('li', [_c('el-select', {
      attrs: {
        "placeholder": "Time period"
      },
      model: {
        value: (item.period_teaching_experience.val),
        callback: function($$v) {
          item.period_teaching_experience.val = $$v
        },
        expression: "item.period_teaching_experience.val"
      }
    }, _vm._l((_vm.period_teaching_experience), function(key, val) {
      return _c('el-option', {
        key: val,
        attrs: {
          "disabled": val > _vm.total_teaching_index,
          "label": key.option_value,
          "value": key.option_key
        }
      })
    })), _vm._v(" "), (item.period_teaching_experience.showFail) ? _c('p', {
      staticClass: "state_notice"
    }, [_vm._v("This is required.")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(_vm.teachingExperience.teaching_experience_list.length > 1) ? _c('el-button', {
      on: {
        "click": function($event) {
          _vm.experienceDelete(index)
        }
      }
    }, [_vm._v("delete")]) : _vm._e()], 1)])])
  }), _vm._v(" "), (_vm.teachingExperience.teaching_experience_list.length < 5) ? _c('el-button', {
    on: {
      "click": _vm.experienceAdd
    }
  }, [_vm._v("+ click here to add more")]) : _vm._e(), _vm._v(" "), (_vm.certification_show) ? _c('h4', [_vm._v("Teaching Certificates")]) : _vm._e(), _vm._v(" "), (_vm.certification_show) ? _c('ul', {
    staticClass: "ch-ul ch-three clearfix"
  }, [(Object.keys(_vm.datas.certification_tesol).length) ? _c('li', [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "TESOL Certificate"
    },
    model: {
      value: (_vm.teachingExperience.certification_tesol.val),
      callback: function($$v) {
        _vm.teachingExperience.certification_tesol.val = $$v
      },
      expression: "teachingExperience.certification_tesol.val"
    }
  }, _vm._l((_vm.datas.certification_tesol), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (Object.keys(_vm.datas.certification_teyl).length) ? _c('li', [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "TEYL Certificate"
    },
    model: {
      value: (_vm.teachingExperience.certification_teyl.val),
      callback: function($$v) {
        _vm.teachingExperience.certification_teyl.val = $$v
      },
      expression: "teachingExperience.certification_teyl.val"
    }
  }, _vm._l((_vm.datas.certification_teyl), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (Object.keys(_vm.datas.certification_other).length) ? _c('li', [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "Other Certificate"
    },
    model: {
      value: (_vm.teachingExperience.certification_other.val),
      callback: function($$v) {
        _vm.teachingExperience.certification_other.val = $$v
      },
      expression: "teachingExperience.certification_other.val"
    }
  }, _vm._l((_vm.datas.certification_other), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  }))], 1) : _vm._e()]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-part"
  }, [_c('h4', [_vm._v("Technical Requirements")]), _vm._v(" "), _c('ul', {
    staticClass: "ch-ul ch-two clearfix"
  }, [_c('li', [_c('el-select', {
    attrs: {
      "placeholder": "Will you teach on either a desktop or laptop?"
    },
    model: {
      value: (_vm.basic_info.desktop_or_laptop.val),
      callback: function($$v) {
        _vm.basic_info.desktop_or_laptop.val = $$v
      },
      expression: "basic_info.desktop_or_laptop.val"
    }
  }, _vm._l((_vm.datas.desktop_or_laptop), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  })), _vm._v(" "), (!_vm.f_state.inp17 && _vm.basic_info.desktop_or_laptop.init) ? _c('p', {
    staticClass: "state_notice"
  }, [_vm._v("This is required.")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.showTechnicalRequirements) ? _c('ul', {
    staticClass: "ch-ul ch-two clearfix"
  }, [_c('li', [_c('el-select', {
    attrs: {
      "placeholder": "In what year did you purchase your Laptop/Desktop?"
    },
    model: {
      value: (_vm.basic_info.computer_purchase_year.val),
      callback: function($$v) {
        _vm.basic_info.computer_purchase_year.val = $$v
      },
      expression: "basic_info.computer_purchase_year.val"
    }
  }, _vm._l((_vm.datas.computer_purchase_year), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  })), _vm._v(" "), (!_vm.f_state.inp18 && _vm.basic_info.computer_purchase_year.init) ? _c('p', {
    staticClass: "state_notice"
  }, [_vm._v("This is required.")]) : _vm._e()], 1), _vm._v(" "), _c('li', [_c('el-select', {
    attrs: {
      "placeholder": "What operating system is your Laptop/Desktop running?"
    },
    model: {
      value: (_vm.basic_info.pc_type.val),
      callback: function($$v) {
        _vm.basic_info.pc_type.val = $$v
      },
      expression: "basic_info.pc_type.val"
    }
  }, _vm._l((_vm.datas.operating_system), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  })), _vm._v(" "), (!_vm.f_state.inp19 && _vm.basic_info.pc_type.init) ? _c('p', {
    staticClass: "state_notice"
  }, [_vm._v("This is required.")]) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), (_vm.showTip) ? _c('p', [_vm._v("You will be required to submit screenshots of your Technical Specifications & Internet Speeds to ensure that your work from home setup is sufficient for teaching in HAWO AA. The instructions on how to accomplish the aforementioned will be provided to you by your recruiter.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "allow_rule clearfix"
  }, [_c('check-box', {
    staticClass: "inline_b",
    attrs: {
      "isCheck": _vm.f_state.checkbox
    },
    on: {
      "checkFn": _vm.reciveMsg
    }
  }), _vm._v(" "), _c('p', [_vm._v("I do not have any criminal records that would show up in a background check which might disqualify me from working with HAWO. ")])], 1), _vm._v(" "), (!_vm.f_state.checkbox && _vm.checkboxInit) ? _c('p', {
    staticClass: "state_notice"
  }, [_vm._v("This is required.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "allow_rule clearfix"
  }, [_c('check-box', {
    staticClass: "inline_b",
    attrs: {
      "isCheck": _vm.f_state.checkbox2
    },
    on: {
      "checkFn": _vm.reciveMsg2
    }
  }), _vm._v(" "), _c('p', [_vm._v("All of the information I provided is factual. Any misinformation could lead to my disqualification.")])], 1), _vm._v(" "), (!_vm.f_state.checkbox2 && _vm.checkboxInit2) ? _c('p', {
    staticClass: "state_notice"
  }, [_vm._v("This is required.")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "submit",
    on: {
      "click": _vm.form_result
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "//www.jobs2careers.com/conversion2.php?p=3857",
      "width": "1",
      "height": "1"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.channelStatus) ? _c('img', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": "https://click.appcast.io/generic-ue8/a7.png?ent=147&e=5728&t=1523371553225",
      "width": "1px",
      "height": "1px"
    }
  }) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('img', {
    staticStyle: {
      "border-style": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "alt": "",
      "src": "//www.googleadservices.com/pagead/conversion/852175291/?label=vQZFCMyAxngQu9OslgM&guid=ON&script=0"
    }
  })])
}]}

/***/ }),
/* 856 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "b_inter_wrap"
  }, [_c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.$route.meta.step
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "book_date"
  }, [_c('h4', [_vm._v("Request a Teaching Practice Guide Time")]), _vm._v(" "), _c('div', {
    staticClass: "choose_timezone"
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Time Zone＊"
    },
    model: {
      value: (_vm.time_zone),
      callback: function($$v) {
        _vm.time_zone = $$v
      },
      expression: "time_zone"
    }
  }, _vm._l((_vm.d_time_zone), function(key, val) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": val,
        "value": key
      }
    })
  })), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "date_detail clearfix"
  }, [_c('div', {
    staticClass: "calendar_wrapper"
  }, [_c('Calendar', {
    attrs: {
      "show": _vm.calendar.show,
      "type": _vm.calendar.items.type,
      "value": _vm.calendar.items.value,
      "x": _vm.calendar.x,
      "y": _vm.calendar.y,
      "begin": _vm.calendar.items.begin,
      "end": _vm.calendar.items.end,
      "sep": _vm.calendar.items.sep,
      "single": _vm.calendar.items.single,
      "rangeValue": _vm.calendar.items.rangeValue,
      "autoclose": _vm.calendar.items.autoclose
    },
    on: {
      "cancel": _vm.dateCancel,
      "ok": _vm.dateOk
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "time_quantum clearfix"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasDate),
      expression: "hasDate"
    }],
    staticClass: "clearfix"
  }, _vm._l((_vm.time_frame), function(time, idx) {
    return _c('li', {
      key: idx,
      class: {
        active: time.isActive
      },
      on: {
        "click": function($event) {
          _vm.frameFn(time.work_hour_value, idx, time.work_start_time)
        }
      }
    }, [_vm._v("\n              " + _vm._s(time.work_start_time) + "-" + _vm._s(time.work_end_time) + "\n            ")])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasDate),
      expression: "!hasDate"
    }],
    staticClass: "no_date"
  }, [_c('p', [_vm._v("No available times that day, please check other dates.")])])])]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" Submit")])]), _vm._v(" "), _c('div', {
    staticClass: "download"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', [_c('ac')], 1)])]), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.$route.query.status == "canceled") ? _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('img', {
    staticStyle: {
      "border-style": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "alt": "",
      "src": "//www.googleadservices.com/pagead/conversion/852175291/?label=5q8jCM_HsngQu9OslgM&guid=ON&script=0"
    }
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The times listed below are presented"), _c('br'), _vm._v(" according to the time zone you selected. ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('img', {
    staticStyle: {
      "border-style": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "alt": "",
      "src": "//www.googleadservices.com/pagead/conversion/852175291/?label=6w1jCNWDxngQu9OslgM&guid=ON&script=0"
    }
  })])
}]}

/***/ }),
/* 857 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy_wrap"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "register_info"
  }, [_c('ul', _vm._l((_vm.datas), function(info) {
    return _c('li', [_c('fold', {
      attrs: {
        "title": info.title,
        "partOne": info.article.partOne,
        "partTwo": info.article.partTwo,
        "partTh": info.article.partTh
      }
    })], 1)
  }))]), _vm._v(" "), _c('div')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p_top"
  }, [_c('h1', [_vm._v("Privacy Policy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p_title"
  }, [_c('h2', [_vm._v("Introduction")]), _vm._v(" "), _c('p', [_vm._v("Welcome to 51Talk American Academy, a web-based service that teaches English to young learners. We respect your privacy and want you to know what information we collect and what we do with that information. This Privacy Policy applies to all information we collect or receive from you. ")])])
}]}

/***/ }),
/* 858 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticClass: "payment"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "payment_item"
  }, [_c('dl', {
    staticClass: "pay_i_tit"
  }, [_c('dt', [_c('check-box', {
    attrs: {
      "isCheck": _vm.isCheckT
    },
    on: {
      "checkFn": _vm.paypalFn
    }
  })], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    class: [{
      'show': _vm.isCheckT
    }, 'address clearfix']
  }, [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Paypal Account (email address)*")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.paypal),
      expression: "paypal",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.paypal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paypal = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.inp1),
      expression: "!inp1"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('p', [_vm._v("PayPal may result in faster payment and is preferred by the company.")])])]), _vm._v(" "), _c('div', {
    staticClass: "payment_item"
  }, [_c('dl', {
    staticClass: "pay_i_tit"
  }, [_c('dt', [_c('check-box', {
    attrs: {
      "isCheck": _vm.isCheck
    },
    on: {
      "checkFn": _vm.changeCheck
    }
  })], 1), _vm._v(" "), _c('dd', {
    staticClass: "direct_banking"
  }, [_vm._v("Direct Banking")])]), _vm._v(" "), _c('div', {
    class: [{
      'show': _vm.isCheck
    }, 'address clearfix']
  }, [_c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Real Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.first_name),
      expression: "basic_info.first_name",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.first_name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp2),
      expression: "!f_state.inp2"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Bank Number/IBAN Number*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.bank_num),
      expression: "basic_info.bank_num",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.bank_num)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.bank_num = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp3),
      expression: "!f_state.inp3"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Bank Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.bank_name),
      expression: "basic_info.bank_name",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.bank_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.bank_name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp4),
      expression: "!f_state.inp4"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Bank Branch*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.bank_branch),
      expression: "basic_info.bank_branch",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.bank_branch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.bank_branch = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp5),
      expression: "!f_state.inp5"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Bank State*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.bank_state),
      expression: "basic_info.bank_state",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.bank_state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.bank_state = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp6),
      expression: "!f_state.inp6"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Bank City*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.bank_city),
      expression: "basic_info.bank_city",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.bank_city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.bank_city = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp7),
      expression: "!f_state.inp7"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("SWIFT Code/Routing Number *")]), _vm._v(" "), _c('div', {
    staticClass: "typecodef"
  }, [_c('el-select', {
    staticClass: "typecode",
    attrs: {
      "placeholder": "select"
    },
    model: {
      value: (_vm.typeCode),
      callback: function($$v) {
        _vm.typeCode = $$v
      },
      expression: "typeCode"
    }
  }, [_c('el-option', {
    key: "0",
    attrs: {
      "label": "SWIFT Code",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "1",
    attrs: {
      "label": "Routing Number",
      "value": "1"
    }
  })], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.typeCodeTxt),
      expression: "typeCodeTxt",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.typeCodeTxt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.typeCodeTxt = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })], 1), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp8),
      expression: "!f_state.inp8"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Bank Address *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.b_info),
      expression: "basic_info.b_info",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.b_info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.b_info = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp9),
      expression: "!f_state.inp9"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Intermediary Bank (Optional)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.inter_bank),
      expression: "basic_info.inter_bank",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.inter_bank)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.inter_bank = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Intermediary Bank's SWIFT Code (Optional)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.inter_code),
      expression: "basic_info.inter_code",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.inter_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.inter_code = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "textarea_input"
  }, [_c('h3', {
    staticClass: "tile_name addtional_info"
  }, [_vm._v("Additional Information (Optional) - For certain countries, banks may required additional information: UK bank account requires Sort Code for all transactions; Canada bank accounts require Transit Number; Mexican bank accounts requires CLABE number.")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.infor),
      expression: "basic_info.infor",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "name": "",
      "id": "",
      "cols": "30",
      "rows": "10",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.basic_info.infor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.infor = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uploadProof"
  }, [_c('file-upload', {
    attrs: {
      "action": _vm.action,
      "before-upload": _vm.b_upload,
      "overtimeFn": _vm.overtimeFn
    },
    on: {
      "complete": _vm.proof_up_s_fn
    }
  }, [_c('uploadImg', {
    attrs: {
      "message": "Upload Valid ID with Picture",
      "imageUrl": _vm.basic_info.valid_id
    }
  })], 1), _vm._v(" "), _vm._m(2)], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "save"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.saveBankFn
    }
  }, [_vm._v("Save")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "payment_tit"
  }, [_vm._v("Please fill out the information for the payment methods for your lesson fee crediting."), _c('br'), _vm._v("If the payment cannot be made to your preferred method, we will make the payment in another method for the month.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dd', {
    staticClass: "paypal"
  }, [_vm._v("Paypal\n        "), _c('span', {
    staticClass: "item_right"
  }, [_vm._v("( preferred )")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notice"
  }, [_c('p', [_vm._v("Passport,Driver's License are acceptable.Please upload scanned copies.The image extension must be .jpg or .png,the size must be lower than 2MB.")])])
}]}

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "information"
  }, [_c('dl', {
    staticClass: "picture"
  }, [_c('dt', [_c('div', {
    on: {
      "click": _vm.toggleShow
    }
  }, [_c('uploadImg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "message": "Upload your profile picture here*",
      "imageUrl": _vm.basic_info.pic
    }
  })], 1), _vm._v(" "), _c('my-upload', {
    attrs: {
      "field": "file",
      "width": 300,
      "height": 300,
      "url": _vm.action,
      "langType": "en"
    },
    on: {
      "crop-success": _vm.cropSuccess,
      "crop-upload-success": _vm.cropUploadSuccess,
      "crop-upload-fail": _vm.cropUploadFail
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp15),
      expression: "!f_state.inp15"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "line_f clearfix"
  }, [_c('div', {
    staticClass: "textInput"
  }, [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("First Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.first_name),
      expression: "basic_info.first_name",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.first_name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp1),
      expression: "!f_state.inp1"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('div', {
    staticClass: "textInput"
  }, [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Last Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.last_name),
      expression: "basic_info.last_name",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.last_name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp2),
      expression: "!f_state.inp2"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('div', {
    staticClass: "textInput",
    staticStyle: {
      "visibility": "hidden"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "personal_info clearfix"
  }, [_c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Birthday*")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "select",
      "filterable": ""
    },
    model: {
      value: (_vm.basic_info.birthday),
      callback: function($$v) {
        _vm.basic_info.birthday = $$v
      },
      expression: "basic_info.birthday"
    }
  }, [_vm._v(_vm._s(_vm.time))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp4),
      expression: "!f_state.inp4"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])], 1), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Zoom account *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.zoom_id),
      expression: "basic_info.zoom_id",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "zoom_id",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.zoom_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.zoom_id = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp6),
      expression: "!f_state.inp6"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Are you legally allowed to work in the US or Canada?")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.basic_info.on_boarding_is_legal),
      callback: function($$v) {
        _vm.basic_info.on_boarding_is_legal = $$v
      },
      expression: "basic_info.on_boarding_is_legal"
    }
  }, _vm._l((_vm.datas.on_boarding_is_legal), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  })), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp5),
      expression: "!f_state.inp5"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "personal_info clearfix"
  }, [_c('div', {
    staticClass: "textInput"
  }, [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Country Code*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.country_code),
      expression: "basic_info.country_code",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.country_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.country_code = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp7),
      expression: "!f_state.inp7"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('div', {
    staticClass: "textInput"
  }, [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v(" Phone Number*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.mobile),
      expression: "basic_info.mobile",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.mobile = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp8),
      expression: "!f_state.inp8"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Your Current Time Zone*")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.basic_info.time_zone),
      callback: function($$v) {
        _vm.basic_info.time_zone = $$v
      },
      expression: "basic_info.time_zone"
    }
  }, _vm._l((_vm.datas.time_zone), function(key, val) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": val,
        "value": key
      }
    })
  })), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp9),
      expression: "!f_state.inp9"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])], 1)]), _vm._v(" "), (_vm.english_proficiency != '') ? _c('div', {
    staticClass: "personal_info clearfix"
  }, [_c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Please select your English proficiency level*")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.english_proficiency),
      callback: function($$v) {
        _vm.english_proficiency = $$v
      },
      expression: "english_proficiency"
    }
  }, _vm._l((_vm.datas.english_proficiency), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    })
  }))], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "personal_info clearfix"
  }, [_c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Computer's Operating Systerm*")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.basic_info.pc_type),
      callback: function($$v) {
        _vm.basic_info.pc_type = $$v
      },
      expression: "basic_info.pc_type"
    }
  }, _vm._l((_vm.datas.operating_system), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "upload_id"
  }, [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Upload Valid ID* (Passport, Driver's License)")]), _vm._v(" "), _c('div', {
    staticClass: "upload_id_in"
  }, [_c('file-upload', {
    attrs: {
      "action": _vm.action,
      "before-upload": _vm.b_upload
    },
    on: {
      "complete": _vm.upload_id
    }
  }, [_c('uploadImg', {
    attrs: {
      "message": "Upload proof",
      "imageUrl": _vm.basic_info.valid_ids_url
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp16),
      expression: "!f_state.inp16"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('p', {
    staticClass: "select_tipes"
  }, [_vm._v("Current location")]), _vm._v(" "), _c('div', {
    staticClass: "last_input"
  }, [_c('div', {
    staticClass: "personal_info clearfix"
  }, [_c('div', [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Country*")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.basic_info.country),
      callback: function($$v) {
        _vm.basic_info.country = $$v
      },
      expression: "basic_info.country"
    }
  }, _vm._l((_vm.datas.country), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  })), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp10),
      expression: "!f_state.inp10"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "state"
  }, [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("State*")]), _vm._v(" "), (_vm.state_change) ? _c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.basic_info.state),
      callback: function($$v) {
        _vm.basic_info.state = $$v
      },
      expression: "basic_info.state"
    }
  }, _vm._l((_vm.datas.state), function(key, val) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": val,
        "value": key
      }
    })
  })) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.state),
      expression: "basic_info.state",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "state_input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.state = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp11),
      expression: "!f_state.inp11"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "zip_code"
  }, [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("City*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.city),
      expression: "basic_info.city",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.city = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp12),
      expression: "!f_state.inp12"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])])]), _vm._v(" "), _c('div', {
    staticClass: "personal_info clearfix"
  }, [_c('div', {
    staticClass: "street_input"
  }, [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v("Street*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.street),
      expression: "basic_info.street",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "street",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.street = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp13),
      expression: "!f_state.inp13"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])]), _vm._v(" "), _c('div', {
    staticClass: "zip_code"
  }, [_c('h3', {
    staticClass: "tile_name"
  }, [_vm._v(" Zip Code*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.basic_info.z_code),
      expression: "basic_info.z_code",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.basic_info.z_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basic_info.z_code = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.f_state.inp14),
      expression: "!f_state.inp14"
    }],
    staticClass: "state_notice"
  }, [_vm._v("This is required.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "interest"
  }, [_c('h3', {
    staticClass: "interests_tit"
  }, [_vm._v("The background and interests below will help our students get to know you better.")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "item_left"
  }, [_vm._v("Background")]), _vm._v(" "), _c('ul', {
    staticClass: "background_list clearfix"
  }, _vm._l((_vm.background), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        'active': item.isActive
      },
      on: {
        "click": function($event) {
          _vm.inActive(index, 'background', 'isActive')
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "item_left"
  }, [_vm._v("Interests")]), _vm._v(" "), _c('ul', {
    staticClass: "background_list clearfix"
  }, _vm._l((_vm.interests), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        'active': item.isActiveIn
      },
      on: {
        "click": function($event) {
          _vm.inActive(index, 'interests', 'isActiveIn')
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }))])]), _vm._v(" "), _c('p', {
    staticClass: "save"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.saveFn
    }
  }, [_vm._v("Save")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dd', [_c('div', {
    staticClass: "picture_decoration"
  }, [_c('p', [_vm._v("Please upload a photo of yourself here. ")]), _vm._v(" "), _c('p', [_vm._v("This photo will be used for your teacher profile page.")]), _vm._v(" "), _c('p', [_vm._v("Your photo should be professional, and have adequate lighting. Don't forget to smile!")]), _vm._v(" "), _c('p', [_vm._v("The photo may be in jpg or png formats, and the size should be 300 x 300.")])]), _vm._v(" "), _c('div', {
    staticClass: "picture_sample"
  }, [_c('div', {
    staticClass: "picture_img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(337),
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Sample profile picture")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('img', {
    staticStyle: {
      "border-style": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "alt": "",
      "src": "//www.googleadservices.com/pagead/conversion/852175291/?label=6jqmCKjEsngQu9OslgM&guid=ON&script=0"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('img', {
    staticStyle: {
      "border-style": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "alt": "",
      "src": "//www.googleadservices.com/pagead/conversion/852175291/?label=h6YZCM7uyngQu9OslgM&guid=ON&script=0"
    }
  })])
}]}

/***/ }),
/* 860 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy_wrap"
  }, [_c('h2', {
    on: {
      "click": _vm.fold
    }
  }, [_vm._v(_vm._s(_vm.title) + "\n    "), _c('span', {
    class: {
      down: !_vm.onOff
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.onOff),
      expression: "onOff"
    }]
  }, [_c('p', [_vm._v(_vm._s(_vm.partOne))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.partTwo))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.partTh))])])])
},staticRenderFns: []}

/***/ }),
/* 861 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 862 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reschedule_wrap"
  }, [_c('div', {
    staticClass: "res_container"
  }, [_c('div', {
    staticClass: "res_head"
  }, [_c('h1', [_vm._v("Reschedule\n\t\t\t\t"), _c('span', {
    on: {
      "click": _vm.close
    }
  })])]), _vm._v(" "), _c('dl', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.no_date),
      expression: "!no_date"
    }],
    staticClass: "timeZone clearfix"
  }, [_c('dt', [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Time Zone"
    },
    model: {
      value: (_vm.time_zone),
      callback: function($$v) {
        _vm.time_zone = $$v
      },
      expression: "time_zone"
    }
  }, _vm._l((_vm.timeZone), function(key, val) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": val,
        "value": key
      }
    })
  }))], 1), _vm._v(" "), _c('dd', [_vm._v("The " + _vm._s(_vm._bookType.upper) + " times listed below are presented "), _c('br'), _vm._v(" according to the time zone you selected")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.no_date),
      expression: "no_date"
    }],
    staticClass: "no_time"
  }, [_c('p', [_vm._v("Currently there are no available times. You may check our schedule availability again tomorrow, or contact your trainer for help.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.no_date),
      expression: "!no_date"
    }],
    staticClass: "choose_time clearfix"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('Calendar', {
    attrs: {
      "show": _vm.calendar.show,
      "type": _vm.calendar.items.type,
      "value": _vm.calendar.items.value,
      "x": _vm.calendar.x,
      "y": _vm.calendar.y,
      "begin": _vm.calendar.items.begin,
      "end": _vm.calendar.items.end,
      "sep": _vm.calendar.items.sep,
      "single": _vm.calendar.items.single,
      "rangeValue": _vm.calendar.items.rangeValue,
      "autoclose": _vm.calendar.items.autoclose
    },
    on: {
      "cancel": _vm.dateCancel,
      "ok": _vm.dateOk
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasDate),
      expression: "hasDate"
    }]
  }, _vm._l((_vm.time_frame), function(time, idx) {
    return _c('li', {
      key: idx,
      class: {
        active: time.isActive, disable: _vm.isTimeDisable(time)
      },
      on: {
        "click": function($event) {
          _vm.frameFn(time.work_hour_value, idx, time.work_start_time, _vm.isTimeDisable(time))
        }
      }
    }, [_vm._v(_vm._s(time.work_start_time) + "-" + _vm._s(time.work_end_time))])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasDate),
      expression: "!hasDate"
    }],
    staticClass: "no_date"
  }, [_c('p', [_vm._v("No available times that day, please check other dates.")])])])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.no_date),
      expression: "!no_date"
    }],
    staticClass: "submit",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('div', {
    staticClass: "shadow_pop",
    style: ({
      height: _vm.window_size.height + 'px',
      width: _vm.window_size.width + 'px'
    })
  })])
},staticRenderFns: []}

/***/ }),
/* 863 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [{
      check: _vm.isCheck
    }, 'input_check_box'],
    on: {
      "click": _vm.inputCheckFn
    }
  })
},staticRenderFns: []}

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "interview_wrapper"
  }, [_c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.$route.meta.step
    }
  }), _vm._v(" "), (_vm.$route.query.status == "Reschedule") ? _c('h1', [_vm._v("\n    Hi " + _vm._s(_vm.full_name) + ","), _c('br'), _vm._v("\n    Thank you for your application to teach with HAWO!"), _c('br'), _vm._v(" We’ve received your information and requested interview time."), _c('br'), _vm._v(" Below, please find the confirmation for your interview, and some further information regarding our interview and demo process.")]) : _vm._e(), _vm._v(" "), (_vm.$route.query.status == "Schedule") ? _c('h1', [_vm._v("Dear " + _vm._s(_vm.full_name) + ",we've assigned an interviewer for you, please click the \"Schedule\" button below to book an appointment with your interviewer.")]) : _vm._e(), _vm._v(" "), (_vm.$route.query.status == "canceled") ? _c('h1', [_vm._v("Dear " + _vm._s(_vm.full_name) + ", you've cancelled your scheduled interview time. You may request a new appointment.")]) : _vm._e(), _vm._v(" "), (_vm.$route.query.status == "rescheduled") ? _c('h1', [_vm._v("Hi " + _vm._s(_vm.full_name) + ", your interview appointment has been rescheduled .")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "schedule"
  }, [_c('h4', [_vm._v("Your Interview Schedule")]), _vm._v(" "), _c('div', {
    staticClass: "schedule_de clearfix"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('ul', [_c('li', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "schedule_de_tit"
  }, [_vm._v("Time Zone：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.time_zone))])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "schedule_de_tit"
  }, [_vm._v("Date & Time：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.interviewer_date))])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "schedule_de_tit"
  }, [_vm._v("Interviewer：")]), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(_vm.interviewer_name))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.interviewer_zoom),
      expression: "interviewer_zoom"
    }]
  }, [_vm._v("Zoom account : " + _vm._s(_vm.interviewer_zoom))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.interviewer_email),
      expression: "interviewer_email"
    }]
  }, [_vm._v("Email : " + _vm._s(_vm.interviewer_email))])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "schedule_de_tit"
  }, [_vm._v("Where：")]), _vm._v(" "), _c('p', [_vm._v("Your interview will be conducted on Zoom.")]), _vm._v(" "), _c('p', {
    staticClass: "interview_click"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.urls.zoomPdfLink,
      "download": "zoom.pdf"
    }
  }, [_vm._v("Click here")]), _vm._v(" "), _c('span', [_vm._v("to download Zoom.")])]), _vm._v(" "), _c('p', {
    staticClass: "interview_click"
  }, [_vm._v("Please check your email inbox or spam folder for further instructions from your recruiter.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Kindly contact your recruiter since you've already rescheduled/cancelled once.",
      "placement": "right",
      "disabled": _vm.canReschedule
    }
  }, [_c('a', {
    staticClass: "style reschedule",
    class: {
      dis: !_vm.canReschedule
    },
    on: {
      "click": _vm.showPop
    }
  }, [_vm._v(_vm._s(_vm.reschedule_inner))])]), _vm._v(" "), (_vm.interviewer_date) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Kindly contact your recruiter since you've already rescheduled/cancelled once.",
      "placement": "right",
      "disabled": _vm.canReschedule
    }
  }, [_c('a', {
    staticClass: "style cancel",
    class: {
      dis: !_vm.canReschedule
    },
    on: {
      "click": _vm.cancel_apo
    }
  }, [_vm._v("Cancel Appointment")])]) : _vm._e(), _vm._v(" "), (_vm.need_help) ? _c('a', {
    staticClass: "need_help",
    attrs: {
      "href": ("mailto:" + _vm.need_help)
    }
  }, [_vm._v("Have questions? Email here")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "preparation"
  }, [_c('h4', [_vm._v("Interview details")]), _vm._v(" "), _c('div', {
    staticClass: "preparation_de"
  }, [_c('p', [_vm._v("Interview (20 minutes): The interview gives us a chance to learn more about you and your teaching experience.")]), _vm._v(" "), _c('p', [_vm._v("Demo class (15 minutes): The demo class gives us a chance to observe your teaching abilities. You should be prepared to teach a lesson to your interviewer, as if he or she is a 5 years old student.")]), _vm._v(" "), _c('p', [_vm._v("If you have any questions regarding your interview or demo, please feel free to contact your interviewer directly via email "), _c('a', {
    attrs: {
      "href": ("mailto:" + _vm.interviewer_email)
    }
  }, [_vm._v(_vm._s(_vm.interviewer_email))]), (_vm.interviewer_zoom) ? [_vm._v(" or Zoom (live: " + _vm._s(_vm.interviewer_zoom) + ")")] : _vm._e(), _vm._v(". ")], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "preparation"
  }, [_c('h4', [_vm._v("Material and Preparations:")]), _vm._v(" "), _c('div', {
    staticClass: "preparation_de"
  }, [_c('p', [_vm._v("Click "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.urls.interviewPdfLink,
      "download": "nademomaterial_20180818.pdf"
    }
  }, [_vm._v("here")]), _vm._v(" to download the lesson material that you’ll be teaching in your demo class. If you cannot access the previous link, copy the following link into your browser: ")]), _vm._v(" "), _c('p', [_vm._v("http:" + _vm._s(_vm.urls.interviewPdfLink))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(769),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reschedule_show),
      expression: "reschedule_show"
    }],
    staticClass: "pop"
  }, [_c('reschedule', {
    attrs: {
      "time-zone": _vm.options,
      "scheduled-time-zone": _vm.time_zone,
      "scheduled-interviewer-date": _vm.interviewer_origin_date,
      "interviewer-id": _vm.interviewer,
      "sureHandler": _vm.confirmOpen
    }
  })], 1), _vm._v(" "), _c('cancel-confirm', {
    ref: "cancelConfirm"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "//www.jobs2careers.com/conversion3.php?p=3857",
      "width": "1",
      "height": "1"
    }
  }), _vm._v(" "), (_vm.$route.query.status == "assigned") ? _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('img', {
    staticStyle: {
      "border-style": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "alt": "",
      "src": "//www.googleadservices.com/pagead/conversion/852175291/?label=dFR5CIzryngQu9OslgM&guid=ON&script=0"
    }
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Demo tips")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("The provided demo material is structured for a typical 25-minute class. You should teach it as if your demo class were to last for 25 minutes, although your interviewer will stop you early.")]), _vm._v(" "), _c('li', [_vm._v("As this interview is for an online teaching position, please be prepared with a clutter-free space, proper lighting,professional attire, and proper positioning in the center of the camera.")]), _vm._v(" "), _c('li', [_vm._v("Your interviewer will have the same lesson material on hand.")]), _vm._v(" "), _c('li', [_vm._v("Remember: you’ll be teaching kids, so be happy, engaging, and excited. Putting on a smile goes a long way! Incorporating helpful body language and gestures into your lesson is key for communicating with students who have little knowledge of English.")]), _vm._v(" "), _c('li', [_vm._v("Have fun! Keeping your lesson entertaining and interesting helps students learn quickly.")])])])
}]}

/***/ }),
/* 865 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "downLoad",
    attrs: {
      "href": "~@img/Zoom_Getting Started with PC and MAC v6.pdf",
      "download": "ZOOM"
    }
  }, [_vm._v("ZOOM")])
},staticRenderFns: []}

/***/ }),
/* 866 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-sa"
  }, [_c('div', {
    staticClass: "sign"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sign_cont"
  }, [_c('div', {
    staticClass: "agreement"
  }, [_c('div', {
    staticClass: "cont_agree"
  }, [_c('img', {
    attrs: {
      "src": _vm.saImgPath,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "annex-link",
    attrs: {
      "href": _vm.annexPath,
      "target": "_blank"
    }
  }, [_vm._v("Annex")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.complete),
      expression: "!complete"
    }],
    staticClass: "checkInput"
  }, [_c('InputCheckbox', {
    attrs: {
      "isCheck": _vm.isCheck
    },
    on: {
      "checkFn": _vm.changeCheck
    }
  }), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.complete && _vm.isCheck),
      expression: "!complete && isCheck"
    }],
    staticClass: "clearfix c_wrap",
    class: [{
      hide: !_vm.isCheck
    }, 'line_f']
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.first_name),
      expression: "first_name",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "First Name＊"
    },
    domProps: {
      "value": (_vm.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.first_name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.full_name),
      expression: "full_name",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "Last Name＊"
    },
    domProps: {
      "value": (_vm.full_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.full_name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Nationality"
    },
    model: {
      value: (_vm.country),
      callback: function($$v) {
        _vm.country = $$v
      },
      expression: "country"
    }
  }, _vm._l((_vm.datas), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "textInput clearfix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.nick_name),
      expression: "nick_name",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "Teacher Name*"
    },
    domProps: {
      "value": (_vm.nick_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nick_name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "detect",
    on: {
      "click": _vm.detectFn
    }
  }, [_vm._v("Detect Availability")]), _vm._v(" "), _c('p', {
    class: [{
      great: _vm.great
    }, 'state_notice']
  }, [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "btn_wrap"
  }, [_c('a', {
    class: {
      'dis': !_vm.canSetSa
    },
    on: {
      "click": _vm.setSa
    }
  }, [_vm._v("I Agree")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.complete),
      expression: "complete"
    }],
    staticClass: "complete"
  }, [_vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.first_name) + " " + _vm._s(_vm.full_name) + " / " + _vm._s(_vm.datas[_vm.country]) + " / " + _vm._s(_vm.nick_name))]), _vm._v(" "), _c('p', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.date))])])])]), _vm._v(" "), _c('div', {
    staticClass: "next_cont"
  }, [_c('a', {
    staticClass: "button",
    class: {
      cancel: !_vm.complete
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("Next")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('span', [_vm._v("Sign the service agreement")]), _vm._v(" "), _c('a', {
    staticClass: "hide",
    attrs: {
      "href": "javascript:;",
      "target": "_blank"
    }
  }, [_vm._v("Service agreement FAQs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "checkCont"
  }, [_vm._v("By clicking here, I indicate that I have read, understood, and accepted the terms "), _c('br'), _vm._v("and conditions of my service agreement with 51Talk EnglishInternational Limited.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "attention"
  }, [_c('i'), _vm._v(" "), _c('p', [_c('b'), _vm._v("Teacher Naming Standards "), _c('br'), _vm._v("·Must be unique and not yet used by other teachers in the system.\n              "), _c('br'), _vm._v("·Must consist of two full names, not initials (i.e. Aaron James). "), _c('br'), _vm._v("·May contain your original name or a name that sounds like it but the second name must be an alias."), _c('br'), _vm._v("·Must not sound funny or awkward (i.e. Superman, Bubble Tea)."), _c('br'), _vm._v("·Videos, introductions, and Skype accounts must use the same teacher name.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('span'), _vm._v("Agreed")])
}]}

/***/ }),
/* 867 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "interview_wrapper"
  }, [_c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.$route.meta.step
    }
  }), _vm._v(" "), (_vm.$route.query.status !== "canceled" && _vm.$route.query.status !== "rescheduled") ? _c('h1', [_vm._v("\n      Hi " + _vm._s(_vm.full_name) + ", "), _c('br'), _vm._v(" Thank you for attending the Orientation session, and welcome to the HAWO Group Class (GC) training program!"), _c('br'), _vm._v(" Please see your Teaching Practice Session schedule below:"), _c('br'), _vm._v(" Take note that you must finish modules 1-3 before your scheduled Teaching Practice Session.\n    ")]) : _vm._e(), _vm._v(" "), (_vm.$route.query.status == "rescheduled") ? _c('h1', [_vm._v("Hi " + _vm._s(_vm.full_name) + ", your teaching practice guide appointment has been rescheduled.")]) : _vm._e(), _vm._v(" "), (_vm.$route.query.status == "canceled") ? _c('h1', [_vm._v("Dear " + _vm._s(_vm.full_name) + ", you've cancelled your scheduled teaching practice guide time. You may request a new appointment. ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "schedule"
  }, [_c('h4', [_vm._v("Your scheduled Teaching Practice Session time")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "date_select"
  }), _vm._v(" "), _c('div', {
    staticClass: "schedule_de clearfix"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('ul', [_c('li', {
    staticClass: "clearfix"
  }, [_c('span', [_vm._v("Time Zone：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.appointment.timezone))])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('span', [_vm._v("Date & Time：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.date_time))])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Kindly contact your recruiter since you've already rescheduled/cancelled once.",
      "placement": "right",
      "disabled": _vm.canReschedule
    }
  }, [_c('a', {
    staticClass: "style reschedule",
    class: {
      dis: !_vm.canReschedule
    },
    on: {
      "click": _vm.showPop
    }
  }, [_vm._v(_vm._s(_vm.$route.query.status == "canceled" ? 'Schedule' : 'Reschedule'))])]), _vm._v(" "), (_vm.date_time) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Kindly contact your recruiter since you've already rescheduled/cancelled once.",
      "placement": "right",
      "disabled": _vm.canReschedule
    }
  }, [_c('a', {
    staticClass: "style cancel",
    class: {
      dis: !_vm.canReschedule
    },
    on: {
      "click": _vm.cancel_apo
    }
  }, [_vm._v("Cancel Appointment")])]) : _vm._e(), _vm._v(" "), (_vm.need_help) ? _c('a', {
    staticClass: "need_help",
    attrs: {
      "href": ("mailto:" + _vm.need_help)
    }
  }, [_vm._v("Have questions? Email here")]) : _vm._e()], 1)]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "session session-s"
  }, [_c('h4', [_vm._v("Training Modules")]), _vm._v(" "), _c('div', {
    staticClass: "preparation_de no_bg"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": _vm.urls.trainingModulesLink,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.urls.trainingModulesLink))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reschedule_show),
      expression: "reschedule_show"
    }],
    staticClass: "pop"
  }, [_c('reschedule', {
    attrs: {
      "scheduled-time-zone": _vm.appointment.timezone_key,
      "scheduled-start-time": _vm.appointment.start_time,
      "scheduled-end-time": _vm.appointment.end_time,
      "time-zone": _vm.options,
      "book-type": _vm.bookType,
      "sureHandler": _vm.confirmOpen,
      "queryStatus": _vm.$route.query.status
    },
    on: {
      "getTutorInfo": _vm.getTutorInfo
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "download"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', [_c('ac')], 1)])]), _vm._v(" "), _c('cancel-confirm', {
    ref: "cancelConfirm"
  }), _vm._v(" "), (_vm.$route.query.status == "assigned") ? _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('img', {
    staticStyle: {
      "border-style": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "alt": "",
      "src": "//www.googleadservices.com/pagead/conversion/852175291/?label=jUeFCKHuyngQu9OslgM&guid=ON&script=0"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.$route.query.status == "canceled") ? _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('img', {
    staticStyle: {
      "border-style": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "alt": "",
      "src": "//www.googleadservices.com/pagead/conversion/852175291/?label=5q8jCM_HsngQu9OslgM&guid=ON&script=0"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.$route.query.status == "rescheduled") ? _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('img', {
    staticStyle: {
      "border-style": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "alt": "",
      "src": "//www.googleadservices.com/pagead/conversion/852175291/?label=iMvTCMvGsngQu9OslgM&guid=ON&script=0"
    }
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "clearfix"
  }, [_c('span', [_vm._v("Where：")]), _vm._v(" "), _c('p', [_vm._v("Your teaching practice session will be conducted on AC."), _c('br'), _vm._v(" Please contact your recruiter for your AC login credentials.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tip"
  }, [_vm._v("\n        Failure to attend your scheduled teaching practice session may disqualify you for the position."), _c('br'), _vm._v(" Please contact your recruiter if you need any assistance, or if you have any questions.\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "session"
  }, [_c('h4', [_vm._v("Live Training Session")]), _vm._v(" "), _c('div', {
    staticClass: "preparation_de"
  }, [_c('p', [_vm._v("Please take note of these further instructions for the session:")]), _vm._v(" "), _c('div', [_c('ul', [_c('li', [_vm._v("Please add trainer as a contact on Zoom 30 minutes before the training and send them your updated speed test result link as a confirmation for "), _c('br'), _vm._v("the training session.")]), _vm._v(" "), _c('li', [_vm._v("Please have your HEADSET set up for the session. You need a corded headset (USB plugged) with noise cancellation feature. ")]), _vm._v(" "), _c('li', [_vm._v("Please have the right background set up. You should have a solid light colored background with adequate lighting and no distractions.")]), _vm._v(" "), _c('li', [_vm._v("You must be using a laptop or PC (Windows or Mac) – Do not use a mobile or tablet.")])])])])])
}]}

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cgs"
  }, [_c('div', {
    staticClass: "shadow"
  }), _vm._v(" "), _c('div', {
    staticClass: "cgs_wrap"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(770),
      "alt": "logo"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Congratulations!")]), _vm._v(" "), _c('p', {
    staticClass: "words"
  }, [_vm._v("Your account has been created successfully. Let's get you \nstarted in your application to become a HAWO teacher.")]), _vm._v(" "), _c('a', {
    staticClass: "started",
    on: {
      "click": _vm.started
    }
  }, [_vm._v("Let's get started")]), _vm._v(" "), _c('p', {
    staticClass: "timeout"
  }, [_vm._v(_vm._s(_vm.time_out))])])])
},staticRenderFns: []}

/***/ }),
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[446]);


// WEBPACK FOOTER //
// static/js/app.5326af0765f098179640.js